import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: any;
};

export type AcceptJoinRequestInput = {
  joinRequestId: Scalars['String'];
  roleId: Scalars['String'];
};

export type AcmCaseStudyFileResponse = {
  __typename?: 'AcmCaseStudyFileResponse';
  _id: Scalars['String'];
  accessibleTo: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  localeCode: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  size?: Maybe<Scalars['Float']>;
  thumbnailPath?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AcmCaseStudyFilesResponse = {
  __typename?: 'AcmCaseStudyFilesResponse';
  docs: Array<AcmCaseStudyFileResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type AcmCompetenciesResponse = {
  __typename?: 'AcmCompetenciesResponse';
  docs: Array<AcmCompetencyResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type AcmCompetencyResponse = {
  __typename?: 'AcmCompetencyResponse';
  _id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type AcmProjectCompetenciesResponse = {
  __typename?: 'AcmProjectCompetenciesResponse';
  docs: Array<AcmProjectCompetencyResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type AcmProjectCompetencyExerciseResponse = {
  __typename?: 'AcmProjectCompetencyExerciseResponse';
  _id: Scalars['String'];
  caseStudyId: Scalars['String'];
  kpiIds?: Maybe<Array<Scalars['String']>>;
  weightPercentage: Scalars['Float'];
};

export type AcmProjectCompetencyResponse = {
  __typename?: 'AcmProjectCompetencyResponse';
  _id: Scalars['String'];
  competencies?: Maybe<Array<AcmCompetencyResponse>>;
  createdAt: Scalars['DateTime'];
  definition?: Maybe<Scalars['String']>;
  exercises?: Maybe<Array<AcmProjectCompetencyExerciseResponse>>;
  name?: Maybe<Scalars['String']>;
};

export type AcmProjectParticipantAssessorResponse = {
  __typename?: 'AcmProjectParticipantAssessorResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AcmProjectParticipantResponse = {
  __typename?: 'AcmProjectParticipantResponse';
  _id: Scalars['String'];
  assessors?: Maybe<Array<AcmProjectParticipantAssessorResponse>>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AcmProjectResponse = {
  __typename?: 'AcmProjectResponse';
  _id: Scalars['String'];
  companyImage?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  numOfDays: Scalars['Float'];
  purpose: Scalars['String'];
  scoringScale?: Maybe<Array<AcmProjectScoringScaleResponse>>;
};

export type AcmProjectScoringScaleResponse = {
  __typename?: 'AcmProjectScoringScaleResponse';
  color: Scalars['String'];
  from: Scalars['Float'];
  name: Scalars['String'];
  to: Scalars['Float'];
};

export type AcmProjectsResponse = {
  __typename?: 'AcmProjectsResponse';
  docs: Array<AcmProjectResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type AddUnitsInput = {
  organizationId: Scalars['String'];
  units: Scalars['Float'];
};

export type AdsAssessmentResponse = {
  __typename?: 'AdsAssessmentResponse';
  _id: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AdsAssessmentsResponse = {
  __typename?: 'AdsAssessmentsResponse';
  docs: Array<AdsAssessmentResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type AnswerCompetencyItemInput = {
  competencyId: Scalars['String'];
  competencyItemId: Scalars['String'];
  responseId: Scalars['String'];
};

export type AnswerCompetencyItemResponse = {
  __typename?: 'AnswerCompetencyItemResponse';
  competencyItemId: Scalars['String'];
  responseId: Scalars['String'];
  subItem?: Maybe<SessionSubItemResponse>;
};

export type AnswerStdSessionDemographicInput = {
  answerId?: InputMaybe<Scalars['String']>;
  answerIds?: InputMaybe<Array<Scalars['String']>>;
  answerText?: InputMaybe<Scalars['String']>;
  demographicId: Scalars['String'];
};

export type AnswerStdSessionDemographicResponse = {
  __typename?: 'AnswerStdSessionDemographicResponse';
  answerId?: Maybe<Scalars['String']>;
  answerIds?: Maybe<Array<Scalars['String']>>;
  answerText?: Maybe<Scalars['String']>;
  demographicId: Scalars['String'];
};

export type AnswerStdSessionOpenEndedQuestionInput = {
  openEndedResponse?: InputMaybe<Scalars['String']>;
  stdPageItemId: Scalars['String'];
};

export type AnswerStdSessionOpenEndedQuestionResponse = {
  __typename?: 'AnswerStdSessionOpenEndedQuestionResponse';
  openEndedResponse?: Maybe<Scalars['String']>;
  stdPageItemId: Scalars['String'];
};

export type AnswerStdSessionPageItemQuestionInput = {
  answerId: Scalars['String'];
  questionId: Scalars['String'];
  stdPageItemId: Scalars['String'];
};

export type AnswerStdSessionPageItemQuestionResponse = {
  __typename?: 'AnswerStdSessionPageItemQuestionResponse';
  answerId?: Maybe<Scalars['String']>;
  questionId: Scalars['String'];
  stdPageItemId: Scalars['String'];
};

export type AnswerSubItemInput = {
  competencyItemId: Scalars['String'];
  responseId: Scalars['String'];
  subItemId: Scalars['String'];
};

export type AnswerSubItemResponse = {
  __typename?: 'AnswerSubItemResponse';
  responseId: Scalars['String'];
  subItemId: Scalars['String'];
};

export type AssignedAssessmentResponse = {
  __typename?: 'AssignedAssessmentResponse';
  _id: Scalars['String'];
  assessmentLink?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  productImage?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
};

export type CaseStudiesResponse = {
  __typename?: 'CaseStudiesResponse';
  docs: Array<CaseStudyResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type CaseStudyKpiResponse = {
  __typename?: 'CaseStudyKpiResponse';
  _id: Scalars['String'];
  kpi: KpiResponse;
  order: Scalars['String'];
};

export type CaseStudyResponse = {
  __typename?: 'CaseStudyResponse';
  _id: Scalars['String'];
  competencyIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  maxCandidates?: Maybe<Scalars['Float']>;
  minCandidates?: Maybe<Scalars['Float']>;
  performingDuration?: Maybe<Scalars['String']>;
  preparationDuration?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
};

export type CheckStdSessionResponse = {
  __typename?: 'CheckStdSessionResponse';
  allowBack?: Maybe<Scalars['Boolean']>;
  demographics?: Maybe<Array<StdSessionDemographicResponse>>;
  infoPageData?: Maybe<StdSessionInfoPageDataResponse>;
  mustAnswerAll?: Maybe<Scalars['Boolean']>;
  organizationName: Scalars['String'];
  responsesLayout: Scalars['String'];
  selectLocaleData?: Maybe<StdSessionSelectLocaleDataResponse>;
  selectedLocaleCode?: Maybe<Scalars['String']>;
  stdPageData?: Maybe<StdSessionPageDataResponse>;
  surveyHorizontalImage?: Maybe<Scalars['String']>;
  surveyName?: Maybe<Scalars['String']>;
  surveyPrimaryColor?: Maybe<Scalars['String']>;
  surveyVerticalImage?: Maybe<Scalars['String']>;
  toRender: Scalars['String'];
};

export type CheckSurveySessionResponse = {
  __typename?: 'CheckSurveySessionResponse';
  competencyData?: Maybe<SurveySessionCompetencyDataResponse>;
  infoPageData?: Maybe<SurveySessionInfoPageDataResponse>;
  isSelfRater?: Maybe<Scalars['Boolean']>;
  organizationName: Scalars['String'];
  responsesLayout: Scalars['String'];
  selectLocaleData?: Maybe<SurveySessionSelectLocaleDataResponse>;
  selectedLocaleCode?: Maybe<Scalars['String']>;
  selfRaterName: Scalars['String'];
  surveyHorizontalImage?: Maybe<Scalars['String']>;
  surveyPrimaryColor?: Maybe<Scalars['String']>;
  surveyVerticalImage?: Maybe<Scalars['String']>;
  toRender: Scalars['String'];
};

export type CloneCompetencyInput = {
  _id?: InputMaybe<Scalars['String']>;
  order: Scalars['String'];
  originalCompetencyId: Scalars['String'];
};

export type CommentCompetencyInput = {
  comment: Scalars['String'];
  competencyId: Scalars['String'];
};

export type CommentCompetencyResponse = {
  __typename?: 'CommentCompetencyResponse';
  comment: Scalars['String'];
  competencyId: Scalars['String'];
};

export type CompetenciesArgs = {
  localeCodes: Array<Scalars['String']>;
};

export type Competency360ReportResponse = {
  __typename?: 'Competency360ReportResponse';
  col: Scalars['Float'];
  definition?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  narratives: Array<Narrative360ReportResponse>;
  participantsSkillAndSignificant: Array<ParticipantsSkillAndSignificant>;
  row: Scalars['Float'];
  selfRaterSignificantMean: Scalars['Float'];
  selfRaterSkillMean: Scalars['Float'];
  totalSelfRaterAgreement?: Maybe<Scalars['String']>;
  totalSelfRaterSignificantMean: Scalars['Float'];
  totalSelfRaterSkillMean: Scalars['Float'];
};

export type CompetencyComments360ReportResponse = {
  __typename?: 'CompetencyComments360ReportResponse';
  name: Scalars['String'];
  participants?: Maybe<Array<ParticipantsComments>>;
};

export type CompetencyGroupResponse = {
  __typename?: 'CompetencyGroupResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CompetencyGroupWithChildrenResponse = {
  __typename?: 'CompetencyGroupWithChildrenResponse';
  _id: Scalars['String'];
  competencies?: Maybe<Array<CompetencyResponse>>;
  competenciesCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CompetencyGroupsResponse = {
  __typename?: 'CompetencyGroupsResponse';
  docs: Array<CompetencyGroupWithChildrenResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type CompetencyItemResponse = {
  __typename?: 'CompetencyItemResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  measure?: Maybe<Scalars['String']>;
  order: Scalars['String'];
  questionTitle?: Maybe<Array<LocaleResponse>>;
  responseStatements?: Maybe<Array<CompetencyItemResponseStatement>>;
  responses?: Maybe<Array<CompetencyItemResponseResponse>>;
  responsesLogic?: Maybe<Array<CompetencyItemResponseLogicResponse>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompetencyItemResponseLogicResponse = {
  __typename?: 'CompetencyItemResponseLogicResponse';
  _id: Scalars['String'];
  data?: Maybe<CompetencySubItemResponse>;
  responseId: Scalars['String'];
  type: Scalars['String'];
};

export type CompetencyItemResponseResponse = {
  __typename?: 'CompetencyItemResponseResponse';
  _id: Scalars['String'];
  score: Scalars['Float'];
  text?: Maybe<Array<LocaleResponse>>;
};

export type CompetencyItemResponseStatement = {
  __typename?: 'CompetencyItemResponseStatement';
  _id: Scalars['String'];
  responseIds: Array<Scalars['String']>;
  text?: Maybe<Array<LocaleResponse>>;
  type: Scalars['String'];
};

export type CompetencyNarrativeResponse = {
  __typename?: 'CompetencyNarrativeResponse';
  text?: Maybe<Array<LocaleResponse>>;
  type: Scalars['String'];
};

export type CompetencyResponse = {
  __typename?: 'CompetencyResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  definition?: Maybe<Array<LocaleResponse>>;
  name?: Maybe<Array<LocaleResponse>>;
  narratives?: Maybe<Array<CompetencyNarrativeResponse>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompetencySubItemResponse = {
  __typename?: 'CompetencySubItemResponse';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  questionDefinition?: Maybe<Array<LocaleResponse>>;
  questionTitle?: Maybe<Array<LocaleResponse>>;
  responses?: Maybe<Array<CompetencySubItemResponseResponse>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompetencySubItemResponseResponse = {
  __typename?: 'CompetencySubItemResponseResponse';
  _id: Scalars['String'];
  score: Scalars['Float'];
  text?: Maybe<Array<LocaleResponse>>;
};

export type CompetencyWithItemsResponse = {
  __typename?: 'CompetencyWithItemsResponse';
  _id: Scalars['String'];
  competenciesItems?: Maybe<Array<CompetencyItemResponse>>;
  createdAt: Scalars['DateTime'];
  definition?: Maybe<Array<LocaleResponse>>;
  name?: Maybe<Array<LocaleResponse>>;
  narratives?: Maybe<Array<CompetencyNarrativeResponse>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CreateAcmCaseStudyFileInput = {
  accessibleTo: Array<Scalars['String']>;
  localeCode: Scalars['String'];
};

export type CreateAcmCompetencyInput = {
  name: Scalars['String'];
};

export type CreateAcmProjectCompetencyInput = {
  definition?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateAcmProjectInput = {
  companyName: Scalars['String'];
  name: Scalars['String'];
  numOfDays: Scalars['Float'];
  purpose: Scalars['String'];
  scoringScale?: InputMaybe<Array<CreateAcmProjectScoringScaleInput>>;
};

export type CreateAcmProjectParticipantInput = {
  assessorEmails?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreateAcmProjectParticipantsInput = {
  participants: Array<CreateAcmProjectParticipantInput>;
};

export type CreateAcmProjectScoringScaleInput = {
  color: Scalars['String'];
  from: Scalars['Float'];
  name: Scalars['String'];
  to: Scalars['Float'];
};

export type CreateCaseStudyInput = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  maxCandidates?: InputMaybe<Scalars['Float']>;
  minCandidates?: InputMaybe<Scalars['Float']>;
  performingDuration?: InputMaybe<Scalars['String']>;
  preparationDuration?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type CreateCompetencyGroupInput = {
  defaultLocaleCode: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};

export type CreateCompetencyItemInput = {
  competencyId: Scalars['String'];
  localeCode: Scalars['String'];
  measure: Scalars['String'];
  order: Scalars['String'];
  questionTitle: Scalars['String'];
  responseStatements?: InputMaybe<Array<CreateCompetencyItemResponseStatementInput>>;
  responses: Array<CreateCompetencyItemResponseInput>;
  responsesLogic?: InputMaybe<Array<CreateCompetencyItemResponseLogicInput>>;
};

export type CreateCompetencyItemResponseInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type CreateCompetencyItemResponseLogicInput = {
  responseId: Scalars['String'];
  type: Scalars['String'];
};

export type CreateCompetencyItemResponseStatementInput = {
  responseIds: Array<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateDemographicInput = {
  order: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  shortAnswerValidation: Scalars['String'];
  type: Scalars['String'];
};

export type CreateDemographicTemplateInput = {
  defaultLocaleCode: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateKpiInput = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  localeCodes: Array<Scalars['String']>;
  negativeStatement: Array<LocaleEntryInput>;
  notes?: InputMaybe<Array<CreateKpiNoteInput>>;
  positiveStatement?: InputMaybe<Array<LocaleEntryInput>>;
  score1Narratives?: InputMaybe<Array<CreateKpiScoreNarrativeInput>>;
  score1NarrativesStatus?: InputMaybe<Scalars['String']>;
  score2Narratives?: InputMaybe<Array<CreateKpiScoreNarrativeInput>>;
  score2NarrativesStatus?: InputMaybe<Scalars['String']>;
  score3Narratives?: InputMaybe<Array<CreateKpiScoreNarrativeInput>>;
  score3NarrativesStatus?: InputMaybe<Scalars['String']>;
  score4Narratives?: InputMaybe<Array<CreateKpiScoreNarrativeInput>>;
  score4NarrativesStatus?: InputMaybe<Scalars['String']>;
  score5Narratives?: InputMaybe<Array<CreateKpiScoreNarrativeInput>>;
  score5NarrativesStatus?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateKpiNoteInput = {
  text: Array<LocaleEntryInput>;
};

export type CreateKpiScoreNarrativeInput = {
  text?: InputMaybe<Array<LocaleEntryInput>>;
};

export type CreateMasterProductAssessmentInput = {
  adsAssessmentName: Scalars['String'];
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type CreateMasterProductInput = {
  assessments: Array<CreateMasterProductAssessmentInput>;
  description: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  units: Scalars['Float'];
};

export type CreateOrganizationInput = {
  domain: Scalars['String'];
  jobTitle: Scalars['String'];
  name: Scalars['String'];
};

export type CreateProductAssessmentInput = {
  adsAssessmentName: Scalars['String'];
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type CreateProductInput = {
  assessments: Array<CreateProductAssessmentInput>;
  description: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreateProductNarrativeInput = {
  content?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  indicatorId?: InputMaybe<Scalars['String']>;
  langCode?: InputMaybe<Scalars['String']>;
  order: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CreateProjectInput = {
  color: Scalars['String'];
  name: Scalars['String'];
};

export type CreateSelfRaterParticipantInput = {
  email: Scalars['String'];
  participantTypeId: Scalars['String'];
};

export type CreateSelfRaterParticipantsInput = {
  participants: Array<CreateSelfRaterParticipantInput>;
};

export type CreateStandardSurveyPageInput = {
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
};

export type CreateStdPageItemInput = {
  order: Scalars['String'];
  type: Scalars['String'];
};

export type CreateSurveyCompetencyItemInput = {
  localeCode: Scalars['String'];
  measure: Scalars['String'];
  order: Scalars['String'];
  questionTitle: Scalars['String'];
  responseStatements?: InputMaybe<Array<CreateSurveyCompetencyItemResponseStatementInput>>;
  responses: Array<CreateSurveyCompetencyItemResponseInput>;
  responsesLogic?: InputMaybe<Array<CreateSurveyCompetencyItemResponseLogicInput>>;
  surveyCompetencyId: Scalars['String'];
};

export type CreateSurveyCompetencyItemResponseInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type CreateSurveyCompetencyItemResponseLogicInput = {
  responseId: Scalars['String'];
  type: Scalars['String'];
};

export type CreateSurveyCompetencyItemResponseStatementInput = {
  responseIds: Array<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateSurveyInput = {
  defaultLocaleCode: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  masterSurveyUnits?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  responsesLayout?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DeleteAcmProjectParticipantsResponse = {
  __typename?: 'DeleteAcmProjectParticipantsResponse';
  deletedParticipants: Array<AcmProjectParticipantResponse>;
  updatedParticipants?: Maybe<Array<AcmProjectParticipantResponse>>;
};

export type DeleteCompetencyItemInput = {
  _id: Scalars['String'];
  competencyId: Scalars['String'];
};

export type DeleteMemberOrInvitationInput = {
  _id: Scalars['String'];
  type: Scalars['String'];
};

export type DeleteMembersOrInvitationsInput = {
  entries: Array<DeleteMemberOrInvitationInput>;
};

export type DeleteSurveyCompetencyItemInput = {
  _id: Scalars['String'];
  surveyCompetencyId: Scalars['String'];
};

export type DemographicAnswerResponse = {
  __typename?: 'DemographicAnswerResponse';
  _id?: Maybe<Scalars['String']>;
  text?: Maybe<Array<LocaleResponse>>;
};

export type DemographicResponse = {
  __typename?: 'DemographicResponse';
  _id: Scalars['String'];
  answers?: Maybe<Array<DemographicAnswerResponse>>;
  createdAt: Scalars['DateTime'];
  customErrorMessage?: Maybe<Array<LocaleResponse>>;
  label?: Maybe<Array<LocaleResponse>>;
  multipleChoicesValidationType?: Maybe<Scalars['String']>;
  multipleChoicesValidationValue?: Maybe<Scalars['Float']>;
  order: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  shortAnswerValidation?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DemographicTemplateResponse = {
  __typename?: 'DemographicTemplateResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type DemographicTemplateWithCountResponse = {
  __typename?: 'DemographicTemplateWithCountResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  demographicsCount: Scalars['Float'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type DemographicTemplatesWithCountResponse = {
  __typename?: 'DemographicTemplatesWithCountResponse';
  docs: Array<DemographicTemplateWithCountResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type DynamicReport360 = {
  __typename?: 'DynamicReport360';
  actualRatersDescription: Scalars['String'];
  additionalComments?: Maybe<Array<ParticipantTypeInsights>>;
  areasForDevelopment?: Maybe<Array<ParticipantTypeInsights>>;
  competencies: Array<Competency360ReportResponse>;
  competenciesComments?: Maybe<Array<CompetencyComments360ReportResponse>>;
  completed: Scalars['Float'];
  completedPercentage: Scalars['Float'];
  endDate: Scalars['DateTime'];
  isSelfRaterCompleted: Scalars['Boolean'];
  noCompleted: Scalars['Float'];
  participantsStatusAsGroup: Array<ParticipantsTypeGroup>;
  projectName: Scalars['String'];
  selfRaterName: Scalars['String'];
  skillSignificantGraph: Array<Array<Array<Scalars['String']>>>;
  startDate: Scalars['DateTime'];
  strengths?: Maybe<Array<ParticipantTypeInsights>>;
  summary: Scalars['String'];
  surveyDuration: Scalars['String'];
};

export type ExportStdQuestionsAndAnswersCsvResponse = {
  __typename?: 'ExportStdQuestionsAndAnswersCsvResponse';
  stdAnswersCsv: Scalars['String'];
  stdQuestionsCsv: Scalars['String'];
};

export type ForgetPasswordInput = {
  email: Scalars['String'];
};

export type ForgetPasswordResponse = {
  __typename?: 'ForgetPasswordResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type GenerateStdProjectTokensInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type HeatmapMatrixRowDrillDownResponse = {
  __typename?: 'HeatmapMatrixRowDrillDownResponse';
  key: Scalars['String'];
  markedAs: Scalars['String'];
  value: Scalars['Float'];
};

export type HeatmapMatrixRowResponse = {
  __typename?: 'HeatmapMatrixRowResponse';
  dimensionId: Scalars['String'];
  dimensionName: Scalars['String'];
  drillDowns: Array<HeatmapMatrixRowDrillDownResponse>;
};

export type InvitationResponse = {
  __typename?: 'InvitationResponse';
  _id: Scalars['String'];
  email: Scalars['String'];
  invitationCodeExpires: Scalars['DateTime'];
  roleId: Scalars['String'];
  roleName: Scalars['String'];
};

export type InviteUserInput = {
  email: Scalars['String'];
  roleId: Scalars['String'];
};

export type JoinRequestResponse = {
  __typename?: 'JoinRequestResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  organizationId: Scalars['String'];
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  userImage?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type JoinRequestsResponse = {
  __typename?: 'JoinRequestsResponse';
  docs: Array<JoinRequestResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type KpiNoteResponse = {
  __typename?: 'KpiNoteResponse';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  text: Array<LocaleEntryResponse>;
};

export type KpiResponse = {
  __typename?: 'KpiResponse';
  _id: Scalars['String'];
  competencyIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  localeCodes: Array<Scalars['String']>;
  negativeStatement: Array<LocaleEntryResponse>;
  notes?: Maybe<Array<KpiNoteResponse>>;
  positiveStatement?: Maybe<Array<LocaleEntryResponse>>;
  score1Narratives?: Maybe<Array<KpiScoreNarrativeResponse>>;
  score1NarrativesStatus?: Maybe<Scalars['String']>;
  score2Narratives?: Maybe<Array<KpiScoreNarrativeResponse>>;
  score2NarrativesStatus?: Maybe<Scalars['String']>;
  score3Narratives?: Maybe<Array<KpiScoreNarrativeResponse>>;
  score3NarrativesStatus?: Maybe<Scalars['String']>;
  score4Narratives?: Maybe<Array<KpiScoreNarrativeResponse>>;
  score4NarrativesStatus?: Maybe<Scalars['String']>;
  score5Narratives?: Maybe<Array<KpiScoreNarrativeResponse>>;
  score5NarrativesStatus?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type KpiScoreNarrativeResponse = {
  __typename?: 'KpiScoreNarrativeResponse';
  _id: Scalars['String'];
  text?: Maybe<Array<LocaleEntryResponse>>;
};

export type KpisResponse = {
  __typename?: 'KpisResponse';
  docs: Array<KpiResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type LanguageResponse = {
  __typename?: 'LanguageResponse';
  code: Scalars['String'];
  dir: Scalars['String'];
  name: Scalars['String'];
  nativeName: Scalars['String'];
};

export type LinkGeneratorInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  productIds: Array<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LinkKpisWithCaseStudyAndCompetencyInput = {
  competencyId: Scalars['String'];
  linkedKpis: Array<LinkedKpiInput>;
};

export type LinkedKpiInput = {
  kpiId: Scalars['String'];
  order: Scalars['String'];
};

export type LocaleEntryInput = {
  localeCode: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
};

export type LocaleEntryResponse = {
  __typename?: 'LocaleEntryResponse';
  localeCode: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type LocaleResponse = {
  __typename?: 'LocaleResponse';
  localeCode: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type MasterProductAssessmentResponse = {
  __typename?: 'MasterProductAssessmentResponse';
  _id: Scalars['String'];
  adsAssessmentName?: Maybe<Scalars['String']>;
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type MasterProductResponse = {
  __typename?: 'MasterProductResponse';
  _id: Scalars['String'];
  assessments?: Maybe<Array<MasterProductAssessmentResponse>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  units: Scalars['Float'];
};

export type MasterProductWithNarrativesCountResponse = {
  __typename?: 'MasterProductWithNarrativesCountResponse';
  _id: Scalars['String'];
  assessments?: Maybe<Array<MasterProductAssessmentResponse>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  narrativesCount: Scalars['Float'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  units: Scalars['Float'];
};

export type MasterProductsResponse = {
  __typename?: 'MasterProductsResponse';
  docs: Array<MasterProductResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type MembersAndInvitationsResponse = {
  __typename?: 'MembersAndInvitationsResponse';
  invitations: Array<InvitationResponse>;
  members: Array<OrganizationMemberResponse>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptJoinRequest: SuccessResponse;
  addUnits: OrganizationResponse;
  answerCompetencyItem: AnswerCompetencyItemResponse;
  answerStdSessionDemographic: AnswerStdSessionDemographicResponse;
  answerStdSessionOpenEndedQuestion: AnswerStdSessionOpenEndedQuestionResponse;
  answerStdSessionPageItemQuestion: AnswerStdSessionPageItemQuestionResponse;
  answerSubItem: AnswerSubItemResponse;
  approveStdSessionPolicy: SuccessResponse;
  approveSurveyPolicy: SuccessResponse;
  cancelJoiningRequest: JoinRequestResponse;
  cloneCompetenciesToSurvey: SuccessResponse;
  commentCompetency: CommentCompetencyResponse;
  createAcmCompetency: AcmCompetencyResponse;
  createAcmProject: AcmProjectResponse;
  createAcmProjectCompetency: AcmProjectCompetencyResponse;
  createAcmProjectParticipants: Array<AcmProjectParticipantResponse>;
  createCaseStudy: CaseStudyResponse;
  createCaseStudyFile: AcmCaseStudyFileResponse;
  createCompetency: CompetencyResponse;
  createCompetencyGroup: CompetencyGroupWithChildrenResponse;
  createCompetencyItem: CompetencyItemResponse;
  createDemographic: DemographicResponse;
  createDemographicTemplate: DemographicTemplateResponse;
  createKpi: KpiResponse;
  createMasterProduct: MasterProductResponse;
  createMasterProductNarrative: ProductNarrativeResponse;
  createOrganization: MyOrganizationResponse;
  createProduct: ProductResponse;
  createProductNarrative: ProductNarrativeResponse;
  createProject: Scalars['String'];
  createSelfRaterParticipants: SuccessResponse;
  createStandardSurveyPage: StandardSurveyPageResponse;
  createStdPageItem: StdPageItemResponse;
  createStdProject: Scalars['String'];
  createSurvey: SurveyResponse;
  createSurveyCompetencyItem: CompetencyItemResponse;
  deleteAcmCompetency: AcmCompetencyResponse;
  deleteAcmProject: AcmProjectResponse;
  deleteAcmProjectCompetency: AcmProjectCompetencyResponse;
  deleteAcmProjectParticipants: DeleteAcmProjectParticipantsResponse;
  deleteAdsApiKey: SuccessResponse;
  deleteCaseStudy: CaseStudyResponse;
  deleteCaseStudyFile: AcmCaseStudyFileResponse;
  deleteCaseStudyKpi: CaseStudyKpiResponse;
  deleteCompetency: SuccessResponse;
  deleteCompetencyGroup: SuccessResponse;
  deleteCompetencyItem: SuccessResponse;
  deleteDemographic: SuccessResponse;
  deleteDemographicTemplate: SuccessResponse;
  deleteKpi: KpiResponse;
  deleteMasterProduct: SuccessResponse;
  deleteMasterProductIndicator: SuccessResponse;
  deleteMasterProductNarrative: SuccessResponse;
  deleteMembersAndInvitations: SuccessResponse;
  deleteProduct: SuccessResponse;
  deleteProductIndicator: SuccessResponse;
  deleteProductNarrative: SuccessResponse;
  deleteSelfRaterParticipant: SuccessResponse;
  deleteStandardSurveyPage: SuccessResponse;
  deleteStdPageItem: SuccessResponse;
  deleteStdProject: SuccessResponse;
  deleteStdProjectSessions: SuccessResponse;
  deleteStdReports: SuccessResponse;
  deleteSurvey: SuccessResponse;
  deleteSurveyCompetency: SuccessResponse;
  deleteSurveyCompetencyItem: SuccessResponse;
  duplicateCompetency: CompetencyWithItemsResponse;
  duplicateCompetencyItem: CompetencyItemResponse;
  duplicateDemographicTemplate: DemographicTemplateWithCountResponse;
  duplicateSurvey: SurveyResponse;
  duplicateSurveyCompetency: SurveyCompetencyWithItemsResponse;
  duplicateSurveyCompetencyItem: CompetencyItemResponse;
  endSession: SuccessResponse;
  endStdSession: SuccessResponse;
  exportMasterProductIndicatorsCsvTemplate: Scalars['String'];
  exportMasterProductNarrativesCsvTemplate: Scalars['String'];
  exportProductIndicatorsCsvTemplate: Scalars['String'];
  exportProductNarrativesCsvTemplate: Scalars['String'];
  extendStdProjectEndDate: SuccessResponse;
  forgetPassword: ForgetPasswordResponse;
  generateProductPdfReport?: Maybe<Scalars['String']>;
  generateProductReport: Scalars['String'];
  generateSingleProductAssessmentReport: SuccessResponse;
  generateStdProjectCsvReport: SuccessResponse;
  generateStdProjectTokens: Scalars['String'];
  generateUniqueDomain: Scalars['String'];
  importMasterProductIndicatorsCsvTemplate: Array<ProductIndicatorResponse>;
  importMasterProductNarrativeCsvTemplate: SuccessResponse;
  importParticipantsCsv: Array<ParticipantsCsvResponse>;
  importProductIndicatorsCsvTemplate: Array<ProductIndicatorResponse>;
  importProductNarrativeCsvTemplate: SuccessResponse;
  importStdAnswersFromCsv: SuccessResponse;
  importStdQuestionsFromCsv: SuccessResponse;
  inviteUsers: SuccessResponse;
  joinOrganization: JoinRequestResponse;
  joinOrganizationViaInvitation: SuccessResponse;
  linkKpisWithCaseStudyAndCompetency: Array<CaseStudyKpiResponse>;
  linkProductsToOrganization: Array<ProductResponse>;
  logout: SuccessResponse;
  passInfoPage: SuccessResponse;
  passStdSessionDemographicsPage: SuccessResponse;
  passStdSessionInfoPage: SuccessResponse;
  productLinkGenerator: Scalars['String'];
  refreshToken: RefreshTokenResponse;
  rejectJoinRequest: SuccessResponse;
  resend360SessionsByProjectId: SuccessResponse;
  resend360SessionsBySelfRaterId: SuccessResponse;
  resendInvitation: SuccessResponse;
  resendProductSession: Scalars['String'];
  resendStdProjectSessions: SuccessResponse;
  resendSurveySession: SuccessResponse;
  resendVerification: SuccessResponse;
  resetPassword: SuccessResponse;
  resetPasswordViaToken: SuccessResponse;
  restoreAcmProject: AcmProjectResponse;
  restoreCaseStudy: CaseStudyResponse;
  restoreCompetencyGroup: SuccessResponse;
  restoreDemographicTemplate: SuccessResponse;
  restoreMasterProduct: SuccessResponse;
  restoreProduct: SuccessResponse;
  restoreStdProject: SuccessResponse;
  restoreSurvey: SuccessResponse;
  selectLocale: Scalars['String'];
  selectStdLocale: Scalars['String'];
  send360ProjectViaCsv: SuccessResponse;
  sendBulkProducts: SuccessResponse;
  sendProductsToIndividual: SuccessResponse;
  sendProject: SuccessResponse;
  sendResetPasswordEmail: SuccessResponse;
  sendStdProject2: SuccessResponse;
  setAdsApiKey: Scalars['String'];
  setMasterProductIndicators: Array<ProductIndicatorResponse>;
  setProductIndicators: Array<ProductIndicatorResponse>;
  setProjectSettings: ProjectSettingsResponse;
  setStandardSurveyDimensions: Array<StdDimensionResponse>;
  setStdProjectSettings: StdProjectSettingsResponse;
  signin: SigninResponse;
  signup: SignupResponse;
  superAdminGenerateUniqueDomain: Scalars['String'];
  superAdminUpdateOrganization: MyOrganizationWithJobTitleResponse;
  syncStdProjectTypo: SuccessResponse;
  toggleOrganizationActivation: SuccessResponse;
  transferMasterSurveys: SuccessResponse;
  trashAcmProject: AcmProjectResponse;
  trashCaseStudy: CaseStudyResponse;
  trashCompetencyGroup: SuccessResponse;
  trashDemographicTemplate: SuccessResponse;
  trashMasterProduct: SuccessResponse;
  trashProduct: SuccessResponse;
  trashStdProject: SuccessResponse;
  trashSurvey: SuccessResponse;
  updateAcmCompetency: AcmCompetencyResponse;
  updateAcmProject: AcmProjectResponse;
  updateAcmProjectCompetency: AcmProjectCompetencyResponse;
  updateAcmProjectParticipants: Array<AcmProjectParticipantResponse>;
  updateCaseStudy: CaseStudyResponse;
  updateCaseStudyFile: AcmCaseStudyFileResponse;
  updateCaseStudyKpiOrder: CaseStudyKpiResponse;
  updateCompetencyGroup: CompetencyGroupResponse;
  updateCompetencyItem: CompetencyItemResponse;
  updateCompetencyItemOrder: CompetencyItemResponse;
  updateCompetencyItemResponseLogic: CompetencySubItemResponse;
  updateCompetencyLocale: CompetencyResponse;
  updateDemographic: DemographicResponse;
  updateDemographicOrder: DemographicResponse;
  updateDemographicTemplate: DemographicTemplateResponse;
  updateKpi: KpiResponse;
  updateMasterProduct: MasterProductResponse;
  updateMasterProductNarrative: ProductNarrativeResponse;
  updateMyProfile: UserResponse;
  updateOrganization: MyOrganizationWithJobTitleResponse;
  updateOrganizationAccess: SuccessResponse;
  updateProduct: ProductResponse;
  updateProductNarrative: ProductNarrativeResponse;
  updateProductSession: SuccessResponse;
  updateProject: ProjectResponse;
  updateRoles: SuccessResponse;
  updateSelfRaterEndDate: SuccessResponse;
  updateSelfRaterParticipant: SuccessResponse;
  updateStandardSurveyPage: StandardSurveyPageResponse;
  updateStdPageItem: StdPageItemResponse;
  updateStdPageItemOrder: StdPageItemResponse;
  updateStdProject: StdProjectResponse;
  updateStdProjectSession: SuccessResponse;
  updateSurvey: SurveyResponse;
  updateSurveyCompetencyItem: CompetencyItemResponse;
  updateSurveyCompetencyItemOrder: CompetencyItemResponse;
  updateSurveyCompetencyItemResponseLogic: CompetencySubItemResponse;
  updateSurveyCompetencyLocale: SurveyCompetencyResponse;
  updateSurveyLocale: SurveyWithLocalesResponse;
  verifyAccount: SigninResponse;
};


export type MutationAcceptJoinRequestArgs = {
  input: AcceptJoinRequestInput;
  organizationId: Scalars['String'];
};


export type MutationAddUnitsArgs = {
  input: AddUnitsInput;
};


export type MutationAnswerCompetencyItemArgs = {
  input: AnswerCompetencyItemInput;
  sessionToken: Scalars['String'];
};


export type MutationAnswerStdSessionDemographicArgs = {
  input: AnswerStdSessionDemographicInput;
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationAnswerStdSessionOpenEndedQuestionArgs = {
  input: AnswerStdSessionOpenEndedQuestionInput;
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationAnswerStdSessionPageItemQuestionArgs = {
  input: AnswerStdSessionPageItemQuestionInput;
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationAnswerSubItemArgs = {
  input: AnswerSubItemInput;
  sessionToken: Scalars['String'];
};


export type MutationApproveStdSessionPolicyArgs = {
  approved: Scalars['Boolean'];
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationApproveSurveyPolicyArgs = {
  approved: Scalars['Boolean'];
  sessionToken: Scalars['String'];
};


export type MutationCancelJoiningRequestArgs = {
  joinRequestId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationCloneCompetenciesToSurveyArgs = {
  clonedCompetencies: Array<CloneCompetencyInput>;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCommentCompetencyArgs = {
  input: CommentCompetencyInput;
  sessionToken: Scalars['String'];
};


export type MutationCreateAcmCompetencyArgs = {
  input: CreateAcmCompetencyInput;
  organizationId: Scalars['String'];
};


export type MutationCreateAcmProjectArgs = {
  companyImageFile?: InputMaybe<Scalars['Upload']>;
  input: CreateAcmProjectInput;
  organizationId: Scalars['String'];
};


export type MutationCreateAcmProjectCompetencyArgs = {
  acmProjectId: Scalars['String'];
  input: CreateAcmProjectCompetencyInput;
  organizationId: Scalars['String'];
};


export type MutationCreateAcmProjectParticipantsArgs = {
  acmProjectId: Scalars['String'];
  input: CreateAcmProjectParticipantsInput;
  organizationId: Scalars['String'];
};


export type MutationCreateCaseStudyArgs = {
  input: CreateCaseStudyInput;
  organizationId: Scalars['String'];
};


export type MutationCreateCaseStudyFileArgs = {
  caseStudyId: Scalars['String'];
  file: Scalars['Upload'];
  input: CreateAcmCaseStudyFileInput;
  organizationId: Scalars['String'];
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
};


export type MutationCreateCompetencyArgs = {
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationCreateCompetencyGroupArgs = {
  input: CreateCompetencyGroupInput;
};


export type MutationCreateCompetencyItemArgs = {
  competencyGroupId: Scalars['String'];
  input: CreateCompetencyItemInput;
  organizationId: Scalars['String'];
};


export type MutationCreateDemographicArgs = {
  demographicTemplateId: Scalars['String'];
  input: CreateDemographicInput;
  organizationId: Scalars['String'];
};


export type MutationCreateDemographicTemplateArgs = {
  input: CreateDemographicTemplateInput;
  organizationId: Scalars['String'];
};


export type MutationCreateKpiArgs = {
  input: CreateKpiInput;
  organizationId: Scalars['String'];
};


export type MutationCreateMasterProductArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: CreateMasterProductInput;
};


export type MutationCreateMasterProductNarrativeArgs = {
  input: CreateProductNarrativeInput;
  masterProductId: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: CreateOrganizationInput;
};


export type MutationCreateProductArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: CreateProductInput;
  organizationId: Scalars['String'];
};


export type MutationCreateProductNarrativeArgs = {
  input: CreateProductNarrativeInput;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateSelfRaterParticipantsArgs = {
  input: CreateSelfRaterParticipantsInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationCreateStandardSurveyPageArgs = {
  input: CreateStandardSurveyPageInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateStdPageItemArgs = {
  input: CreateStdPageItemInput;
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateStdProjectArgs = {
  input: CreateProjectInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
  organizationId: Scalars['String'];
};


export type MutationCreateSurveyCompetencyItemArgs = {
  input: CreateSurveyCompetencyItemInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDeleteAcmCompetencyArgs = {
  acmCompetencyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteAcmProjectArgs = {
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteAcmProjectCompetencyArgs = {
  acmProjectCompetencyId: Scalars['String'];
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteAcmProjectParticipantsArgs = {
  acmProjectId: Scalars['String'];
  acmProjectParticipantIds: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteAdsApiKeyArgs = {
  key: Scalars['String'];
};


export type MutationDeleteCaseStudyArgs = {
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCaseStudyFileArgs = {
  caseFileId: Scalars['String'];
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCaseStudyKpiArgs = {
  caseStudyId: Scalars['String'];
  caseStudyKpiId: Scalars['String'];
  competencyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCompetencyArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCompetencyGroupArgs = {
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteCompetencyItemArgs = {
  competencyGroupId: Scalars['String'];
  input: DeleteCompetencyItemInput;
  organizationId: Scalars['String'];
};


export type MutationDeleteDemographicArgs = {
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteKpiArgs = {
  kpiId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDeleteMasterProductArgs = {
  masterProductId: Scalars['String'];
};


export type MutationDeleteMasterProductIndicatorArgs = {
  _id: Scalars['String'];
  masterProductId: Scalars['String'];
};


export type MutationDeleteMasterProductNarrativeArgs = {
  _id: Scalars['String'];
  masterProductId: Scalars['String'];
};


export type MutationDeleteMembersAndInvitationsArgs = {
  input: DeleteMembersOrInvitationsInput;
  organizationId: Scalars['String'];
};


export type MutationDeleteProductArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationDeleteProductIndicatorArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationDeleteProductNarrativeArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationDeleteSelfRaterParticipantArgs = {
  organizationId: Scalars['String'];
  participantId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationDeleteStandardSurveyPageArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDeleteStdPageItemArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDeleteStdProjectArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationDeleteStdProjectSessionsArgs = {
  isAllSelected?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  sessionIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeleteStdReportsArgs = {
  organizationId: Scalars['String'];
  stdReportsIds: Array<Scalars['String']>;
};


export type MutationDeleteSurveyArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDeleteSurveyCompetencyArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDeleteSurveyCompetencyItemArgs = {
  input: DeleteSurveyCompetencyItemInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDuplicateCompetencyArgs = {
  _id: Scalars['String'];
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDuplicateCompetencyItemArgs = {
  _id: Scalars['String'];
  competencyGroupId: Scalars['String'];
  competencyId: Scalars['String'];
  newCompetencyItemOrder: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDuplicateDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationDuplicateSurveyArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDuplicateSurveyCompetencyArgs = {
  _id: Scalars['String'];
  newSurveyCompetencyOrder: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationDuplicateSurveyCompetencyItemArgs = {
  _id: Scalars['String'];
  newSurveyCompetencyItemOrder: Scalars['String'];
  organizationId: Scalars['String'];
  surveyCompetencyId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationEndSessionArgs = {
  additionalComments?: InputMaybe<Scalars['String']>;
  areasForDevelopment?: InputMaybe<Scalars['String']>;
  sessionToken: Scalars['String'];
  strengths?: InputMaybe<Scalars['String']>;
};


export type MutationEndStdSessionArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationExportMasterProductIndicatorsCsvTemplateArgs = {
  masterProductId: Scalars['String'];
};


export type MutationExportMasterProductNarrativesCsvTemplateArgs = {
  masterProductId: Scalars['String'];
};


export type MutationExportProductIndicatorsCsvTemplateArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationExportProductNarrativesCsvTemplateArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationExtendStdProjectEndDateArgs = {
  endDate: Scalars['DateTime'];
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationForgetPasswordArgs = {
  input: ForgetPasswordInput;
};


export type MutationGenerateProductPdfReportArgs = {
  email: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
};


export type MutationGenerateProductReportArgs = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  startAt?: InputMaybe<Scalars['DateTime']>;
};


export type MutationGenerateSingleProductAssessmentReportArgs = {
  adsAssessmentId: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationGenerateStdProjectCsvReportArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationGenerateStdProjectTokensArgs = {
  input: GenerateStdProjectTokensInput;
  organizationId: Scalars['String'];
  participantsCsv?: InputMaybe<Scalars['Upload']>;
  projectId: Scalars['String'];
};


export type MutationGenerateUniqueDomainArgs = {
  organizationName: Scalars['String'];
};


export type MutationImportMasterProductIndicatorsCsvTemplateArgs = {
  ProductIndicatorsCsv: Scalars['Upload'];
  masterProductId: Scalars['String'];
};


export type MutationImportMasterProductNarrativeCsvTemplateArgs = {
  masterProductId: Scalars['String'];
  productNarrativesCsv: Scalars['Upload'];
};


export type MutationImportParticipantsCsvArgs = {
  organizationId: Scalars['String'];
  participantsCsv?: InputMaybe<Scalars['Upload']>;
  projectId: Scalars['String'];
};


export type MutationImportProductIndicatorsCsvTemplateArgs = {
  ProductIndicatorsCsv: Scalars['Upload'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationImportProductNarrativeCsvTemplateArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productNarrativesCsv: Scalars['Upload'];
};


export type MutationImportStdAnswersFromCsvArgs = {
  organizationId: Scalars['String'];
  stdAnswersCsv?: InputMaybe<Scalars['Upload']>;
  surveyId: Scalars['String'];
};


export type MutationImportStdQuestionsFromCsvArgs = {
  organizationId: Scalars['String'];
  stdQuestionsCsv?: InputMaybe<Scalars['Upload']>;
  surveyId: Scalars['String'];
};


export type MutationInviteUsersArgs = {
  invitedUsers?: InputMaybe<Array<InviteUserInput>>;
  invitedUsersCsv?: InputMaybe<Scalars['Upload']>;
  organizationId: Scalars['String'];
};


export type MutationJoinOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type MutationJoinOrganizationViaInvitationArgs = {
  invitationToken: Scalars['String'];
};


export type MutationLinkKpisWithCaseStudyAndCompetencyArgs = {
  caseStudyId: Scalars['String'];
  input: LinkKpisWithCaseStudyAndCompetencyInput;
  organizationId: Scalars['String'];
};


export type MutationLinkProductsToOrganizationArgs = {
  masterProductsIds: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type MutationPassInfoPageArgs = {
  sessionToken: Scalars['String'];
};


export type MutationPassStdSessionDemographicsPageArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationPassStdSessionInfoPageArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationProductLinkGeneratorArgs = {
  candidatesCsv?: InputMaybe<Scalars['Upload']>;
  input: LinkGeneratorInput;
  organizationId: Scalars['String'];
};


export type MutationRejectJoinRequestArgs = {
  joinRequestId: Scalars['String'];
  organizationId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationResend360SessionsByProjectIdArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationResend360SessionsBySelfRaterIdArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationResendInvitationArgs = {
  organizationId: Scalars['String'];
  userEmail: Scalars['String'];
};


export type MutationResendProductSessionArgs = {
  assessmentId: Scalars['String'];
  email: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
  resendEmail?: InputMaybe<Scalars['Boolean']>;
  withNewToken?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResendStdProjectSessionsArgs = {
  isAllSelected?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  sessionIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationResendSurveySessionArgs = {
  organizationId: Scalars['String'];
  participantId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationResendVerificationArgs = {
  input: ResendVerificationCodeInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPasswordViaTokenArgs = {
  input: ChangePasswordInput;
};


export type MutationRestoreAcmProjectArgs = {
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationRestoreCaseStudyArgs = {
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationRestoreCompetencyGroupArgs = {
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationRestoreDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationRestoreMasterProductArgs = {
  masterProductId: Scalars['String'];
};


export type MutationRestoreProductArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationRestoreStdProjectArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationRestoreSurveyArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationSelectLocaleArgs = {
  input: SelectLocaleInput;
  sessionToken: Scalars['String'];
};


export type MutationSelectStdLocaleArgs = {
  input: StdSelectLocaleInput;
  stdSessionInfo: StdSessionInfoArgs;
};


export type MutationSend360ProjectViaCsvArgs = {
  input: SendProjectViaCsvInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRatersCsv?: InputMaybe<Scalars['Upload']>;
};


export type MutationSendBulkProductsArgs = {
  candidatesCsv?: InputMaybe<Scalars['Upload']>;
  input: SendProductsInput;
  organizationId: Scalars['String'];
};


export type MutationSendProductsToIndividualArgs = {
  input: SendProductsToIndividualInput;
  organizationId: Scalars['String'];
};


export type MutationSendProjectArgs = {
  input: SendProjectInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSendStdProject2Args = {
  organizationId: Scalars['String'];
  participantsCsv?: InputMaybe<Scalars['Upload']>;
  projectId: Scalars['String'];
  sendStdProjectInput: SendStdProjectInput;
};


export type MutationSetAdsApiKeyArgs = {
  key: Scalars['String'];
};


export type MutationSetMasterProductIndicatorsArgs = {
  input: Array<SetProductIndicatorInput>;
  masterProductId: Scalars['String'];
};


export type MutationSetProductIndicatorsArgs = {
  input: Array<SetProductIndicatorInput>;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationSetProjectSettingsArgs = {
  input: SetProjectSettingsInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSetStandardSurveyDimensionsArgs = {
  input: SetStandardDimensionsInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationSetStdProjectSettingsArgs = {
  input: SetStdProjectSettingsInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSigninArgs = {
  input: SigninInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSuperAdminGenerateUniqueDomainArgs = {
  organizationName: Scalars['String'];
};


export type MutationSuperAdminUpdateOrganizationArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateOrganizationInput;
  organizationId: Scalars['String'];
};


export type MutationSyncStdProjectTypoArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationToggleOrganizationActivationArgs = {
  active: Scalars['Boolean'];
  organizationId: Scalars['String'];
};


export type MutationTransferMasterSurveysArgs = {
  masterSurveyIds: Array<Scalars['String']>;
  transfereeOrganizationId: Scalars['String'];
};


export type MutationTrashAcmProjectArgs = {
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationTrashCaseStudyArgs = {
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationTrashCompetencyGroupArgs = {
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationTrashDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationTrashMasterProductArgs = {
  masterProductId: Scalars['String'];
};


export type MutationTrashProductArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationTrashStdProjectArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationTrashSurveyArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationUpdateAcmCompetencyArgs = {
  acmCompetencyId: Scalars['String'];
  input: UpdateAcmCompetencyInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateAcmProjectArgs = {
  acmProjectId: Scalars['String'];
  companyImageFile?: InputMaybe<Scalars['Upload']>;
  input: UpdateAcmProjectInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateAcmProjectCompetencyArgs = {
  acmProjectCompetencyId: Scalars['String'];
  acmProjectId: Scalars['String'];
  input: UpdateAcmProjectCompetencyInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateAcmProjectParticipantsArgs = {
  acmProjectId: Scalars['String'];
  input: UpdateAcmProjectParticipantsInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateCaseStudyArgs = {
  caseStudyId: Scalars['String'];
  input: UpdateCaseStudyInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateCaseStudyFileArgs = {
  caseFileId: Scalars['String'];
  caseStudyId: Scalars['String'];
  input: UpdateAcmCaseStudyFileInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateCaseStudyKpiOrderArgs = {
  caseStudyId: Scalars['String'];
  caseStudyKpiId: Scalars['String'];
  competencyId: Scalars['String'];
  order: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateCompetencyGroupArgs = {
  input: UpdateCompetencyGroupInput;
};


export type MutationUpdateCompetencyItemArgs = {
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemInput;
  organizationId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateCompetencyItemOrderArgs = {
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemOrderInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateCompetencyItemResponseLogicArgs = {
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemResponseLogicSubItemInput;
  organizationId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateCompetencyLocaleArgs = {
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyLocaleInput;
  localeCodes: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type MutationUpdateDemographicArgs = {
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  input: UpdateDemographicInput;
  organizationId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateDemographicOrderArgs = {
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  order: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  input: UpdateDemographicTemplateInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateKpiArgs = {
  input: UpdateKpiInput;
  kpiId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateMasterProductArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateMasterProductInput;
  masterProductId: Scalars['String'];
};


export type MutationUpdateMasterProductNarrativeArgs = {
  _id: Scalars['String'];
  input: UpdateProductNarrativeInput;
  masterProductId: Scalars['String'];
};


export type MutationUpdateMyProfileArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateMyProfileInput;
};


export type MutationUpdateOrganizationArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateOrganizationInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateOrganizationAccessArgs = {
  input: UpdateOrganizationAccessInput;
};


export type MutationUpdateProductArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateProductInput;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationUpdateProductNarrativeArgs = {
  _id: Scalars['String'];
  input: UpdateProductNarrativeInput;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type MutationUpdateProductSessionArgs = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUpdateRolesArgs = {
  input: UpdateMembersOrInvitationsInput;
  newRoleId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationUpdateSelfRaterEndDateArgs = {
  input: UpdateProjectSelfRaterDateInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationUpdateSelfRaterParticipantArgs = {
  input: UpdateSelfRaterParticipantInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type MutationUpdateStandardSurveyPageArgs = {
  _id: Scalars['String'];
  input: UpdateStandardSurveyPageInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationUpdateStdPageItemArgs = {
  input: UpdateStdPageItemInput;
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateStdPageItemOrderArgs = {
  input: UpdateStdPageItemOrderInput;
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationUpdateStdProjectArgs = {
  input: UpdateStdProjectInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUpdateStdProjectSessionArgs = {
  input: UpdateStdProjectSessionInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  stdProjectSessionId: Scalars['String'];
};


export type MutationUpdateSurveyArgs = {
  horizontalImage?: InputMaybe<Scalars['Upload']>;
  input: UpdateSurveyInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  verticalImage?: InputMaybe<Scalars['Upload']>;
};


export type MutationUpdateSurveyCompetencyItemArgs = {
  input: UpdateSurveyCompetencyItemInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateSurveyCompetencyItemOrderArgs = {
  input: UpdateSurveyCompetencyItemOrderInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationUpdateSurveyCompetencyItemResponseLogicArgs = {
  input: UpdateSurveyCompetencyItemResponseLogicSubItemInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']>;
};


export type MutationUpdateSurveyCompetencyLocaleArgs = {
  input: UpdateSurveyCompetencyLocaleInput;
  localeCodes: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationUpdateSurveyLocaleArgs = {
  input: UpdateSurveyLocaleInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type MutationVerifyAccountArgs = {
  input: VerifyInput;
};

export type MyOrganizationAccessResponse = {
  __typename?: 'MyOrganizationAccessResponse';
  assessmentModule?: Maybe<Scalars['Boolean']>;
  surveyModule?: Maybe<Scalars['Boolean']>;
};

export type MyOrganizationResponse = {
  __typename?: 'MyOrganizationResponse';
  _id: Scalars['String'];
  access?: Maybe<MyOrganizationAccessResponse>;
  active: Scalars['Boolean'];
  adsApiKey?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  units?: Maybe<Scalars['Float']>;
};

export type MyOrganizationWithJobTitleResponse = {
  __typename?: 'MyOrganizationWithJobTitleResponse';
  _id: Scalars['String'];
  access?: Maybe<MyOrganizationAccessResponse>;
  active: Scalars['Boolean'];
  adsApiKey?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  units?: Maybe<Scalars['Float']>;
};

export type MyProductReportResponse = {
  __typename?: 'MyProductReportResponse';
  groupId: Scalars['String'];
  organizationId: Scalars['String'];
  organizationImage?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productSendId: Scalars['String'];
};

export type Narrative360ReportResponse = {
  __typename?: 'Narrative360ReportResponse';
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type OrganizationMemberResponse = {
  __typename?: 'OrganizationMemberResponse';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName: Scalars['String'];
  userId: Scalars['String'];
};

export type OrganizationResponse = {
  __typename?: 'OrganizationResponse';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  domain?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  units?: Maybe<Scalars['Float']>;
};

export type OrganizationsResponse = {
  __typename?: 'OrganizationsResponse';
  docs: Array<OrganizationResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PaginationArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
};

export type PartialProductResponse = {
  __typename?: 'PartialProductResponse';
  _id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ParticipantEmailTemplateResponse = {
  __typename?: 'ParticipantEmailTemplateResponse';
  _id: Scalars['String'];
  body?: Maybe<Scalars['String']>;
  participantTypeId: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type ParticipantResponse = {
  __typename?: 'ParticipantResponse';
  _id: Scalars['String'];
  email: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  participantType: Scalars['String'];
  participantTypeId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type ParticipantStatus = {
  __typename?: 'ParticipantStatus';
  completed: Scalars['Boolean'];
  email: Scalars['String'];
};

export type ParticipantTypeInsights = {
  __typename?: 'ParticipantTypeInsights';
  comments?: Maybe<Array<Scalars['String']>>;
  participantTypeId: Scalars['String'];
  participantTypeName: Scalars['String'];
};

export type ParticipantTypeResponse = {
  __typename?: 'ParticipantTypeResponse';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type ParticipantsComments = {
  __typename?: 'ParticipantsComments';
  comments?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type ParticipantsCsvResponse = {
  __typename?: 'ParticipantsCsvResponse';
  email: Scalars['String'];
  participantTypeId: Scalars['String'];
};

export type ParticipantsSkillAndSignificant = {
  __typename?: 'ParticipantsSkillAndSignificant';
  agreement?: Maybe<Scalars['String']>;
  keyInsights?: Maybe<Scalars['String']>;
  potentialUse?: Maybe<Scalars['String']>;
  significantMean: Scalars['Float'];
  skillMean: Scalars['Float'];
  typeName: Scalars['String'];
};

export type ParticipantsTypeGroup = {
  __typename?: 'ParticipantsTypeGroup';
  participantsStatus: Array<ParticipantStatus>;
  type: Scalars['String'];
};

export type ProductAssessmentResponse = {
  __typename?: 'ProductAssessmentResponse';
  _id: Scalars['String'];
  adsAssessmentName?: Maybe<Scalars['String']>;
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type ProductEmailReportResponse = {
  __typename?: 'ProductEmailReportResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isProductDeleted?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  productImage?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productSendId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userSessions?: Maybe<Array<ProductEmailReportUserSessionResponse>>;
};

export type ProductEmailReportUserSessionResponse = {
  __typename?: 'ProductEmailReportUserSessionResponse';
  _id: Scalars['String'];
  adsAssessmentName?: Maybe<Scalars['String']>;
  assessmentId?: Maybe<Scalars['String']>;
  assessmentLink?: Maybe<Scalars['String']>;
  assessmentName?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
};

export type ProductEmailReportsArgs = {
  filter?: InputMaybe<ProductEmailReportsFilterArgs>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
};

export type ProductEmailReportsFilterArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type ProductEmailReportsResponse = {
  __typename?: 'ProductEmailReportsResponse';
  docs: Array<ProductEmailReportResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ProductIndicatorResponse = {
  __typename?: 'ProductIndicatorResponse';
  _id: Scalars['String'];
  fromScore: Scalars['Float'];
  name: Scalars['String'];
  toScore: Scalars['Float'];
};

export type ProductNarrativeResponse = {
  __typename?: 'ProductNarrativeResponse';
  _id: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  dimension?: Maybe<Scalars['String']>;
  indicatorId?: Maybe<Scalars['String']>;
  langCode?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductNarrativesResponse = {
  __typename?: 'ProductNarrativesResponse';
  docs: Array<ProductNarrativeResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ProductResponse = {
  __typename?: 'ProductResponse';
  _id: Scalars['String'];
  assessments?: Maybe<Array<ProductAssessmentResponse>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isSent: Scalars['Boolean'];
  masterProductId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  units: Scalars['Float'];
};

export type ProductResponseWithNarrativesCount = {
  __typename?: 'ProductResponseWithNarrativesCount';
  _id: Scalars['String'];
  assessments?: Maybe<Array<ProductAssessmentResponse>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isSent: Scalars['Boolean'];
  masterProductId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  narrativesCount: Scalars['Float'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  units: Scalars['Float'];
};

export type ProductSendResponse = {
  __typename?: 'ProductSendResponse';
  _id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  products: Array<PartialProductResponse>;
  sendType: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  totalSessions: Scalars['Float'];
};

export type ProductSendsResponse = {
  __typename?: 'ProductSendsResponse';
  docs: Array<ProductSendResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ProductSessionResponse = {
  __typename?: 'ProductSessionResponse';
  _id: Scalars['String'];
  assessments?: Maybe<Array<ProductAssessmentResponse>>;
  email?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
};

export type ProductSessionsResponse = {
  __typename?: 'ProductSessionsResponse';
  docs: Array<ProductSessionResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  docs: Array<ProductResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type ProjectResponse = {
  __typename?: 'ProjectResponse';
  _id: Scalars['String'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  localeCodes?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  surveyId: Scalars['String'];
  surveyName: Scalars['String'];
  surveyType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProjectSettingsResponse = {
  __typename?: 'ProjectSettingsResponse';
  _id: Scalars['String'];
  globalBody?: Maybe<Scalars['String']>;
  globalSubject?: Maybe<Scalars['String']>;
  participantEmailTemplates?: Maybe<Array<ParticipantEmailTemplateResponse>>;
  participantTypes: Array<ParticipantTypeResponse>;
  restrictLogin?: Maybe<Scalars['Boolean']>;
  selfRaterBody?: Maybe<Scalars['String']>;
  selfRaterSubject?: Maybe<Scalars['String']>;
  unifyEmailForAll: Scalars['Boolean'];
};

export type ProjectsResponse = {
  __typename?: 'ProjectsResponse';
  docs: Array<ProjectResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  acmCompetencies: Array<AcmCompetencyResponse>;
  acmCompetency: AcmCompetencyResponse;
  acmProject: AcmProjectResponse;
  acmProjectCompetencyKpis: Array<KpiResponse>;
  acmProjectParticipants: Array<AcmProjectParticipantResponse>;
  adsApiKey?: Maybe<Scalars['String']>;
  assignedAssessments: Array<AssignedAssessmentResponse>;
  caseStudy: CaseStudyResponse;
  caseStudyKpis: Array<CaseStudyKpiResponse>;
  checkStdSession: CheckStdSessionResponse;
  checkSurveySession: CheckSurveySessionResponse;
  competencies: Array<CompetencyWithItemsResponse>;
  competencyGroup: CompetencyGroupWithChildrenResponse;
  countStdSessionsWithTrashedOption: Scalars['Float'];
  demographicTemplate: DemographicTemplateResponse;
  demographics: Array<DemographicResponse>;
  downloadBulkSenderTemplate: Scalars['String'];
  downloadInviteUsersCsvTemplate: Scalars['String'];
  downloadLinksGeneratorTemplate: Scalars['String'];
  downloadParticipantsCsvTemplate: Scalars['String'];
  downloadProductIndicatorsCsvTemplate: Scalars['String'];
  downloadProductNarrativesCsvTemplate: Scalars['String'];
  downloadProject360CsvTemplate: Scalars['String'];
  downloadStdParticipantsCsvTemplate: Scalars['String'];
  exportStdQuestionsAndAnswersToCsv: ExportStdQuestionsAndAnswersCsvResponse;
  generateMyProductReport: Scalars['String'];
  getSystemLanguages: Array<LanguageResponse>;
  isProjectNameExist: Scalars['Boolean'];
  isStdProjectNameExist: Scalars['Boolean'];
  joinRequests: JoinRequestsResponse;
  kpi: KpiResponse;
  lastThreeJoinRequests: Array<JoinRequestResponse>;
  masterProduct: MasterProductWithNarrativesCountResponse;
  masterProductIndicators: Array<ProductIndicatorResponse>;
  masterProductNarrative: ProductNarrativeResponse;
  me: UserResponse;
  membersAndInvitations: MembersAndInvitationsResponse;
  myJoiningRequests: Array<JoinRequestResponse>;
  myOrganization: MyOrganizationWithJobTitleResponse;
  myOrganizations: Array<MyOrganizationResponse>;
  myProductReports: Array<MyProductReportResponse>;
  nextCompetency: CheckSurveySessionResponse;
  nextStdSessionPage: CheckStdSessionResponse;
  organization: SuperAdminOrganizationResponse;
  organizationAdsAssessments: AdsAssessmentsResponse;
  organizationAssignableProducts: MasterProductsResponse;
  prevCompetency: CheckSurveySessionResponse;
  prevStdSessionPage: CheckStdSessionResponse;
  product: ProductResponseWithNarrativesCount;
  productEmailReports: ProductEmailReportsResponse;
  productIndicators: Array<ProductIndicatorResponse>;
  productNarrative: ProductNarrativeResponse;
  productSend: ProductSendResponse;
  project: ProjectResponse;
  projectRawScores360: Scalars['String'];
  projectSettings?: Maybe<ProjectSettingsResponse>;
  report360Data: DynamicReport360;
  report360DataForManySelfRaters: Scalars['String'];
  report360Pdf: Scalars['String'];
  roles: Array<RoleResponse>;
  searchAcmCaseFiles: AcmCaseStudyFilesResponse;
  searchAcmCompetencies: AcmCompetenciesResponse;
  searchAcmProjectCompetencies: AcmProjectCompetenciesResponse;
  searchAcmProjects: AcmProjectsResponse;
  searchCaseStudies: CaseStudiesResponse;
  searchCompetencyGroups: CompetencyGroupsResponse;
  searchCompetencyGroupsWithAllCompetencies: CompetencyGroupsResponse;
  searchDemographicTemplates: DemographicTemplatesWithCountResponse;
  searchKpis: KpisResponse;
  searchMasterProductNarratives: ProductNarrativesResponse;
  searchMasterProducts: MasterProductsResponse;
  searchOrganizations: OrganizationsResponse;
  searchProductNarratives: ProductNarrativesResponse;
  searchProductSendSessions: ProductSessionsResponse;
  searchProductSends: ProductSendsResponse;
  searchProducts: ProductsResponse;
  searchProjects: ProjectsResponse;
  searchSelfRaters: SelfRatersResponse;
  searchStdProjectReports: SearchStdReportsResponse;
  searchStdProjectSessions: StdProjectSessionsResponse;
  searchStdProjects: StdProjectsResponse;
  searchStdSurveyProjects: StdProjectsResponse;
  searchSurveyProjects: ProjectsResponse;
  searchSurveys: SurveysResponse;
  searchTrashedAcmProjects: AcmProjectsResponse;
  searchTrashedCaseStudies: CaseStudiesResponse;
  searchTrashedStdProjects: StdProjectsResponse;
  selfRater: SelfRaterResponse;
  selfRaterRawScores360: Scalars['String'];
  standardSurveyDimensions: Array<StdDimensionResponse>;
  standardSurveyPage: StandardSurveyPageResponse;
  standardSurveyPages: Array<StandardSurveyPageResponse>;
  stdPageItems: Array<StdPageItemResponse>;
  stdPagesWithPageItems: Array<StandardSurveyPageWithItemsResponse>;
  stdProject: StdProjectResponse;
  stdProjectHeatmapReport: Array<HeatmapMatrixRowResponse>;
  stdProjectParticipantsReport: Array<StdReportParticipantsResponse>;
  stdProjectReport: StdReportResponse;
  stdProjectReportDetails: StdProjectReportDetailsResponse;
  stdProjectSettings?: Maybe<StdProjectSettingsResponse>;
  superAdminAdsAssessments: AdsAssessmentsResponse;
  superAdminOrganizations: OrganizationsResponse;
  survey: SurveyWithLocalesResponse;
  surveyCompetencies: Array<SurveyCompetencyWithItemsResponse>;
  timezones: Array<Scalars['String']>;
  trashedCompetencyGroups: CompetencyGroupsResponse;
  trashedDemographicTemplates: DemographicTemplatesWithCountResponse;
  trashedMasterProducts: MasterProductsResponse;
  trashedProducts: ProductsResponse;
  trashedSurveys: SurveysResponse;
};


export type QueryAcmCompetenciesArgs = {
  ids: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryAcmCompetencyArgs = {
  acmCompetencyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryAcmProjectArgs = {
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryAcmProjectCompetencyKpisArgs = {
  acmProjectCompetencyId: Scalars['String'];
  acmProjectId: Scalars['String'];
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryAcmProjectParticipantsArgs = {
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryCaseStudyArgs = {
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryCaseStudyKpisArgs = {
  caseStudyId: Scalars['String'];
  competencyId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryCheckStdSessionArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type QueryCheckSurveySessionArgs = {
  sessionToken: Scalars['String'];
};


export type QueryCompetenciesArgs = {
  competencyGroupId: Scalars['String'];
  organizationId: Scalars['String'];
  query: CompetenciesArgs;
};


export type QueryCompetencyGroupArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryCountStdSessionsWithTrashedOptionArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryDemographicTemplateArgs = {
  demographicTemplateId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryDemographicsArgs = {
  demographicTemplateId: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type QueryExportStdQuestionsAndAnswersToCsvArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryGenerateMyProductReportArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
};


export type QueryIsProjectNameExistArgs = {
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryIsStdProjectNameExistArgs = {
  name: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryJoinRequestsArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QueryKpiArgs = {
  kpiId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QueryLastThreeJoinRequestsArgs = {
  organizationId: Scalars['String'];
};


export type QueryMasterProductArgs = {
  masterProductId: Scalars['String'];
};


export type QueryMasterProductIndicatorsArgs = {
  masterProductId: Scalars['String'];
};


export type QueryMasterProductNarrativeArgs = {
  _id: Scalars['String'];
  masterProductId: Scalars['String'];
};


export type QueryMembersAndInvitationsArgs = {
  organizationId: Scalars['String'];
};


export type QueryMyOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type QueryNextCompetencyArgs = {
  sessionToken: Scalars['String'];
};


export type QueryNextStdSessionPageArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type QueryOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type QueryOrganizationAdsAssessmentsArgs = {
  args: SearchAdsAssessmentsArgs;
  organizationId: Scalars['String'];
};


export type QueryOrganizationAssignableProductsArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QueryPrevCompetencyArgs = {
  sessionToken: Scalars['String'];
};


export type QueryPrevStdSessionPageArgs = {
  stdSessionInfo: StdSessionInfoArgs;
};


export type QueryProductArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryProductEmailReportsArgs = {
  args: ProductEmailReportsArgs;
  organizationId: Scalars['String'];
};


export type QueryProductIndicatorsArgs = {
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryProductNarrativeArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryProductSendArgs = {
  organizationId: Scalars['String'];
  productSendId: Scalars['String'];
};


export type QueryProjectArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryProjectRawScores360Args = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryProjectSettingsArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryReport360DataArgs = {
  lang?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type QueryReport360DataForManySelfRatersArgs = {
  lang?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryReport360PdfArgs = {
  lang?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type QueryRolesArgs = {
  organizationId: Scalars['String'];
};


export type QuerySearchAcmCaseFilesArgs = {
  args: SearchAcmCaseFileArgs;
  caseStudyId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type QuerySearchAcmCompetenciesArgs = {
  args: SearchAcmCompetenciesArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchAcmProjectCompetenciesArgs = {
  acmProjectId: Scalars['String'];
  args: SearchAcmProjectCompetenciesArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchAcmProjectsArgs = {
  args: SearchAcmProjectsArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchCaseStudiesArgs = {
  args: SearchCaseStudiesArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchCompetencyGroupsArgs = {
  args: SearchCompetencyGroupArgs;
};


export type QuerySearchCompetencyGroupsWithAllCompetenciesArgs = {
  args: SearchCompetencyGroupArgs;
  localeCode?: InputMaybe<Scalars['String']>;
};


export type QuerySearchDemographicTemplatesArgs = {
  args: SearchDemographicTemplatesArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchKpisArgs = {
  args: SearchKpisArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchMasterProductNarrativesArgs = {
  args: SearchProductNarrativeArgs;
  masterProductId: Scalars['String'];
};


export type QuerySearchMasterProductsArgs = {
  args: SearchProductArgs;
};


export type QuerySearchOrganizationsArgs = {
  searchOrganizationsData: SearchOrganizationArgs;
};


export type QuerySearchProductNarrativesArgs = {
  args: SearchProductNarrativeArgs;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
};


export type QuerySearchProductSendSessionsArgs = {
  args: SearchProductSessionsArgs;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
};


export type QuerySearchProductSendsArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchProductsArgs = {
  args: SearchProductArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchProjectsArgs = {
  args: SearchProjectsArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchSelfRatersArgs = {
  args: SearchSelfRatersArgs;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QuerySearchStdProjectReportsArgs = {
  args: SearchStdReportsArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchStdProjectSessionsArgs = {
  args: SearchProjectSessionsArgs;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QuerySearchStdProjectsArgs = {
  args: SearchStdProjectsArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchStdSurveyProjectsArgs = {
  args: SearchStdProjectsArgs;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QuerySearchSurveyProjectsArgs = {
  args: SearchProjectsArgs;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QuerySearchSurveysArgs = {
  args: SearchSurveysArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchTrashedAcmProjectsArgs = {
  args: SearchAcmProjectsArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchTrashedCaseStudiesArgs = {
  args: SearchCaseStudiesArgs;
  organizationId: Scalars['String'];
};


export type QuerySearchTrashedStdProjectsArgs = {
  args: SearchStdProjectsArgs;
  organizationId: Scalars['String'];
};


export type QuerySelfRaterArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QuerySelfRaterRawScores360Args = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
};


export type QueryStandardSurveyDimensionsArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryStandardSurveyPageArgs = {
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryStandardSurveyPagesArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryStdPageItemsArgs = {
  organizationId: Scalars['String'];
  query: StdPageItemArgs;
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryStdPagesWithPageItemsArgs = {
  localeCodes: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryStdProjectArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryStdProjectHeatmapReportArgs = {
  allowPercentageHeatMap?: InputMaybe<Scalars['Boolean']>;
  dimensionsFilter?: InputMaybe<Array<Scalars['String']>>;
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs>>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  organizationId: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
  percentageHeatMapCutOff?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['String'];
};


export type QueryStdProjectParticipantsReportArgs = {
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs>>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryStdProjectReportArgs = {
  dimensionsFilter?: InputMaybe<Array<Scalars['String']>>;
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs>>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryStdProjectReportDetailsArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryStdProjectSettingsArgs = {
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QuerySuperAdminAdsAssessmentsArgs = {
  args: SearchAdsAssessmentsArgs;
};


export type QuerySuperAdminOrganizationsArgs = {
  args: SearchSuperAdminOrganizationArgs;
};


export type QuerySurveyArgs = {
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySurveyCompetenciesArgs = {
  localeCodes: Array<Scalars['String']>;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
};


export type QueryTrashedCompetencyGroupsArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QueryTrashedDemographicTemplatesArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QueryTrashedMasterProductsArgs = {
  args: PaginationArgs;
};


export type QueryTrashedProductsArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};


export type QueryTrashedSurveysArgs = {
  args: PaginationArgs;
  organizationId: Scalars['String'];
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type ResendVerificationCodeInput = {
  userId: Scalars['String'];
  verificationToken: Scalars['String'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String'];
  resetPasswordCode: Scalars['Float'];
  userId: Scalars['String'];
};

export type RoleResponse = {
  __typename?: 'RoleResponse';
  _id: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type SearchAcmCaseFileArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchAcmCompetenciesArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchAcmProjectCompetenciesArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchAcmProjectsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchAdsAssessmentsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchCaseStudiesArgs = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchCompetencyGroupArgs = {
  limit: Scalars['Float'];
  organizationId: Scalars['String'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchDemographicTemplatesArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchKpisArgs = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type SearchOrganizationArgs = {
  limit: Scalars['Float'];
  name: Scalars['String'];
  page: Scalars['Float'];
};

export type SearchProductArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchProductNarrativeArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchProductSessionsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchProjectSessionsArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type SearchProjectsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchSelfRaterResponse = {
  __typename?: 'SearchSelfRaterResponse';
  _id: Scalars['String'];
  completedParticipants?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  endDate: Scalars['DateTime'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  totalParticipants?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
};

export type SearchSelfRatersArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchStdProjectsArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchStdReportResponse = {
  __typename?: 'SearchStdReportResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdById: Scalars['String'];
  firstName: Scalars['String'];
  image: Scalars['String'];
  lastName: Scalars['String'];
  link: Scalars['String'];
  size: Scalars['String'];
  stdProjectId: Scalars['String'];
  stdProjectName: Scalars['String'];
  stdSurveyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SearchStdReportsArgs = {
  createdById?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  stdProjectIds?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type SearchStdReportsResponse = {
  __typename?: 'SearchStdReportsResponse';
  docs: Array<SearchStdReportResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type SearchSuperAdminOrganizationArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SearchSurveysArgs = {
  limit: Scalars['Float'];
  page: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type SelectLocaleInput = {
  localeCode: Scalars['String'];
};

export type SelfRaterInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  participants: Array<SelfRaterParticipantInput>;
};

export type SelfRaterParticipantInput = {
  email: Scalars['String'];
  participantTypeId: Scalars['String'];
};

export type SelfRaterResponse = {
  __typename?: 'SelfRaterResponse';
  _id: Scalars['String'];
  email: Scalars['String'];
  endDate: Scalars['DateTime'];
  image?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  participants: Array<ParticipantResponse>;
  sendDate: Scalars['DateTime'];
};

export type SelfRatersResponse = {
  __typename?: 'SelfRatersResponse';
  docs: Array<SearchSelfRaterResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type SendProductsInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  productIds: Array<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type SendProductsToIndividualInput = {
  email: Scalars['String'];
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  productIds: Array<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type SendProjectInput = {
  endDate: Scalars['DateTime'];
  selfRaters: Array<SelfRaterInput>;
  sendDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type SendProjectViaCsvInput = {
  endDate: Scalars['DateTime'];
  sendDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type SendStdProjectInput = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  endDate: Scalars['DateTime'];
  sendDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type SessionSubItemResponse = {
  __typename?: 'SessionSubItemResponse';
  _id: Scalars['String'];
  questionDefinition?: Maybe<Scalars['String']>;
  questionTitle: Scalars['String'];
  responses: Array<SessionSubItemResponseResponse>;
  selectedResponseId?: Maybe<Scalars['String']>;
};

export type SessionSubItemResponseResponse = {
  __typename?: 'SessionSubItemResponseResponse';
  _id: Scalars['String'];
  text: Scalars['String'];
};

export type SetParticipantEmailTemplateInput = {
  _id: Scalars['String'];
  body: Scalars['String'];
  participantTypeId: Scalars['String'];
  subject: Scalars['String'];
};

export type SetParticipantTypeInput = {
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type SetProductIndicatorInput = {
  _id?: InputMaybe<Scalars['String']>;
  fromScore: Scalars['Float'];
  name: Scalars['String'];
  toScore: Scalars['Float'];
};

export type SetProjectSettingsInput = {
  globalBody?: InputMaybe<Scalars['String']>;
  globalSubject?: InputMaybe<Scalars['String']>;
  participantEmailTemplates?: InputMaybe<Array<SetParticipantEmailTemplateInput>>;
  participantTypes: Array<SetParticipantTypeInput>;
  restrictLogin?: InputMaybe<Scalars['Boolean']>;
  selfRaterBody?: InputMaybe<Scalars['String']>;
  selfRaterSubject?: InputMaybe<Scalars['String']>;
  unifyEmailForAll: Scalars['Boolean'];
};

export type SetStandardDimensionInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  subDimensions?: InputMaybe<Array<SetSubStandardDimensionInput>>;
};

export type SetStandardDimensionsInput = {
  dimensions: Array<SetStandardDimensionInput>;
};

export type SetStdProjectSettingsInput = {
  allowPublicLink?: InputMaybe<Scalars['Boolean']>;
  globalBody: Scalars['String'];
  globalSubject: Scalars['String'];
  restrictLogin?: InputMaybe<Scalars['Boolean']>;
  showDimensions?: InputMaybe<Scalars['Boolean']>;
};

export type SetSubStandardDimensionInput = {
  _id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SigninInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SigninResponse = {
  __typename?: 'SigninResponse';
  accessToken?: Maybe<Scalars['String']>;
  isVerified: Scalars['Boolean'];
  refreshToken?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  verificationToken?: Maybe<Scalars['String']>;
};

export type SignupInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  userId: Scalars['String'];
  verificationToken: Scalars['String'];
};

export type StandardSurveyPageResponse = {
  __typename?: 'StandardSurveyPageResponse';
  _id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
};

export type StandardSurveyPageWithItemsResponse = {
  __typename?: 'StandardSurveyPageWithItemsResponse';
  _id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  stdPageItems: Array<StdPageItemResponse>;
};

export type StdDimensionResponse = {
  __typename?: 'StdDimensionResponse';
  _id: Scalars['String'];
  name: Scalars['String'];
  subDimensions: Array<StdSubDimensionResponse>;
};

export type StdPageItemAnswerResponse = {
  __typename?: 'StdPageItemAnswerResponse';
  _id: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  text?: Maybe<Array<LocaleResponse>>;
  value?: Maybe<Scalars['String']>;
};

export type StdPageItemArgs = {
  localeCodes: Array<Scalars['String']>;
};

export type StdPageItemQuestionResponse = {
  __typename?: 'StdPageItemQuestionResponse';
  _id: Scalars['String'];
  dimensionId?: Maybe<Scalars['String']>;
  isInverted?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['String']>;
  subDimensionId?: Maybe<Scalars['String']>;
  text?: Maybe<Array<LocaleResponse>>;
};

export type StdPageItemResponse = {
  __typename?: 'StdPageItemResponse';
  _id: Scalars['String'];
  answers?: Maybe<Array<StdPageItemAnswerResponse>>;
  createdAt: Scalars['DateTime'];
  dimensionId?: Maybe<Scalars['String']>;
  infoText?: Maybe<Array<LocaleResponse>>;
  order: Scalars['String'];
  questionTitle?: Maybe<Array<LocaleResponse>>;
  questions?: Maybe<Array<StdPageItemQuestionResponse>>;
  subDimensionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StdProjectReportDetailsDimensionResponse = {
  __typename?: 'StdProjectReportDetailsDimensionResponse';
  _id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StdProjectReportDetailsResponse = {
  __typename?: 'StdProjectReportDetailsResponse';
  completedParticipants?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Array<StdProjectReportDetailsDimensionResponse>>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  qualitativeItems?: Maybe<Scalars['Float']>;
  quantitativeItems?: Maybe<Scalars['Float']>;
  totalParticipants?: Maybe<Scalars['Float']>;
};

export type StdProjectReportDrillDownArgs = {
  dynamicKey?: InputMaybe<Scalars['String']>;
  staticKey?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type StdProjectReportDynamicDemographicsArgs = {
  demographicId: Scalars['String'];
  optionId: Scalars['String'];
};

export type StdProjectReportFilterArgs = {
  ageGroup?: InputMaybe<Array<Scalars['String']>>;
  businessUnit?: InputMaybe<Array<Scalars['String']>>;
  city?: InputMaybe<Array<Scalars['String']>>;
  custom1?: InputMaybe<Array<Scalars['String']>>;
  custom2?: InputMaybe<Array<Scalars['String']>>;
  custom3?: InputMaybe<Array<Scalars['String']>>;
  department?: InputMaybe<Array<Scalars['String']>>;
  experience?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Array<Scalars['String']>>;
  location?: InputMaybe<Array<Scalars['String']>>;
  seniority?: InputMaybe<Array<Scalars['String']>>;
  tenure?: InputMaybe<Array<Scalars['String']>>;
};

export type StdProjectResponse = {
  __typename?: 'StdProjectResponse';
  _id: Scalars['String'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  stdSurveyId: Scalars['String'];
  stdSurveyName: Scalars['String'];
  stdSurveyType: Scalars['String'];
  trashedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type StdProjectSessionResponse = {
  __typename?: 'StdProjectSessionResponse';
  _id: Scalars['String'];
  ageGroup?: Maybe<Scalars['String']>;
  businessUnit?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  custom1?: Maybe<Scalars['String']>;
  custom2?: Maybe<Scalars['String']>;
  custom3?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seniority?: Maybe<Scalars['String']>;
  tenure?: Maybe<Scalars['String']>;
};

export type StdProjectSessionsResponse = {
  __typename?: 'StdProjectSessionsResponse';
  docs: Array<StdProjectSessionResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type StdProjectSettingsResponse = {
  __typename?: 'StdProjectSettingsResponse';
  _id: Scalars['String'];
  allowPublicLink?: Maybe<Scalars['Boolean']>;
  globalBody?: Maybe<Scalars['String']>;
  globalSubject?: Maybe<Scalars['String']>;
  restrictLogin?: Maybe<Scalars['Boolean']>;
  showDimensions?: Maybe<Scalars['Boolean']>;
};

export type StdProjectsResponse = {
  __typename?: 'StdProjectsResponse';
  docs: Array<StdProjectResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type StdReportDimensionGroupResponse = {
  __typename?: 'StdReportDimensionGroupResponse';
  dimensionId: Scalars['String'];
  dimensionName: Scalars['String'];
  questions: Array<StdReportQuestionResponse>;
};

export type StdReportDimensionResponse = {
  __typename?: 'StdReportDimensionResponse';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type StdReportDrillDownFrequencyResponse = {
  __typename?: 'StdReportDrillDownFrequencyResponse';
  key: Scalars['String'];
  value: Scalars['Float'];
};

export type StdReportDynamicDemographicOptionResponse = {
  __typename?: 'StdReportDynamicDemographicOptionResponse';
  _id: Scalars['String'];
  label: Scalars['String'];
};

export type StdReportDynamicDemographicResponse = {
  __typename?: 'StdReportDynamicDemographicResponse';
  _id: Scalars['String'];
  label: Scalars['String'];
  options: Array<StdReportDynamicDemographicOptionResponse>;
};

export type StdReportFilterResponse = {
  __typename?: 'StdReportFilterResponse';
  ageGroup?: Maybe<Array<Scalars['String']>>;
  businessUnit?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Array<Scalars['String']>>;
  custom1?: Maybe<Array<Scalars['String']>>;
  custom2?: Maybe<Array<Scalars['String']>>;
  custom3?: Maybe<Array<Scalars['String']>>;
  department?: Maybe<Array<Scalars['String']>>;
  experience?: Maybe<Array<Scalars['String']>>;
  gender?: Maybe<Array<Scalars['String']>>;
  location?: Maybe<Array<Scalars['String']>>;
  seniority?: Maybe<Array<Scalars['String']>>;
  tenure?: Maybe<Array<Scalars['String']>>;
};

export type StdReportParticipantsResponse = {
  __typename?: 'StdReportParticipantsResponse';
  completedCount?: Maybe<Scalars['Float']>;
  drillDownValue?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type StdReportQuestionAnswerResponse = {
  __typename?: 'StdReportQuestionAnswerResponse';
  _id: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  drilledDowns?: Maybe<Array<StdReportDrillDownFrequencyResponse>>;
  score?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  totalFrequency?: Maybe<Scalars['Float']>;
};

export type StdReportQuestionResponse = {
  __typename?: 'StdReportQuestionResponse';
  _id: Scalars['String'];
  answers: Array<StdReportQuestionAnswerResponse>;
  label: Scalars['String'];
};

export type StdReportResponse = {
  __typename?: 'StdReportResponse';
  dimensionGroups: Array<StdReportDimensionGroupResponse>;
  dimensions: Array<StdReportDimensionResponse>;
  dynamicDemographics?: Maybe<Array<StdReportDynamicDemographicResponse>>;
  filterFields?: Maybe<StdReportFilterResponse>;
  sessionsCount: Scalars['Float'];
};

export type StdSelectLocaleInput = {
  localeCode: Scalars['String'];
};

export type StdSessionDemographicAnswerResponse = {
  __typename?: 'StdSessionDemographicAnswerResponse';
  _id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type StdSessionDemographicResponse = {
  __typename?: 'StdSessionDemographicResponse';
  _id: Scalars['String'];
  answerId?: Maybe<Scalars['String']>;
  answerIds?: Maybe<Array<Scalars['String']>>;
  answerText?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<StdSessionDemographicAnswerResponse>>;
  customErrorMessage?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  multipleChoicesValidationType?: Maybe<Scalars['String']>;
  multipleChoicesValidationValue?: Maybe<Scalars['Float']>;
  order: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  shortAnswerValidation?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type StdSessionInfoArgs = {
  organizationId?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['String']>;
  stdProjectId?: InputMaybe<Scalars['String']>;
  stdPublicSessionId?: InputMaybe<Scalars['String']>;
};

export type StdSessionInfoPageDataResponse = {
  __typename?: 'StdSessionInfoPageDataResponse';
  infoPageContent: Scalars['String'];
  isPolicyApproved?: Maybe<Scalars['Boolean']>;
  isSurveyConsentRequired?: Maybe<Scalars['Boolean']>;
  policyText: Scalars['String'];
};

export type StdSessionPageDataResponse = {
  __typename?: 'StdSessionPageDataResponse';
  nextStdPageId?: Maybe<Scalars['String']>;
  prevStdPageId?: Maybe<Scalars['String']>;
  progressPercentage: Scalars['Float'];
  stdPageId: Scalars['String'];
  stdPageItems: Array<StdSessionPageItemResponse>;
};

export type StdSessionPageItemAnswerResponse = {
  __typename?: 'StdSessionPageItemAnswerResponse';
  _id: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type StdSessionPageItemLinearQuestionResponse = {
  __typename?: 'StdSessionPageItemLinearQuestionResponse';
  _id: Scalars['String'];
  dimensionName?: Maybe<Scalars['String']>;
  order: Scalars['String'];
  questionTitle?: Maybe<Scalars['String']>;
  selectedAnswerId?: Maybe<Scalars['String']>;
  subDimensionName?: Maybe<Scalars['String']>;
};

export type StdSessionPageItemResponse = {
  __typename?: 'StdSessionPageItemResponse';
  _id: Scalars['String'];
  answers: Array<StdSessionPageItemAnswerResponse>;
  infoText?: Maybe<Scalars['String']>;
  linearQuestions: Array<StdSessionPageItemLinearQuestionResponse>;
  openEndedAnswer?: Maybe<Scalars['String']>;
  openEndedDimensionName?: Maybe<Scalars['String']>;
  openEndedQuestion?: Maybe<Scalars['String']>;
  openEndedSubDimensionName?: Maybe<Scalars['String']>;
  order: Scalars['String'];
  type: Scalars['String'];
};

export type StdSessionSelectLocaleDataResponse = {
  __typename?: 'StdSessionSelectLocaleDataResponse';
  surveyDefaultLocale: Scalars['String'];
  surveyLocaleCodes: Array<Scalars['String']>;
};

export type StdSubDimensionResponse = {
  __typename?: 'StdSubDimensionResponse';
  _id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SuperAdminOrganizationResponse = {
  __typename?: 'SuperAdminOrganizationResponse';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  consumedUnits?: Maybe<Scalars['Float']>;
  domain?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  units?: Maybe<Scalars['Float']>;
};

export type SurveyCompetencyNarrativeResponse = {
  __typename?: 'SurveyCompetencyNarrativeResponse';
  text?: Maybe<Array<LocaleResponse>>;
  type: Scalars['String'];
};

export type SurveyCompetencyResponse = {
  __typename?: 'SurveyCompetencyResponse';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  definition?: Maybe<Array<LocaleResponse>>;
  name?: Maybe<Array<LocaleResponse>>;
  narratives?: Maybe<Array<SurveyCompetencyNarrativeResponse>>;
  order: Scalars['String'];
  originalCompetencyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyCompetencyWithItemsResponse = {
  __typename?: 'SurveyCompetencyWithItemsResponse';
  _id: Scalars['String'];
  competenciesItems?: Maybe<Array<CompetencyItemResponse>>;
  createdAt: Scalars['DateTime'];
  definition?: Maybe<Array<LocaleResponse>>;
  name?: Maybe<Array<LocaleResponse>>;
  narratives?: Maybe<Array<SurveyCompetencyNarrativeResponse>>;
  order: Scalars['String'];
  originalCompetencyId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  _id: Scalars['String'];
  allowBack?: Maybe<Scalars['Boolean']>;
  allowDemographics?: Maybe<Scalars['Boolean']>;
  consentRequired?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  demographicTemplateId?: Maybe<Scalars['String']>;
  demographicTemplateName?: Maybe<Scalars['String']>;
  horizontalImage?: Maybe<Scalars['String']>;
  isReadOnly?: Maybe<Scalars['Boolean']>;
  localeCodes: Array<Scalars['String']>;
  masterSurveyUnits?: Maybe<Scalars['Float']>;
  mustAnswerAll?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  responsesLayout?: Maybe<Scalars['String']>;
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  verticalImage?: Maybe<Scalars['String']>;
};

export type SurveySessionCompetencyDataResponse = {
  __typename?: 'SurveySessionCompetencyDataResponse';
  comment?: Maybe<Scalars['String']>;
  competenciesItems: Array<SurveySessionCompetencyItemResponse>;
  competencyDefinition: Scalars['String'];
  competencyId: Scalars['String'];
  competencyName: Scalars['String'];
  nextCompetencyId?: Maybe<Scalars['String']>;
  prevCompetencyId?: Maybe<Scalars['String']>;
  progressPercentage: Scalars['Float'];
};

export type SurveySessionCompetencyItemResponse = {
  __typename?: 'SurveySessionCompetencyItemResponse';
  _id: Scalars['String'];
  order: Scalars['String'];
  questionTitle: Scalars['String'];
  responses: Array<SurveySessionCompetencyItemResponseResponse>;
  selectedResponseId?: Maybe<Scalars['String']>;
  subItem?: Maybe<SessionSubItemResponse>;
};

export type SurveySessionCompetencyItemResponseResponse = {
  __typename?: 'SurveySessionCompetencyItemResponseResponse';
  _id: Scalars['String'];
  text: Scalars['String'];
};

export type SurveySessionInfoPageDataResponse = {
  __typename?: 'SurveySessionInfoPageDataResponse';
  infoPageContent: Scalars['String'];
  isPolicyApproved?: Maybe<Scalars['Boolean']>;
  isSurveyConsentRequired?: Maybe<Scalars['Boolean']>;
  policyText: Scalars['String'];
};

export type SurveySessionSelectLocaleDataResponse = {
  __typename?: 'SurveySessionSelectLocaleDataResponse';
  surveyDefaultLocale: Scalars['String'];
  surveyLocaleCodes: Array<Scalars['String']>;
};

export type SurveyWithLocalesResponse = {
  __typename?: 'SurveyWithLocalesResponse';
  _id: Scalars['String'];
  allowBack?: Maybe<Scalars['Boolean']>;
  allowDemographics?: Maybe<Scalars['Boolean']>;
  consentRequired?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  defaultLocaleCode: Scalars['String'];
  demographicTemplateId?: Maybe<Scalars['String']>;
  demographicTemplateName?: Maybe<Scalars['String']>;
  horizontalImage?: Maybe<Scalars['String']>;
  infoPageContent?: Maybe<Array<LocaleResponse>>;
  isReadOnly?: Maybe<Scalars['Boolean']>;
  localeCodes: Array<Scalars['String']>;
  masterSurveyUnits?: Maybe<Scalars['Float']>;
  mustAnswerAll?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  policyText?: Maybe<Array<LocaleResponse>>;
  primaryColor?: Maybe<Scalars['String']>;
  responsesLayout?: Maybe<Scalars['String']>;
  trashedAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  verticalImage?: Maybe<Scalars['String']>;
};

export type SurveysResponse = {
  __typename?: 'SurveysResponse';
  docs: Array<SurveyResponse>;
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  limit: Scalars['Float'];
  nextPage?: Maybe<Scalars['Float']>;
  page: Scalars['Float'];
  pagingCounter: Scalars['Float'];
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type UpdateAcmCaseStudyFileInput = {
  accessibleTo?: InputMaybe<Array<Scalars['String']>>;
  localeCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAcmCompetencyInput = {
  name: Scalars['String'];
};

export type UpdateAcmProjectCompetencyExerciseInput = {
  _id?: InputMaybe<Scalars['String']>;
  caseStudyId: Scalars['String'];
  kpiIds?: InputMaybe<Array<Scalars['String']>>;
  weightPercentage: Scalars['Float'];
};

export type UpdateAcmProjectCompetencyInput = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  definition?: InputMaybe<Scalars['String']>;
  exercises?: InputMaybe<Array<UpdateAcmProjectCompetencyExerciseInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAcmProjectInput = {
  companyName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  numOfDays?: InputMaybe<Scalars['Float']>;
  purpose?: InputMaybe<Scalars['String']>;
  scoringScale?: InputMaybe<Array<CreateAcmProjectScoringScaleInput>>;
};

export type UpdateAcmProjectParticipantInput = {
  _id: Scalars['String'];
  assessorEmails?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type UpdateAcmProjectParticipantsInput = {
  participants: Array<UpdateAcmProjectParticipantInput>;
};

export type UpdateAnswersInput = {
  _id: Scalars['String'];
  text: Scalars['String'];
};

export type UpdateCaseStudyInput = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  maxCandidates?: InputMaybe<Scalars['Float']>;
  minCandidates?: InputMaybe<Scalars['Float']>;
  performingDuration?: InputMaybe<Scalars['String']>;
  preparationDuration?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateCompetencyGroupInput = {
  _id: Scalars['String'];
  defaultLocaleCode: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
};

export type UpdateCompetencyItemInput = {
  _id: Scalars['String'];
  competencyId: Scalars['String'];
  localeCode: Scalars['String'];
  measure?: InputMaybe<Scalars['String']>;
  questionTitle: Scalars['String'];
  responseStatements?: InputMaybe<Array<UpdateCompetencyItemResponseStatementInput>>;
  responses: Array<UpdateCompetencyItemResponseInput>;
  responsesLogic?: InputMaybe<Array<UpdateCompetencyItemResponseLogicInput>>;
};

export type UpdateCompetencyItemOrderInput = {
  _id: Scalars['String'];
  competencyId: Scalars['String'];
  order: Scalars['String'];
};

export type UpdateCompetencyItemResponseInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateCompetencyItemResponseLogicInput = {
  _id?: InputMaybe<Scalars['String']>;
  responseId: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateCompetencyItemResponseLogicResponseSubItemInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateCompetencyItemResponseLogicSubItemInput = {
  _id: Scalars['String'];
  competencyId: Scalars['String'];
  competencyItemId: Scalars['String'];
  localeCode: Scalars['String'];
  questionDefinition: Scalars['String'];
  questionTitle: Scalars['String'];
  responses: Array<UpdateCompetencyItemResponseLogicResponseSubItemInput>;
};

export type UpdateCompetencyItemResponseStatementInput = {
  _id?: InputMaybe<Scalars['String']>;
  responseIds: Array<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpdateCompetencyLocaleInput = {
  competencyId: Scalars['String'];
  definition?: InputMaybe<Scalars['String']>;
  localeCode: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  narratives?: InputMaybe<Array<UpdateNarrativeInput>>;
};

export type UpdateDemographicInput = {
  answers: Array<UpdateAnswersInput>;
  customErrorMessage?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  localeCode: Scalars['String'];
  multipleChoicesValidationType?: InputMaybe<Scalars['String']>;
  multipleChoicesValidationValue?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  shortAnswerValidation?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpdateDemographicTemplateInput = {
  defaultLocaleCode?: InputMaybe<Scalars['String']>;
  localeCodes?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateKpiInput = {
  competencyIds?: InputMaybe<Array<Scalars['String']>>;
  localeCodes?: InputMaybe<Array<Scalars['String']>>;
  negativeStatement?: InputMaybe<Array<LocaleEntryInput>>;
  notes?: InputMaybe<Array<UpdateKpiNoteInput>>;
  positiveStatement?: InputMaybe<Array<LocaleEntryInput>>;
  score1Narratives?: InputMaybe<Array<UpdateKpiScoreNarrativeInput>>;
  score1NarrativesStatus?: InputMaybe<Scalars['String']>;
  score2Narratives?: InputMaybe<Array<UpdateKpiScoreNarrativeInput>>;
  score2NarrativesStatus?: InputMaybe<Scalars['String']>;
  score3Narratives?: InputMaybe<Array<UpdateKpiScoreNarrativeInput>>;
  score3NarrativesStatus?: InputMaybe<Scalars['String']>;
  score4Narratives?: InputMaybe<Array<UpdateKpiScoreNarrativeInput>>;
  score4NarrativesStatus?: InputMaybe<Scalars['String']>;
  score5Narratives?: InputMaybe<Array<UpdateKpiScoreNarrativeInput>>;
  score5NarrativesStatus?: InputMaybe<Scalars['String']>;
};

export type UpdateKpiNoteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  text: Array<LocaleEntryInput>;
};

export type UpdateKpiScoreNarrativeInput = {
  text?: InputMaybe<Array<LocaleEntryInput>>;
};

export type UpdateMasterProductAssessmentInput = {
  _id?: InputMaybe<Scalars['String']>;
  adsAssessmentName: Scalars['String'];
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type UpdateMasterProductInput = {
  assessments: Array<UpdateMasterProductAssessmentInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Float']>;
};

export type UpdateMemberOrInvitationInput = {
  _id: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateMembersOrInvitationsInput = {
  entries: Array<UpdateMemberOrInvitationInput>;
};

export type UpdateMyProfileInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateNarrativeInput = {
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpdateOrganizationAccessInput = {
  assessmentModule?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  surveyModule?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationInput = {
  adsApiKey?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProductAssessmentInput = {
  _id?: InputMaybe<Scalars['String']>;
  adsAssessmentName: Scalars['String'];
  assessmentId: Scalars['String'];
  assessmentName: Scalars['String'];
};

export type UpdateProductInput = {
  assessments: Array<UpdateProductAssessmentInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateProductNarrativeInput = {
  content?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<Scalars['String']>;
  indicatorId?: InputMaybe<Scalars['String']>;
  langCode?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectInput = {
  color: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateProjectSelfRaterDateInput = {
  endDate: Scalars['DateTime'];
};

export type UpdateSelfRaterParticipantInput = {
  email?: InputMaybe<Scalars['String']>;
  participantId: Scalars['String'];
  participantTypeId?: InputMaybe<Scalars['String']>;
};

export type UpdateStandardSurveyPageInput = {
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['String']>;
};

export type UpdateStdPageItemAnswerInput = {
  _id?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateStdPageItemInput = {
  _id: Scalars['String'];
  answers?: InputMaybe<Array<UpdateStdPageItemAnswerInput>>;
  dimensionId?: InputMaybe<Scalars['String']>;
  infoText?: InputMaybe<Scalars['String']>;
  localeCode: Scalars['String'];
  questionTitle?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<UpdateStdPageItemQuestionInput>>;
  subDimensionId?: InputMaybe<Scalars['String']>;
};

export type UpdateStdPageItemOrderInput = {
  _id: Scalars['String'];
  order: Scalars['String'];
};

export type UpdateStdPageItemQuestionInput = {
  _id?: InputMaybe<Scalars['String']>;
  dimensionId?: InputMaybe<Scalars['String']>;
  isInverted?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['String']>;
  subDimensionId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateStdProjectInput = {
  color: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateStdProjectSessionInput = {
  ageGroup?: InputMaybe<Scalars['String']>;
  businessUnit?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  custom1?: InputMaybe<Scalars['String']>;
  custom2?: InputMaybe<Scalars['String']>;
  custom3?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  tenure?: InputMaybe<Scalars['String']>;
};

export type UpdateSurveyCompetencyItemInput = {
  _id: Scalars['String'];
  localeCode: Scalars['String'];
  measure?: InputMaybe<Scalars['String']>;
  questionTitle: Scalars['String'];
  responseStatements?: InputMaybe<Array<UpdateSurveyCompetencyItemResponseStatementInput>>;
  responses: Array<UpdateSurveyCompetencyItemResponseInput>;
  responsesLogic?: InputMaybe<Array<UpdateSurveyCompetencyItemResponseLogicInput>>;
  surveyCompetencyId: Scalars['String'];
};

export type UpdateSurveyCompetencyItemOrderInput = {
  _id: Scalars['String'];
  order: Scalars['String'];
};

export type UpdateSurveyCompetencyItemResponseInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateSurveyCompetencyItemResponseLogicInput = {
  _id?: InputMaybe<Scalars['String']>;
  responseId: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateSurveyCompetencyItemResponseLogicResponseSubItemInput = {
  _id: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateSurveyCompetencyItemResponseLogicSubItemInput = {
  _id: Scalars['String'];
  competencyItemId: Scalars['String'];
  localeCode: Scalars['String'];
  questionDefinition: Scalars['String'];
  questionTitle: Scalars['String'];
  responses: Array<UpdateSurveyCompetencyItemResponseLogicResponseSubItemInput>;
  surveyCompetencyId: Scalars['String'];
};

export type UpdateSurveyCompetencyItemResponseStatementInput = {
  _id?: InputMaybe<Scalars['String']>;
  responseIds: Array<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpdateSurveyCompetencyLocaleInput = {
  definition?: InputMaybe<Scalars['String']>;
  localeCode: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  narratives?: InputMaybe<Array<UpdateSurveyCompetencyNarrativeInput>>;
  surveyCompetencyId: Scalars['String'];
};

export type UpdateSurveyCompetencyNarrativeInput = {
  text?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type UpdateSurveyInput = {
  allowBack?: InputMaybe<Scalars['Boolean']>;
  allowDemographics?: InputMaybe<Scalars['Boolean']>;
  consentRequired?: InputMaybe<Scalars['Boolean']>;
  defaultLocaleCode?: InputMaybe<Scalars['String']>;
  demographicTemplateId?: InputMaybe<Scalars['String']>;
  localeCodes?: InputMaybe<Array<Scalars['String']>>;
  masterSurveyUnits?: InputMaybe<Scalars['Float']>;
  mustAnswerAll?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  responsesLayout?: InputMaybe<Scalars['String']>;
};

export type UpdateSurveyLocaleInput = {
  infoPageContent?: InputMaybe<Scalars['String']>;
  localeCode: Scalars['String'];
  policyText?: InputMaybe<Scalars['String']>;
  withLocaleCodes: Array<Scalars['String']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  _id: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  superAdminOrganizationId?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type VerifyInput = {
  userId: Scalars['String'];
  verificationCode: Scalars['Float'];
  verificationToken: Scalars['String'];
};

export type CreateAcmCompetencyMutationVariables = Exact<{
  input: CreateAcmCompetencyInput;
  organizationId: Scalars['String'];
}>;


export type CreateAcmCompetencyMutation = { __typename?: 'Mutation', createAcmCompetency: { __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null } };

export type DeleteAcmCompetencyMutationVariables = Exact<{
  acmCompetencyId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type DeleteAcmCompetencyMutation = { __typename?: 'Mutation', deleteAcmCompetency: { __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null } };

export type UpdateAcmCompetencyMutationVariables = Exact<{
  input: UpdateAcmCompetencyInput;
  acmCompetencyId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type UpdateAcmCompetencyMutation = { __typename?: 'Mutation', updateAcmCompetency: { __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null } };

export type AcmCompetenciesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type AcmCompetenciesQuery = { __typename?: 'Query', acmCompetencies: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> };

export type SearchAcmCompetenciesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchAcmCompetenciesArgs;
}>;


export type SearchAcmCompetenciesQuery = { __typename?: 'Query', searchAcmCompetencies: { __typename?: 'AcmCompetenciesResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> } };

export type CreateAcmProjectCompetencyMutationVariables = Exact<{
  acmProjectId: Scalars['String'];
  input: CreateAcmProjectCompetencyInput;
  organizationId: Scalars['String'];
}>;


export type CreateAcmProjectCompetencyMutation = { __typename?: 'Mutation', createAcmProjectCompetency: { __typename?: 'AcmProjectCompetencyResponse', _id: string, name?: string | null, definition?: string | null, createdAt: any, competencies?: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> | null, exercises?: Array<{ __typename?: 'AcmProjectCompetencyExerciseResponse', _id: string, caseStudyId: string, kpiIds?: Array<string> | null, weightPercentage: number }> | null } };

export type DeleteAcmProjectCompetencyMutationVariables = Exact<{
  acmProjectCompetencyId: Scalars['String'];
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type DeleteAcmProjectCompetencyMutation = { __typename?: 'Mutation', deleteAcmProjectCompetency: { __typename?: 'AcmProjectCompetencyResponse', _id: string, name?: string | null, definition?: string | null, createdAt: any, competencies?: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> | null, exercises?: Array<{ __typename?: 'AcmProjectCompetencyExerciseResponse', _id: string, caseStudyId: string, kpiIds?: Array<string> | null, weightPercentage: number }> | null } };

export type UpdateAcmProjectCompetencyMutationVariables = Exact<{
  acmProjectCompetencyId: Scalars['String'];
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
  input: UpdateAcmProjectCompetencyInput;
}>;


export type UpdateAcmProjectCompetencyMutation = { __typename?: 'Mutation', updateAcmProjectCompetency: { __typename?: 'AcmProjectCompetencyResponse', _id: string, name?: string | null, definition?: string | null, createdAt: any, competencies?: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> | null, exercises?: Array<{ __typename?: 'AcmProjectCompetencyExerciseResponse', _id: string, caseStudyId: string, kpiIds?: Array<string> | null, weightPercentage: number }> | null } };

export type AcmProjectCompetencyKpisQueryVariables = Exact<{
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
  acmProjectCompetencyId: Scalars['String'];
  caseStudyId: Scalars['String'];
}>;


export type AcmProjectCompetencyKpisQuery = { __typename?: 'Query', acmProjectCompetencyKpis: Array<{ __typename?: 'KpiResponse', _id: string, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, type: string, updatedAt?: any | null, competencyIds?: Array<string> | null, createdAt: any, localeCodes: Array<string>, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> };

export type SearchAcmProjectCompetenciesQueryVariables = Exact<{
  acmProjectId: Scalars['String'];
  args: SearchAcmProjectCompetenciesArgs;
  organizationId: Scalars['String'];
}>;


export type SearchAcmProjectCompetenciesQuery = { __typename?: 'Query', searchAcmProjectCompetencies: { __typename?: 'AcmProjectCompetenciesResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AcmProjectCompetencyResponse', _id: string, name?: string | null, definition?: string | null, createdAt: any, competencies?: Array<{ __typename?: 'AcmCompetencyResponse', _id: string, name?: string | null }> | null, exercises?: Array<{ __typename?: 'AcmProjectCompetencyExerciseResponse', _id: string, caseStudyId: string, kpiIds?: Array<string> | null, weightPercentage: number }> | null }> } };

export type CreateAcmProjectMutationVariables = Exact<{
  companyImageFile?: InputMaybe<Scalars['Upload']>;
  input: CreateAcmProjectInput;
  organizationId: Scalars['String'];
}>;


export type CreateAcmProjectMutation = { __typename?: 'Mutation', createAcmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type DeleteAcmProjectMutationVariables = Exact<{
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type DeleteAcmProjectMutation = { __typename?: 'Mutation', deleteAcmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type RestoreAcmProjectMutationVariables = Exact<{
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type RestoreAcmProjectMutation = { __typename?: 'Mutation', restoreAcmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type TrashAcmProjectMutationVariables = Exact<{
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type TrashAcmProjectMutation = { __typename?: 'Mutation', trashAcmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type UpdateAcmProjectMutationVariables = Exact<{
  companyImageFile?: InputMaybe<Scalars['Upload']>;
  input: UpdateAcmProjectInput;
  organizationId: Scalars['String'];
  acmProjectId: Scalars['String'];
}>;


export type UpdateAcmProjectMutation = { __typename?: 'Mutation', updateAcmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type AcmProjectQueryVariables = Exact<{
  acmProjectId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type AcmProjectQuery = { __typename?: 'Query', acmProject: { __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null } };

export type SearchAcmProjectsQueryVariables = Exact<{
  args: SearchAcmProjectsArgs;
  organizationId: Scalars['String'];
}>;


export type SearchAcmProjectsQuery = { __typename?: 'Query', searchAcmProjects: { __typename?: 'AcmProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null }> } };

export type SearchTrashedAcmProjectsQueryVariables = Exact<{
  args: SearchAcmProjectsArgs;
  organizationId: Scalars['String'];
}>;


export type SearchTrashedAcmProjectsQuery = { __typename?: 'Query', searchTrashedAcmProjects: { __typename?: 'AcmProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AcmProjectResponse', _id: string, companyImage?: string | null, companyName: string, createdAt: any, name: string, numOfDays: number, purpose: string, scoringScale?: Array<{ __typename?: 'AcmProjectScoringScaleResponse', color: string, from: number, name: string, to: number }> | null }> } };

export type DeleteAdsApiKeyMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type DeleteAdsApiKeyMutation = { __typename?: 'Mutation', deleteAdsApiKey: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SetAdsApiKeyMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type SetAdsApiKeyMutation = { __typename?: 'Mutation', setAdsApiKey: string };

export type AdsApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type AdsApiKeyQuery = { __typename?: 'Query', adsApiKey?: string | null };

export type ForgetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgetPasswordMutation = { __typename?: 'Mutation', forgetPassword: { __typename?: 'ForgetPasswordResponse', message: string, success: boolean, userId: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'RefreshTokenResponse', accessToken: string, refreshToken: string } };

export type ResendVerificationMutationVariables = Exact<{
  userId: Scalars['String'];
  verificationToken: Scalars['String'];
}>;


export type ResendVerificationMutation = { __typename?: 'Mutation', resendVerification: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  resetPasswordCode: Scalars['Float'];
  userId: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ResetPasswordViaTokenMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ResetPasswordViaTokenMutation = { __typename?: 'Mutation', resetPasswordViaToken: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SendResetPasswordEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type SigninMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SigninMutation = { __typename?: 'Mutation', signin: { __typename?: 'SigninResponse', userId?: string | null, accessToken?: string | null, refreshToken?: string | null, isVerified: boolean, verificationToken?: string | null } };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'SignupResponse', message: string, success: boolean, userId: string, verificationToken: string } };

export type UpdateMyProfileMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateMyProfileInput;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile: { __typename?: 'UserResponse', _id: string, email: string, firstName?: string | null, lastName?: string | null, image?: string | null, timezone?: string | null, isSuperAdmin?: boolean | null, superAdminOrganizationId?: string | null } };

export type VerifyAccountMutationVariables = Exact<{
  userId: Scalars['String'];
  verificationCode: Scalars['Float'];
  verificationToken: Scalars['String'];
}>;


export type VerifyAccountMutation = { __typename?: 'Mutation', verifyAccount: { __typename?: 'SigninResponse', accessToken?: string | null, isVerified: boolean, refreshToken?: string | null, userId?: string | null, verificationToken?: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UserResponse', _id: string, firstName?: string | null, lastName?: string | null, email: string, image?: string | null, timezone?: string | null, isSuperAdmin?: boolean | null, superAdminOrganizationId?: string | null } };

export type TimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezonesQuery = { __typename?: 'Query', timezones: Array<string> };

export type CreateCaseStudyFileMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  file: Scalars['Upload'];
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
  input: CreateAcmCaseStudyFileInput;
}>;


export type CreateCaseStudyFileMutation = { __typename?: 'Mutation', createCaseStudyFile: { __typename?: 'AcmCaseStudyFileResponse', _id: string, name: string, path: string, type?: string | null, size?: number | null, localeCode: string, accessibleTo: Array<string>, createdAt: any, thumbnailPath?: string | null } };

export type DeleteCaseStudyFileMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  caseFileId: Scalars['String'];
}>;


export type DeleteCaseStudyFileMutation = { __typename?: 'Mutation', deleteCaseStudyFile: { __typename?: 'AcmCaseStudyFileResponse', _id: string, name: string, path: string, type?: string | null, size?: number | null, localeCode: string, accessibleTo: Array<string>, thumbnailPath?: string | null, createdAt: any } };

export type UpdateCaseStudyFileMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  caseFileId: Scalars['String'];
  input: UpdateAcmCaseStudyFileInput;
}>;


export type UpdateCaseStudyFileMutation = { __typename?: 'Mutation', updateCaseStudyFile: { __typename?: 'AcmCaseStudyFileResponse', _id: string, name: string, path: string, type?: string | null, size?: number | null, localeCode: string, accessibleTo: Array<string>, thumbnailPath?: string | null, createdAt: any } };

export type SearchAcmCaseFilesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  args: SearchAcmCaseFileArgs;
}>;


export type SearchAcmCaseFilesQuery = { __typename?: 'Query', searchAcmCaseFiles: { __typename?: 'AcmCaseStudyFilesResponse', totalDocs: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, docs: Array<{ __typename?: 'AcmCaseStudyFileResponse', _id: string, createdAt: any, accessibleTo: Array<string>, localeCode: string, name: string, path: string, size?: number | null, thumbnailPath?: string | null, type?: string | null }> } };

export type CreateCaseStudyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: CreateCaseStudyInput;
}>;


export type CreateCaseStudyMutation = { __typename?: 'Mutation', createCaseStudy: { __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any } };

export type TrashCaseStudyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
}>;


export type TrashCaseStudyMutation = { __typename?: 'Mutation', trashCaseStudy: { __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any } };

export type UpdateCaseStudyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  input: UpdateCaseStudyInput;
}>;


export type UpdateCaseStudyMutation = { __typename?: 'Mutation', updateCaseStudy: { __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any } };

export type CaseStudyQueryVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
}>;


export type CaseStudyQuery = { __typename?: 'Query', caseStudy: { __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any } };

export type SearchCaseStudiesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchCaseStudiesArgs;
}>;


export type SearchCaseStudiesQuery = { __typename?: 'Query', searchCaseStudies: { __typename?: 'CaseStudiesResponse', totalDocs: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, docs: Array<{ __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any }> } };

export type SearchTrashedCaseStudiesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchCaseStudiesArgs;
}>;


export type SearchTrashedCaseStudiesQuery = { __typename?: 'Query', searchTrashedCaseStudies: { __typename?: 'CaseStudiesResponse', totalDocs: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, docs: Array<{ __typename?: 'CaseStudyResponse', _id: string, title: string, description?: string | null, type: string, maxCandidates?: number | null, minCandidates?: number | null, competencyIds?: Array<string> | null, performingDuration?: string | null, preparationDuration?: string | null, createdAt: any }> } };

export type DeleteCaseStudyKpiMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  competencyId: Scalars['String'];
  caseStudyKpiId: Scalars['String'];
}>;


export type DeleteCaseStudyKpiMutation = { __typename?: 'Mutation', deleteCaseStudyKpi: { __typename?: 'CaseStudyKpiResponse', _id: string, order: string, kpi: { __typename?: 'KpiResponse', _id: string, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, type: string, updatedAt?: any | null, createdAt: any, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } } };

export type LinkKpisWithCaseStudyAndCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  input: LinkKpisWithCaseStudyAndCompetencyInput;
}>;


export type LinkKpisWithCaseStudyAndCompetencyMutation = { __typename?: 'Mutation', linkKpisWithCaseStudyAndCompetency: Array<{ __typename?: 'CaseStudyKpiResponse', _id: string, order: string, kpi: { __typename?: 'KpiResponse', _id: string, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, type: string, updatedAt?: any | null, createdAt: any, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } }> };

export type UpdateCaseStudyKpiOrderMutationVariables = Exact<{
  organizationId: Scalars['String'];
  order: Scalars['String'];
  competencyId: Scalars['String'];
  caseStudyId: Scalars['String'];
  caseStudyKpiId: Scalars['String'];
}>;


export type UpdateCaseStudyKpiOrderMutation = { __typename?: 'Mutation', updateCaseStudyKpiOrder: { __typename?: 'CaseStudyKpiResponse', _id: string, order: string, kpi: { __typename?: 'KpiResponse', _id: string, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, type: string, updatedAt?: any | null, createdAt: any, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } } };

export type CaseStudyKpisQueryVariables = Exact<{
  organizationId: Scalars['String'];
  caseStudyId: Scalars['String'];
  competencyId?: InputMaybe<Scalars['String']>;
}>;


export type CaseStudyKpisQuery = { __typename?: 'Query', caseStudyKpis: Array<{ __typename?: 'CaseStudyKpiResponse', _id: string, order: string, kpi: { __typename?: 'KpiResponse', _id: string, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } }> };

export type CreateCompetencyGroupMutationVariables = Exact<{
  organizationId: Scalars['String'];
  name: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
  defaultLocaleCode: Scalars['String'];
}>;


export type CreateCompetencyGroupMutation = { __typename?: 'Mutation', createCompetencyGroup: { __typename?: 'CompetencyGroupWithChildrenResponse', _id: string, name: string, definition: string, defaultLocaleCode: string, localeCodes: Array<string>, competenciesCount?: number | null, createdAt: any, updatedAt: any, competencies?: Array<{ __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null } };

export type UpdateCompetencyGroupMutationVariables = Exact<{
  organizationId: Scalars['String'];
  _id: Scalars['String'];
  name: Scalars['String'];
  definition: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
  defaultLocaleCode: Scalars['String'];
}>;


export type UpdateCompetencyGroupMutation = { __typename?: 'Mutation', updateCompetencyGroup: { __typename?: 'CompetencyGroupResponse', _id: string, name: string, definition: string, defaultLocaleCode: string, localeCodes: Array<string>, createdAt: any, updatedAt: any } };

export type CompetencyGroupQueryVariables = Exact<{
  _id: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type CompetencyGroupQuery = { __typename?: 'Query', competencyGroup: { __typename?: 'CompetencyGroupWithChildrenResponse', _id: string, name: string, definition: string, localeCodes: Array<string>, defaultLocaleCode: string, createdAt: any, updatedAt: any } };

export type SearchCompetencyGroupsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
}>;


export type SearchCompetencyGroupsQuery = { __typename?: 'Query', searchCompetencyGroups: { __typename?: 'CompetencyGroupsResponse', page: number, limit: number, hasNextPage: boolean, hasPrevPage: boolean, nextPage?: number | null, prevPage?: number | null, pagingCounter: number, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'CompetencyGroupWithChildrenResponse', _id: string, name: string, definition: string, defaultLocaleCode: string, localeCodes: Array<string>, competenciesCount?: number | null, createdAt: any, updatedAt: any, competencies?: Array<{ __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null }> } };

export type SearchCompetencyGroupsWithAllCompetenciesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  localeCode?: InputMaybe<Scalars['String']>;
}>;


export type SearchCompetencyGroupsWithAllCompetenciesQuery = { __typename?: 'Query', searchCompetencyGroupsWithAllCompetencies: { __typename?: 'CompetencyGroupsResponse', page: number, limit: number, hasNextPage: boolean, hasPrevPage: boolean, nextPage?: number | null, prevPage?: number | null, pagingCounter: number, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'CompetencyGroupWithChildrenResponse', _id: string, name: string, definition: string, defaultLocaleCode: string, localeCodes: Array<string>, competenciesCount?: number | null, createdAt: any, updatedAt: any, competencies?: Array<{ __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null }> } };

export type CreateCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
}>;


export type CreateCompetencyMutation = { __typename?: 'Mutation', createCompetency: { __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type DeleteCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteCompetencyMutation = { __typename?: 'Mutation', deleteCompetency: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DuplicateCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  _id: Scalars['String'];
  competencyGroupId: Scalars['String'];
}>;


export type DuplicateCompetencyMutation = { __typename?: 'Mutation', duplicateCompetency: { __typename?: 'CompetencyWithItemsResponse', _id: string, createdAt: any, updatedAt?: any | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, competenciesItems?: Array<{ __typename?: 'CompetencyItemResponse', _id: string, createdAt: any, measure?: string | null, order: string, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } | null }> | null }> | null } };

export type TrashCompetencyGroupMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
}>;


export type TrashCompetencyGroupMutation = { __typename?: 'Mutation', trashCompetencyGroup: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type UpdateCompetencyLocaleMutationVariables = Exact<{
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyLocaleInput;
  localeCodes: Array<Scalars['String']> | Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type UpdateCompetencyLocaleMutation = { __typename?: 'Mutation', updateCompetencyLocale: { __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type CompetenciesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type CompetenciesQuery = { __typename?: 'Query', competencies: Array<{ __typename?: 'CompetencyWithItemsResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, competenciesItems?: Array<{ __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null }> };

export type CreateCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  input: CreateCompetencyItemInput;
}>;


export type CreateCompetencyItemMutation = { __typename?: 'Mutation', createCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type CreateSurveyCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: CreateSurveyCompetencyItemInput;
  surveyId: Scalars['String'];
}>;


export type CreateSurveyCompetencyItemMutation = { __typename?: 'Mutation', createSurveyCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type DeleteCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  input: DeleteCompetencyItemInput;
}>;


export type DeleteCompetencyItemMutation = { __typename?: 'Mutation', deleteCompetencyItem: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DeleteSurveyCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: DeleteSurveyCompetencyItemInput;
}>;


export type DeleteSurveyCompetencyItemMutation = { __typename?: 'Mutation', deleteSurveyCompetencyItem: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DuplicateCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  _id: Scalars['String'];
  competencyId: Scalars['String'];
  newCompetencyItemOrder: Scalars['String'];
}>;


export type DuplicateCompetencyItemMutation = { __typename?: 'Mutation', duplicateCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, createdAt: any, measure?: string | null, order: string, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } | null }> | null } };

export type DuplicateSurveyCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  _id: Scalars['String'];
  surveyCompetencyId: Scalars['String'];
  newSurveyCompetencyItemOrder: Scalars['String'];
}>;


export type DuplicateSurveyCompetencyItemMutation = { __typename?: 'Mutation', duplicateSurveyCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, createdAt: any, measure?: string | null, order: string, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } | null }> | null } };

export type UpdateCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemInput;
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateCompetencyItemMutation = { __typename?: 'Mutation', updateCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateCompetencyItemOrderMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemOrderInput;
}>;


export type UpdateCompetencyItemOrderMutation = { __typename?: 'Mutation', updateCompetencyItemOrder: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateSurveyCompetencyItemMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: UpdateSurveyCompetencyItemInput;
  surveyId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateSurveyCompetencyItemMutation = { __typename?: 'Mutation', updateSurveyCompetencyItem: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateSurveyCompetencyItemOrderMutationVariables = Exact<{
  input: UpdateSurveyCompetencyItemOrderInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type UpdateSurveyCompetencyItemOrderMutation = { __typename?: 'Mutation', updateSurveyCompetencyItemOrder: { __typename?: 'CompetencyItemResponse', _id: string, measure?: string | null, order: string, createdAt: any, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateCompetencyItemResponseLogicMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
  input: UpdateCompetencyItemResponseLogicSubItemInput;
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateCompetencyItemResponseLogicMutation = { __typename?: 'Mutation', updateCompetencyItemResponseLogic: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateSurveyCompetencyItemResponseLogicMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: UpdateSurveyCompetencyItemResponseLogicSubItemInput;
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateSurveyCompetencyItemResponseLogicMutation = { __typename?: 'Mutation', updateSurveyCompetencyItemResponseLogic: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type CreateDemographicMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  input: CreateDemographicInput;
}>;


export type CreateDemographicMutation = { __typename?: 'Mutation', createDemographic: { __typename?: 'DemographicResponse', _id: string, createdAt: any, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answers?: Array<{ __typename?: 'DemographicAnswerResponse', _id?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, label?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, customErrorMessage?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null } };

export type CreateDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: CreateDemographicTemplateInput;
}>;


export type CreateDemographicTemplateMutation = { __typename?: 'Mutation', createDemographicTemplate: { __typename?: 'DemographicTemplateResponse', _id: string, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, updatedAt: any } };

export type DeleteDemographicMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type DeleteDemographicMutation = { __typename?: 'Mutation', deleteDemographic: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DuplicateDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type DuplicateDemographicTemplateMutation = { __typename?: 'Mutation', duplicateDemographicTemplate: { __typename?: 'DemographicTemplateWithCountResponse', _id: string, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, trashedAt?: any | null, updatedAt: any, demographicsCount: number } };

export type TrashDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type TrashDemographicTemplateMutation = { __typename?: 'Mutation', trashDemographicTemplate: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type UpdateDemographicMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  input: UpdateDemographicInput;
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateDemographicMutation = { __typename?: 'Mutation', updateDemographic: { __typename?: 'DemographicResponse', _id: string, createdAt: any, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answers?: Array<{ __typename?: 'DemographicAnswerResponse', _id?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, label?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, customErrorMessage?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null } };

export type UpdateDemographicOrderMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  order: Scalars['String'];
}>;


export type UpdateDemographicOrderMutation = { __typename?: 'Mutation', updateDemographicOrder: { __typename?: 'DemographicResponse', _id: string, createdAt: any, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answers?: Array<{ __typename?: 'DemographicAnswerResponse', _id?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, label?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, customErrorMessage?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null } };

export type UpdateDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  input: UpdateDemographicTemplateInput;
}>;


export type UpdateDemographicTemplateMutation = { __typename?: 'Mutation', updateDemographicTemplate: { __typename?: 'DemographicTemplateResponse', _id: string, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, updatedAt: any } };

export type DemographicTemplateQueryVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type DemographicTemplateQuery = { __typename?: 'Query', demographicTemplate: { __typename?: 'DemographicTemplateResponse', _id: string, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, updatedAt: any } };

export type DemographicsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type DemographicsQuery = { __typename?: 'Query', demographics: Array<{ __typename?: 'DemographicResponse', _id: string, createdAt: any, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answers?: Array<{ __typename?: 'DemographicAnswerResponse', _id?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, customErrorMessage?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, label?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> };

export type SearchDemographicTemplatesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchDemographicTemplatesArgs;
}>;


export type SearchDemographicTemplatesQuery = { __typename?: 'Query', searchDemographicTemplates: { __typename?: 'DemographicTemplatesWithCountResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'DemographicTemplateWithCountResponse', _id: string, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, updatedAt: any, demographicsCount: number }> } };

export type CreateKpiMutationVariables = Exact<{
  input: CreateKpiInput;
  organizationId: Scalars['String'];
}>;


export type CreateKpiMutation = { __typename?: 'Mutation', createKpi: { __typename?: 'KpiResponse', _id: string, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } };

export type DeleteKpiMutationVariables = Exact<{
  kpiId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type DeleteKpiMutation = { __typename?: 'Mutation', deleteKpi: { __typename?: 'KpiResponse', _id: string, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } };

export type UpdateKpiMutationVariables = Exact<{
  input: UpdateKpiInput;
  kpiId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type UpdateKpiMutation = { __typename?: 'Mutation', updateKpi: { __typename?: 'KpiResponse', _id: string, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } };

export type KpiQueryVariables = Exact<{
  organizationId: Scalars['String'];
  kpiId: Scalars['String'];
}>;


export type KpiQuery = { __typename?: 'Query', kpi: { __typename?: 'KpiResponse', _id: string, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null } };

export type SearchKpisQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchKpisArgs;
}>;


export type SearchKpisQuery = { __typename?: 'Query', searchKpis: { __typename?: 'KpisResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'KpiResponse', _id: string, type: string, competencyIds?: Array<string> | null, localeCodes: Array<string>, score1NarrativesStatus?: string | null, score2NarrativesStatus?: string | null, score3NarrativesStatus?: string | null, score4NarrativesStatus?: string | null, score5NarrativesStatus?: string | null, updatedAt?: any | null, createdAt: any, score1Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score2Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score3Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score4Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, score5Narratives?: Array<{ __typename?: 'KpiScoreNarrativeResponse', _id: string, text?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> | null, negativeStatement: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }>, notes?: Array<{ __typename?: 'KpiNoteResponse', _id: string, createdAt?: any | null, text: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> }> | null, positiveStatement?: Array<{ __typename?: 'LocaleEntryResponse', localeCode: string, text?: string | null }> | null }> } };

export type CreateSelfRaterParticipantsMutationVariables = Exact<{
  input: CreateSelfRaterParticipantsInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type CreateSelfRaterParticipantsMutation = { __typename?: 'Mutation', createSelfRaterParticipants: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DeleteSelfRaterParticipantMutationVariables = Exact<{
  participantId: Scalars['String'];
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type DeleteSelfRaterParticipantMutation = { __typename?: 'Mutation', deleteSelfRaterParticipant: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ImportParticipantsCsvMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  participantsCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type ImportParticipantsCsvMutation = { __typename?: 'Mutation', importParticipantsCsv: Array<{ __typename?: 'ParticipantsCsvResponse', email: string, participantTypeId: string }> };

export type UpdateSelfRaterParticipantMutationVariables = Exact<{
  input: UpdateSelfRaterParticipantInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type UpdateSelfRaterParticipantMutation = { __typename?: 'Mutation', updateSelfRaterParticipant: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DownloadParticipantsCsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadParticipantsCsvTemplateQuery = { __typename?: 'Query', downloadParticipantsCsvTemplate: string };

export type DownloadStdParticipantsCsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadStdParticipantsCsvTemplateQuery = { __typename?: 'Query', downloadStdParticipantsCsvTemplate: string };

export type DeleteMasterProductIndicatorMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteMasterProductIndicatorMutation = { __typename?: 'Mutation', deleteMasterProductIndicator: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DeleteProductIndicatorMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteProductIndicatorMutation = { __typename?: 'Mutation', deleteProductIndicator: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ExportMasterProductIndicatorsCsvTemplateMutationVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type ExportMasterProductIndicatorsCsvTemplateMutation = { __typename?: 'Mutation', exportMasterProductIndicatorsCsvTemplate: string };

export type ExportProductIndicatorsCsvTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
}>;


export type ExportProductIndicatorsCsvTemplateMutation = { __typename?: 'Mutation', exportProductIndicatorsCsvTemplate: string };

export type ImportMasterProductIndicatorsCsvTemplateMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  ProductIndicatorsCsv: Scalars['Upload'];
}>;


export type ImportMasterProductIndicatorsCsvTemplateMutation = { __typename?: 'Mutation', importMasterProductIndicatorsCsvTemplate: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type ImportProductIndicatorsCsvTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  ProductIndicatorsCsv: Scalars['Upload'];
}>;


export type ImportProductIndicatorsCsvTemplateMutation = { __typename?: 'Mutation', importProductIndicatorsCsvTemplate: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type SetMasterProductIndicatorsMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  input: Array<SetProductIndicatorInput> | SetProductIndicatorInput;
}>;


export type SetMasterProductIndicatorsMutation = { __typename?: 'Mutation', setMasterProductIndicators: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type SetProductIndicatorsMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  input: Array<SetProductIndicatorInput> | SetProductIndicatorInput;
}>;


export type SetProductIndicatorsMutation = { __typename?: 'Mutation', setProductIndicators: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type DownloadProductIndicatorsCsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadProductIndicatorsCsvTemplateQuery = { __typename?: 'Query', downloadProductIndicatorsCsvTemplate: string };

export type MasterProductIndicatorsQueryVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type MasterProductIndicatorsQuery = { __typename?: 'Query', masterProductIndicators: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type ProductIndicatorsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
}>;


export type ProductIndicatorsQuery = { __typename?: 'Query', productIndicators: Array<{ __typename?: 'ProductIndicatorResponse', _id: string, fromScore: number, name: string, toScore: number }> };

export type CreateMasterProductNarrativeMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  input: CreateProductNarrativeInput;
}>;


export type CreateMasterProductNarrativeMutation = { __typename?: 'Mutation', createMasterProductNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type CreateProductNarrativeMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  input: CreateProductNarrativeInput;
}>;


export type CreateProductNarrativeMutation = { __typename?: 'Mutation', createProductNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type DeleteMasterProductNarrativeMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteMasterProductNarrativeMutation = { __typename?: 'Mutation', deleteMasterProductNarrative: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DeleteProductNarrativeMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteProductNarrativeMutation = { __typename?: 'Mutation', deleteProductNarrative: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ExportMasterProductNarrativesCsvTemplateMutationVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type ExportMasterProductNarrativesCsvTemplateMutation = { __typename?: 'Mutation', exportMasterProductNarrativesCsvTemplate: string };

export type ExportProductNarrativesCsvTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
}>;


export type ExportProductNarrativesCsvTemplateMutation = { __typename?: 'Mutation', exportProductNarrativesCsvTemplate: string };

export type ImportMasterProductNarrativeCsvTemplateMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  productNarrativesCsv: Scalars['Upload'];
}>;


export type ImportMasterProductNarrativeCsvTemplateMutation = { __typename?: 'Mutation', importMasterProductNarrativeCsvTemplate: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ImportProductNarrativeCsvTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productNarrativesCsv: Scalars['Upload'];
}>;


export type ImportProductNarrativeCsvTemplateMutation = { __typename?: 'Mutation', importProductNarrativeCsvTemplate: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type UpdateMasterProductNarrativeMutationVariables = Exact<{
  masterProductId: Scalars['String'];
  _id: Scalars['String'];
  input: UpdateProductNarrativeInput;
}>;


export type UpdateMasterProductNarrativeMutation = { __typename?: 'Mutation', updateMasterProductNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type UpdateProductNarrativeMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  _id: Scalars['String'];
  input: UpdateProductNarrativeInput;
}>;


export type UpdateProductNarrativeMutation = { __typename?: 'Mutation', updateProductNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type DownloadProductNarrativesCsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadProductNarrativesCsvTemplateQuery = { __typename?: 'Query', downloadProductNarrativesCsvTemplate: string };

export type MasterProductNarrativeQueryVariables = Exact<{
  _id: Scalars['String'];
  masterProductId: Scalars['String'];
}>;


export type MasterProductNarrativeQuery = { __typename?: 'Query', masterProductNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type ProductNarrativeQueryVariables = Exact<{
  organizationId: Scalars['String'];
  _id: Scalars['String'];
  productId: Scalars['String'];
}>;


export type ProductNarrativeQuery = { __typename?: 'Query', productNarrative: { __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null } };

export type SearchMasterProductNarrativesQueryVariables = Exact<{
  args: SearchProductNarrativeArgs;
  masterProductId: Scalars['String'];
}>;


export type SearchMasterProductNarrativesQuery = { __typename?: 'Query', searchMasterProductNarratives: { __typename?: 'ProductNarrativesResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null }> } };

export type SearchProductNarrativesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchProductNarrativeArgs;
  productId: Scalars['String'];
}>;


export type SearchProductNarrativesQuery = { __typename?: 'Query', searchProductNarratives: { __typename?: 'ProductNarrativesResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProductNarrativeResponse', _id: string, content?: string | null, dimension?: string | null, indicatorId?: string | null, langCode?: string | null, order?: string | null, type?: string | null }> } };

export type CreateMasterProductMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: CreateMasterProductInput;
}>;


export type CreateMasterProductMutation = { __typename?: 'Mutation', createMasterProduct: { __typename?: 'MasterProductResponse', _id: string, createdAt: any, description: string, image?: string | null, name: string, type: string, units: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type CreateProductMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: CreateProductInput;
  organizationId: Scalars['String'];
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductResponse', _id: string, createdAt: any, description: string, image?: string | null, name: string, type: string, masterProductId?: string | null, isSent: boolean, units: number, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type ProductLinkGeneratorMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: LinkGeneratorInput;
  candidatesCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type ProductLinkGeneratorMutation = { __typename?: 'Mutation', productLinkGenerator: string };

export type ResendProductSessionMutationVariables = Exact<{
  assessmentId: Scalars['String'];
  email: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
  withNewToken?: InputMaybe<Scalars['Boolean']>;
  resendEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type ResendProductSessionMutation = { __typename?: 'Mutation', resendProductSession: string };

export type SendBulkProductsMutationVariables = Exact<{
  input: SendProductsInput;
  organizationId: Scalars['String'];
  candidatesCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type SendBulkProductsMutation = { __typename?: 'Mutation', sendBulkProducts: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SendProductsToIndividualMutationVariables = Exact<{
  input: SendProductsToIndividualInput;
  organizationId: Scalars['String'];
}>;


export type SendProductsToIndividualMutation = { __typename?: 'Mutation', sendProductsToIndividual: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type TrashMasterProductMutationVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type TrashMasterProductMutation = { __typename?: 'Mutation', trashMasterProduct: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type TrashProductMutationVariables = Exact<{
  productId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type TrashProductMutation = { __typename?: 'Mutation', trashProduct: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type UpdateMasterProductMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateMasterProductInput;
  masterProductId: Scalars['String'];
}>;


export type UpdateMasterProductMutation = { __typename?: 'Mutation', updateMasterProduct: { __typename?: 'MasterProductResponse', _id: string, createdAt: any, description: string, image?: string | null, name: string, type: string, units: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type UpdateProductMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateProductInput;
  productId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'ProductResponse', _id: string, createdAt: any, description: string, image?: string | null, name: string, type: string, masterProductId?: string | null, isSent: boolean, units: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type AssignedAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedAssessmentsQuery = { __typename?: 'Query', assignedAssessments: Array<{ __typename?: 'AssignedAssessmentResponse', _id: string, productId: string, productName: string, productImage?: string | null, assessmentLink?: string | null, expiryDate?: any | null, isExpired?: boolean | null }> };

export type DownloadBulkSenderTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadBulkSenderTemplateQuery = { __typename?: 'Query', downloadBulkSenderTemplate: string };

export type DownloadLinksGeneratorTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadLinksGeneratorTemplateQuery = { __typename?: 'Query', downloadLinksGeneratorTemplate: string };

export type MasterProductQueryVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type MasterProductQuery = { __typename?: 'Query', masterProduct: { __typename?: 'MasterProductWithNarrativesCountResponse', _id: string, createdAt: any, name: string, type: string, units: number, image?: string | null, description: string, narrativesCount: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type OrganizationAdsAssessmentsQueryVariables = Exact<{
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
  organizationId: Scalars['String'];
}>;


export type OrganizationAdsAssessmentsQuery = { __typename?: 'Query', organizationAdsAssessments: { __typename?: 'AdsAssessmentsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AdsAssessmentResponse', _id: string, name?: string | null, displayName?: string | null, image?: string | null }> } };

export type ProductQueryVariables = Exact<{
  productId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'ProductResponseWithNarrativesCount', _id: string, createdAt: any, name: string, type: string, units: number, image?: string | null, description: string, masterProductId?: string | null, isSent: boolean, narrativesCount: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null } };

export type SearchMasterProductsQueryVariables = Exact<{
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
}>;


export type SearchMasterProductsQuery = { __typename?: 'Query', searchMasterProducts: { __typename?: 'MasterProductsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'MasterProductResponse', _id: string, createdAt: any, name: string, type: string, units: number, image?: string | null, description: string, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> } };

export type SearchProductsQueryVariables = Exact<{
  args: SearchProductArgs;
  organizationId: Scalars['String'];
}>;


export type SearchProductsQuery = { __typename?: 'Query', searchProducts: { __typename?: 'ProductsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProductResponse', _id: string, createdAt: any, name: string, type: string, units: number, image?: string | null, description: string, masterProductId?: string | null, isSent: boolean, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> } };

export type CreateProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: string };

export type CreateStdProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: CreateProjectInput;
}>;


export type CreateStdProjectMutation = { __typename?: 'Mutation', createStdProject: string };

export type DeleteStdProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type DeleteStdProjectMutation = { __typename?: 'Mutation', deleteStdProject: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteStdReportsMutationVariables = Exact<{
  organizationId: Scalars['String'];
  stdReportsIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteStdReportsMutation = { __typename?: 'Mutation', deleteStdReports: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type ExtendStdProjectEndDateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  endDate: Scalars['DateTime'];
}>;


export type ExtendStdProjectEndDateMutation = { __typename?: 'Mutation', extendStdProjectEndDate: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreStdProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type RestoreStdProjectMutation = { __typename?: 'Mutation', restoreStdProject: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type Send360ProjectViaCsvMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: SendProjectViaCsvInput;
  selfRatersCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type Send360ProjectViaCsvMutation = { __typename?: 'Mutation', send360ProjectViaCsv: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SendProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: SendProjectInput;
}>;


export type SendProjectMutation = { __typename?: 'Mutation', sendProject: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type SendStdProject2MutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  sendStdProjectInput: SendStdProjectInput;
  participantsCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type SendStdProject2Mutation = { __typename?: 'Mutation', sendStdProject2: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type SetProjectSettingsMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: SetProjectSettingsInput;
}>;


export type SetProjectSettingsMutation = { __typename?: 'Mutation', setProjectSettings: { __typename?: 'ProjectSettingsResponse', _id: string, globalSubject?: string | null, globalBody?: string | null, unifyEmailForAll: boolean, restrictLogin?: boolean | null, selfRaterSubject?: string | null, selfRaterBody?: string | null, participantTypes: Array<{ __typename?: 'ParticipantTypeResponse', _id: string, name: string }>, participantEmailTemplates?: Array<{ __typename?: 'ParticipantEmailTemplateResponse', _id: string, subject?: string | null, body?: string | null, participantTypeId: string }> | null } };

export type SetStdProjectSettingsMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: SetStdProjectSettingsInput;
}>;


export type SetStdProjectSettingsMutation = { __typename?: 'Mutation', setStdProjectSettings: { __typename?: 'StdProjectSettingsResponse', _id: string, globalSubject?: string | null, globalBody?: string | null, restrictLogin?: boolean | null, allowPublicLink?: boolean | null, showDimensions?: boolean | null } };

export type SyncStdProjectTypoMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type SyncStdProjectTypoMutation = { __typename?: 'Mutation', syncStdProjectTypo: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type TrashStdProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type TrashStdProjectMutation = { __typename?: 'Mutation', trashStdProject: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type UpdateProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'ProjectResponse', _id: string, color: string, createdAt: any, name: string, surveyId: string, surveyName: string, surveyType: string, localeCodes?: Array<string> | null, updatedAt: any } };

export type UpdateStdProjectMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: UpdateStdProjectInput;
}>;


export type UpdateStdProjectMutation = { __typename?: 'Mutation', updateStdProject: { __typename?: 'StdProjectResponse', _id: string, color: string, createdAt: any, name: string, stdSurveyId: string, stdSurveyName: string, stdSurveyType: string, trashedAt?: any | null, updatedAt: any } };

export type UpdateStdProjectSessionMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  stdProjectSessionId: Scalars['String'];
  input: UpdateStdProjectSessionInput;
}>;


export type UpdateStdProjectSessionMutation = { __typename?: 'Mutation', updateStdProjectSession: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type CountStdSessionsWithTrashedOptionQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type CountStdSessionsWithTrashedOptionQuery = { __typename?: 'Query', countStdSessionsWithTrashedOption: number };

export type DownloadProject360CsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadProject360CsvTemplateQuery = { __typename?: 'Query', downloadProject360CsvTemplate: string };

export type IsProjectNameExistQueryVariables = Exact<{
  organizationId: Scalars['String'];
  name: Scalars['String'];
}>;


export type IsProjectNameExistQuery = { __typename?: 'Query', isProjectNameExist: boolean };

export type IsStdProjectNameExistQueryVariables = Exact<{
  organizationId: Scalars['String'];
  name: Scalars['String'];
}>;


export type IsStdProjectNameExistQuery = { __typename?: 'Query', isStdProjectNameExist: boolean };

export type ProjectQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ProjectQuery = { __typename?: 'Query', project: { __typename?: 'ProjectResponse', _id: string, color: string, createdAt: any, name: string, surveyId: string, surveyName: string, surveyType: string, localeCodes?: Array<string> | null, updatedAt: any } };

export type ProjectSettingsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ProjectSettingsQuery = { __typename?: 'Query', projectSettings?: { __typename?: 'ProjectSettingsResponse', _id: string, globalSubject?: string | null, globalBody?: string | null, unifyEmailForAll: boolean, restrictLogin?: boolean | null, selfRaterSubject?: string | null, selfRaterBody?: string | null, participantTypes: Array<{ __typename?: 'ParticipantTypeResponse', _id: string, name: string }>, participantEmailTemplates?: Array<{ __typename?: 'ParticipantEmailTemplateResponse', _id: string, subject?: string | null, body?: string | null, participantTypeId: string }> | null } | null };

export type SearchProjectsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchProjectsArgs;
}>;


export type SearchProjectsQuery = { __typename?: 'Query', searchProjects: { __typename?: 'ProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProjectResponse', _id: string, color: string, createdAt: any, name: string, surveyId: string, surveyName: string, surveyType: string, localeCodes?: Array<string> | null, updatedAt: any }> } };

export type SearchStdProjectReportsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchStdReportsArgs;
}>;


export type SearchStdProjectReportsQuery = { __typename?: 'Query', searchStdProjectReports: { __typename?: 'SearchStdReportsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'SearchStdReportResponse', _id: string, stdSurveyId: string, updatedAt: any, createdAt: any, createdById: string, firstName: string, image: string, lastName: string, link: string, size: string, stdProjectId: string, stdProjectName: string }> } };

export type SearchStdProjectSessionsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  args: SearchProjectSessionsArgs;
}>;


export type SearchStdProjectSessionsQuery = { __typename?: 'Query', searchStdProjectSessions: { __typename?: 'StdProjectSessionsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'StdProjectSessionResponse', _id: string, email?: string | null, expiryDate?: any | null, image?: string | null, isCompleted?: boolean | null, name?: string | null, businessUnit?: string | null, ageGroup?: string | null, city?: string | null, custom1?: string | null, custom2?: string | null, custom3?: string | null, department?: string | null, experience?: string | null, location?: string | null, seniority?: string | null, tenure?: string | null, gender?: string | null }> } };

export type SearchStdProjectsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchStdProjectsArgs;
}>;


export type SearchStdProjectsQuery = { __typename?: 'Query', searchStdProjects: { __typename?: 'StdProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'StdProjectResponse', _id: string, color: string, createdAt: any, name: string, stdSurveyId: string, stdSurveyName: string, trashedAt?: any | null, stdSurveyType: string, updatedAt: any }> } };

export type SearchStdSurveyProjectsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchStdProjectsArgs;
  surveyId: Scalars['String'];
}>;


export type SearchStdSurveyProjectsQuery = { __typename?: 'Query', searchStdSurveyProjects: { __typename?: 'StdProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'StdProjectResponse', _id: string, color: string, createdAt: any, name: string, stdSurveyId: string, stdSurveyName: string, stdSurveyType: string, trashedAt?: any | null, updatedAt: any }> } };

export type SearchSurveyProjectsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchProjectsArgs;
  surveyId: Scalars['String'];
}>;


export type SearchSurveyProjectsQuery = { __typename?: 'Query', searchSurveyProjects: { __typename?: 'ProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProjectResponse', _id: string, color: string, createdAt: any, name: string, surveyId: string, surveyName: string, surveyType: string, localeCodes?: Array<string> | null, updatedAt: any }> } };

export type SearchTrashedStdProjectsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: SearchStdProjectsArgs;
}>;


export type SearchTrashedStdProjectsQuery = { __typename?: 'Query', searchTrashedStdProjects: { __typename?: 'StdProjectsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'StdProjectResponse', _id: string, color: string, createdAt: any, name: string, stdSurveyId: string, stdSurveyName: string, stdSurveyType: string, trashedAt?: any | null, updatedAt: any }> } };

export type StdProjectQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type StdProjectQuery = { __typename?: 'Query', stdProject: { __typename?: 'StdProjectResponse', _id: string, color: string, createdAt: any, name: string, stdSurveyId: string, stdSurveyName: string, stdSurveyType: string, trashedAt?: any | null, updatedAt: any } };

export type StdProjectHeatmapReportQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs> | StdProjectReportDynamicDemographicsArgs>;
  dimensionsFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  allowPercentageHeatMap?: InputMaybe<Scalars['Boolean']>;
  percentageHeatMapCutOff?: InputMaybe<Scalars['Float']>;
}>;


export type StdProjectHeatmapReportQuery = { __typename?: 'Query', stdProjectHeatmapReport: Array<{ __typename?: 'HeatmapMatrixRowResponse', dimensionId: string, dimensionName: string, drillDowns: Array<{ __typename?: 'HeatmapMatrixRowDrillDownResponse', key: string, markedAs: string, value: number }> }> };

export type StdProjectParticipantsReportQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs> | StdProjectReportDynamicDemographicsArgs>;
}>;


export type StdProjectParticipantsReportQuery = { __typename?: 'Query', stdProjectParticipantsReport: Array<{ __typename?: 'StdReportParticipantsResponse', completedCount?: number | null, drillDownValue?: string | null, totalCount?: number | null }> };

export type StdProjectReportQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  drillDownBy?: InputMaybe<StdProjectReportDrillDownArgs>;
  dynamicDemographicsFilter?: InputMaybe<Array<StdProjectReportDynamicDemographicsArgs> | StdProjectReportDynamicDemographicsArgs>;
  filterBy?: InputMaybe<StdProjectReportFilterArgs>;
  dimensionsFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type StdProjectReportQuery = { __typename?: 'Query', stdProjectReport: { __typename?: 'StdReportResponse', sessionsCount: number, filterFields?: { __typename?: 'StdReportFilterResponse', ageGroup?: Array<string> | null, seniority?: Array<string> | null, tenure?: Array<string> | null, businessUnit?: Array<string> | null, city?: Array<string> | null, custom1?: Array<string> | null, custom2?: Array<string> | null, custom3?: Array<string> | null, department?: Array<string> | null, experience?: Array<string> | null, gender?: Array<string> | null, location?: Array<string> | null } | null, dimensions: Array<{ __typename?: 'StdReportDimensionResponse', _id: string, name: string }>, dynamicDemographics?: Array<{ __typename?: 'StdReportDynamicDemographicResponse', _id: string, label: string, options: Array<{ __typename?: 'StdReportDynamicDemographicOptionResponse', _id: string, label: string }> }> | null, dimensionGroups: Array<{ __typename?: 'StdReportDimensionGroupResponse', dimensionId: string, dimensionName: string, questions: Array<{ __typename?: 'StdReportQuestionResponse', _id: string, label: string, answers: Array<{ __typename?: 'StdReportQuestionAnswerResponse', _id: string, color?: string | null, score?: number | null, text?: string | null, totalFrequency?: number | null, drilledDowns?: Array<{ __typename?: 'StdReportDrillDownFrequencyResponse', key: string, value: number }> | null }> }> }> } };

export type StdProjectReportDetailsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type StdProjectReportDetailsQuery = { __typename?: 'Query', stdProjectReportDetails: { __typename?: 'StdProjectReportDetailsResponse', completedParticipants?: number | null, expirationDate?: any | null, qualitativeItems?: number | null, quantitativeItems?: number | null, totalParticipants?: number | null, dimensions?: Array<{ __typename?: 'StdProjectReportDetailsDimensionResponse', _id?: string | null, name?: string | null }> | null } };

export type StdProjectSettingsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type StdProjectSettingsQuery = { __typename?: 'Query', stdProjectSettings?: { __typename?: 'StdProjectSettingsResponse', _id: string, globalSubject?: string | null, globalBody?: string | null, restrictLogin?: boolean | null, allowPublicLink?: boolean | null, showDimensions?: boolean | null } | null };

export type GetSystemLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemLanguagesQuery = { __typename?: 'Query', getSystemLanguages: Array<{ __typename?: 'LanguageResponse', code: string, name: string, nativeName: string, dir: string }> };

export type GenerateProductPdfReportMutationVariables = Exact<{
  email: Scalars['String'];
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
}>;


export type GenerateProductPdfReportMutation = { __typename?: 'Mutation', generateProductPdfReport?: string | null };

export type GenerateProductReportMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  startAt?: InputMaybe<Scalars['DateTime']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type GenerateProductReportMutation = { __typename?: 'Mutation', generateProductReport: string };

export type GenerateSingleProductAssessmentReportMutationVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  adsAssessmentId: Scalars['String'];
}>;


export type GenerateSingleProductAssessmentReportMutation = { __typename?: 'Mutation', generateSingleProductAssessmentReport: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type GenerateStdProjectCsvReportMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GenerateStdProjectCsvReportMutation = { __typename?: 'Mutation', generateStdProjectCsvReport: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type GenerateStdProjectTokensMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  input: GenerateStdProjectTokensInput;
  participantsCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type GenerateStdProjectTokensMutation = { __typename?: 'Mutation', generateStdProjectTokens: string };

export type UpdateProductSessionMutationVariables = Exact<{
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
}>;


export type UpdateProductSessionMutation = { __typename?: 'Mutation', updateProductSession: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type GenerateMyProductReportQueryVariables = Exact<{
  organizationId: Scalars['String'];
  productId: Scalars['String'];
  productSendId: Scalars['String'];
}>;


export type GenerateMyProductReportQuery = { __typename?: 'Query', generateMyProductReport: string };

export type MyProductReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProductReportsQuery = { __typename?: 'Query', myProductReports: Array<{ __typename?: 'MyProductReportResponse', groupId: string, organizationId: string, productId: string, productSendId: string, organizationName?: string | null, organizationImage?: string | null, productName?: string | null, productImage?: string | null }> };

export type ProductEmailReportsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: ProductEmailReportsArgs;
}>;


export type ProductEmailReportsQuery = { __typename?: 'Query', productEmailReports: { __typename?: 'ProductEmailReportsResponse', hasNextPage: boolean, hasPrevPage: boolean, page: number, limit: number, pagingCounter: number, prevPage?: number | null, nextPage?: number | null, totalPages: number, totalDocs: number, docs: Array<{ __typename?: 'ProductEmailReportResponse', _id: string, createdAt: any, email: string, productId: string, productImage?: string | null, productName?: string | null, updatedAt: any, isProductDeleted?: boolean | null, productSendId: string, firstName?: string | null, lastName?: string | null, userSessions?: Array<{ __typename?: 'ProductEmailReportUserSessionResponse', _id: string, adsAssessmentName?: string | null, assessmentId?: string | null, assessmentName?: string | null, isCompleted?: boolean | null, assessmentLink?: string | null }> | null }> } };

export type ProjectRawScores360QueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ProjectRawScores360Query = { __typename?: 'Query', projectRawScores360: string };

export type Report360DataForManySelfRatersQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
}>;


export type Report360DataForManySelfRatersQuery = { __typename?: 'Query', report360DataForManySelfRaters: string };

export type Report360DataQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type Report360DataQuery = { __typename?: 'Query', report360Data: { __typename?: 'DynamicReport360', actualRatersDescription: string, selfRaterName: string, skillSignificantGraph: Array<Array<Array<string>>>, startDate: any, summary: string, surveyDuration: string, completed: number, completedPercentage: number, endDate: any, isSelfRaterCompleted: boolean, noCompleted: number, projectName: string, competencies: Array<{ __typename?: 'Competency360ReportResponse', col: number, totalSelfRaterSkillMean: number, definition?: string | null, name?: string | null, row: number, selfRaterSignificantMean: number, selfRaterSkillMean: number, totalSelfRaterAgreement?: string | null, totalSelfRaterSignificantMean: number, narratives: Array<{ __typename?: 'Narrative360ReportResponse', text?: string | null, type: string }>, participantsSkillAndSignificant: Array<{ __typename?: 'ParticipantsSkillAndSignificant', agreement?: string | null, keyInsights?: string | null, potentialUse?: string | null, significantMean: number, skillMean: number, typeName: string }> }>, competenciesComments?: Array<{ __typename?: 'CompetencyComments360ReportResponse', name: string, participants?: Array<{ __typename?: 'ParticipantsComments', comments?: Array<string> | null, name: string }> | null }> | null, additionalComments?: Array<{ __typename?: 'ParticipantTypeInsights', comments?: Array<string> | null, participantTypeId: string, participantTypeName: string }> | null, areasForDevelopment?: Array<{ __typename?: 'ParticipantTypeInsights', comments?: Array<string> | null, participantTypeId: string, participantTypeName: string }> | null, strengths?: Array<{ __typename?: 'ParticipantTypeInsights', comments?: Array<string> | null, participantTypeId: string, participantTypeName: string }> | null, participantsStatusAsGroup: Array<{ __typename?: 'ParticipantsTypeGroup', type: string, participantsStatus: Array<{ __typename?: 'ParticipantStatus', completed: boolean, email: string }> }> } };

export type Report360PdfQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type Report360PdfQuery = { __typename?: 'Query', report360Pdf: string };

export type SelfRaterRawScores360QueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type SelfRaterRawScores360Query = { __typename?: 'Query', selfRaterRawScores360: string };

export type UpdateSelfRaterEndDateMutationVariables = Exact<{
  input: UpdateProjectSelfRaterDateInput;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type UpdateSelfRaterEndDateMutation = { __typename?: 'Mutation', updateSelfRaterEndDate: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SearchSelfRatersQueryVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  args: SearchSelfRatersArgs;
}>;


export type SearchSelfRatersQuery = { __typename?: 'Query', searchSelfRaters: { __typename?: 'SelfRatersResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'SearchSelfRaterResponse', _id: string, email: string, endDate: any, image?: string | null, name: string, userId?: string | null, completedParticipants?: number | null, totalParticipants?: number | null }> } };

export type SelfRaterQueryVariables = Exact<{
  organizationId: Scalars['String'];
  _id: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type SelfRaterQuery = { __typename?: 'Query', selfRater: { __typename?: 'SelfRaterResponse', _id: string, email: string, endDate: any, image?: string | null, name: string, isCompleted?: boolean | null, sendDate: any, participants: Array<{ __typename?: 'ParticipantResponse', _id: string, email: string, image?: string | null, name?: string | null, participantType: string, participantTypeId: string, userId?: string | null, isCompleted?: boolean | null }> } };

export type CancelJoiningRequestMutationVariables = Exact<{
  joinRequestId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type CancelJoiningRequestMutation = { __typename?: 'Mutation', cancelJoiningRequest: { __typename?: 'JoinRequestResponse', _id: string, organizationId: string, userId: string, createdAt: any, userEmail?: string | null, userImage?: string | null, userName?: string | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
  image?: InputMaybe<Scalars['Upload']>;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'MyOrganizationResponse', _id: string, name: string, image?: string | null, domain?: string | null, units?: number | null, adsApiKey?: string | null, active: boolean, access?: { __typename?: 'MyOrganizationAccessResponse', assessmentModule?: boolean | null, surveyModule?: boolean | null } | null } };

export type GenerateUniqueDomainMutationVariables = Exact<{
  organizationName: Scalars['String'];
}>;


export type GenerateUniqueDomainMutation = { __typename?: 'Mutation', generateUniqueDomain: string };

export type JoinOrganizationMutationVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type JoinOrganizationMutation = { __typename?: 'Mutation', joinOrganization: { __typename?: 'JoinRequestResponse', _id: string, organizationId: string, userId: string, createdAt: any, userEmail?: string | null, userImage?: string | null, userName?: string | null } };

export type JoinOrganizationViaInvitationMutationVariables = Exact<{
  invitationToken: Scalars['String'];
}>;


export type JoinOrganizationViaInvitationMutation = { __typename?: 'Mutation', joinOrganizationViaInvitation: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type RejectJoinRequestMutationVariables = Exact<{
  joinRequestId: Scalars['String'];
  organizationId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RejectJoinRequestMutation = { __typename?: 'Mutation', rejectJoinRequest: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: UpdateOrganizationInput;
  image?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'MyOrganizationWithJobTitleResponse', _id: string, name: string, image?: string | null, jobTitle?: string | null, domain?: string | null, units?: number | null, adsApiKey?: string | null, active: boolean, access?: { __typename?: 'MyOrganizationAccessResponse', assessmentModule?: boolean | null, surveyModule?: boolean | null } | null } };

export type UpdateOrganizationAccessMutationVariables = Exact<{
  input: UpdateOrganizationAccessInput;
}>;


export type UpdateOrganizationAccessMutation = { __typename?: 'Mutation', updateOrganizationAccess: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type MyJoiningRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyJoiningRequestsQuery = { __typename?: 'Query', myJoiningRequests: Array<{ __typename?: 'JoinRequestResponse', _id: string, organizationId: string, userId: string, createdAt: any, userEmail?: string | null, userImage?: string | null, userName?: string | null }> };

export type MyOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type MyOrganizationQuery = { __typename?: 'Query', myOrganization: { __typename?: 'MyOrganizationWithJobTitleResponse', _id: string, name: string, image?: string | null, jobTitle?: string | null, domain?: string | null, units?: number | null, adsApiKey?: string | null, active: boolean, access?: { __typename?: 'MyOrganizationAccessResponse', assessmentModule?: boolean | null, surveyModule?: boolean | null } | null } };

export type MyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationsQuery = { __typename?: 'Query', myOrganizations: Array<{ __typename?: 'MyOrganizationResponse', _id: string, name: string, image?: string | null, domain?: string | null, units?: number | null, adsApiKey?: string | null, active: boolean, access?: { __typename?: 'MyOrganizationAccessResponse', assessmentModule?: boolean | null, surveyModule?: boolean | null } | null }> };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'SuperAdminOrganizationResponse', _id: string, name: string, image?: string | null, domain?: string | null, active: boolean, units?: number | null, consumedUnits?: number | null } };

export type SearchOrganizationsQueryVariables = Exact<{
  name: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type SearchOrganizationsQuery = { __typename?: 'Query', searchOrganizations: { __typename?: 'OrganizationsResponse', page: number, limit: number, pagingCounter: number, totalDocs: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean, nextPage?: number | null, prevPage?: number | null, docs: Array<{ __typename?: 'OrganizationResponse', _id: string, name: string, image?: string | null }> } };

export type CreateStandardSurveyPageMutationVariables = Exact<{
  input: CreateStandardSurveyPageInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type CreateStandardSurveyPageMutation = { __typename?: 'Mutation', createStandardSurveyPage: { __typename?: 'StandardSurveyPageResponse', _id: string, name?: string | null, order?: string | null } };

export type CreateStdPageItemMutationVariables = Exact<{
  input: CreateStdPageItemInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  stdPageId: Scalars['String'];
}>;


export type CreateStdPageItemMutation = { __typename?: 'Mutation', createStdPageItem: { __typename?: 'StdPageItemResponse', _id: string, createdAt: any, dimensionId?: string | null, order: string, subDimensionId?: string | null, type: string, updatedAt?: any | null, answers?: Array<{ __typename?: 'StdPageItemAnswerResponse', _id: string, color?: string | null, score?: number | null, value?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, infoText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questions?: Array<{ __typename?: 'StdPageItemQuestionResponse', _id: string, dimensionId?: string | null, isInverted?: boolean | null, order?: string | null, subDimensionId?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type DeleteStandardSurveyPageMutationVariables = Exact<{
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type DeleteStandardSurveyPageMutation = { __typename?: 'Mutation', deleteStandardSurveyPage: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DeleteStdPageItemMutationVariables = Exact<{
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  stdPageId: Scalars['String'];
}>;


export type DeleteStdPageItemMutation = { __typename?: 'Mutation', deleteStdPageItem: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ImportStdAnswersFromCsvMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  stdAnswersCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type ImportStdAnswersFromCsvMutation = { __typename?: 'Mutation', importStdAnswersFromCsv: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ImportStdQuestionsFromCsvMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  stdQuestionsCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type ImportStdQuestionsFromCsvMutation = { __typename?: 'Mutation', importStdQuestionsFromCsv: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type SetStandardSurveyDimensionsMutationVariables = Exact<{
  input: SetStandardDimensionsInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type SetStandardSurveyDimensionsMutation = { __typename?: 'Mutation', setStandardSurveyDimensions: Array<{ __typename?: 'StdDimensionResponse', _id: string, name: string, subDimensions: Array<{ __typename?: 'StdSubDimensionResponse', _id: string, name?: string | null }> }> };

export type UpdateStandardSurveyPageMutationVariables = Exact<{
  _id: Scalars['String'];
  input: UpdateStandardSurveyPageInput;
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type UpdateStandardSurveyPageMutation = { __typename?: 'Mutation', updateStandardSurveyPage: { __typename?: 'StandardSurveyPageResponse', _id: string, name?: string | null, order?: string | null } };

export type UpdateStdPageItemMutationVariables = Exact<{
  input: UpdateStdPageItemInput;
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateStdPageItemMutation = { __typename?: 'Mutation', updateStdPageItem: { __typename?: 'StdPageItemResponse', _id: string, createdAt: any, dimensionId?: string | null, order: string, subDimensionId?: string | null, type: string, updatedAt?: any | null, answers?: Array<{ __typename?: 'StdPageItemAnswerResponse', _id: string, color?: string | null, score?: number | null, value?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, infoText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questions?: Array<{ __typename?: 'StdPageItemQuestionResponse', _id: string, dimensionId?: string | null, isInverted?: boolean | null, order?: string | null, subDimensionId?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateStdPageItemOrderMutationVariables = Exact<{
  input: UpdateStdPageItemOrderInput;
  organizationId: Scalars['String'];
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type UpdateStdPageItemOrderMutation = { __typename?: 'Mutation', updateStdPageItemOrder: { __typename?: 'StdPageItemResponse', _id: string, createdAt: any, dimensionId?: string | null, order: string, subDimensionId?: string | null, type: string, updatedAt?: any | null, answers?: Array<{ __typename?: 'StdPageItemAnswerResponse', _id: string, color?: string | null, score?: number | null, value?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, infoText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questions?: Array<{ __typename?: 'StdPageItemQuestionResponse', _id: string, dimensionId?: string | null, isInverted?: boolean | null, order?: string | null, subDimensionId?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type ExportStdQuestionsAndAnswersToCsvQueryVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type ExportStdQuestionsAndAnswersToCsvQuery = { __typename?: 'Query', exportStdQuestionsAndAnswersToCsv: { __typename?: 'ExportStdQuestionsAndAnswersCsvResponse', stdAnswersCsv: string, stdQuestionsCsv: string } };

export type StandardSurveyDimensionsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type StandardSurveyDimensionsQuery = { __typename?: 'Query', standardSurveyDimensions: Array<{ __typename?: 'StdDimensionResponse', _id: string, name: string, subDimensions: Array<{ __typename?: 'StdSubDimensionResponse', _id: string, name?: string | null }> }> };

export type StandardSurveyPageQueryVariables = Exact<{
  _id: Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type StandardSurveyPageQuery = { __typename?: 'Query', standardSurveyPage: { __typename?: 'StandardSurveyPageResponse', _id: string, name?: string | null, order?: string | null } };

export type StandardSurveyPagesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type StandardSurveyPagesQuery = { __typename?: 'Query', standardSurveyPages: Array<{ __typename?: 'StandardSurveyPageResponse', _id: string, name?: string | null, order?: string | null }> };

export type StdPageItemsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  query: StdPageItemArgs;
  stdPageId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type StdPageItemsQuery = { __typename?: 'Query', stdPageItems: Array<{ __typename?: 'StdPageItemResponse', _id: string, createdAt: any, dimensionId?: string | null, order: string, subDimensionId?: string | null, type: string, updatedAt?: any | null, answers?: Array<{ __typename?: 'StdPageItemAnswerResponse', _id: string, color?: string | null, score?: number | null, value?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, infoText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questions?: Array<{ __typename?: 'StdPageItemQuestionResponse', _id: string, dimensionId?: string | null, isInverted?: boolean | null, order?: string | null, subDimensionId?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> };

export type StdPagesWithPageItemsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type StdPagesWithPageItemsQuery = { __typename?: 'Query', stdPagesWithPageItems: Array<{ __typename?: 'StandardSurveyPageWithItemsResponse', _id: string, name?: string | null, order?: string | null, stdPageItems: Array<{ __typename?: 'StdPageItemResponse', _id: string, createdAt: any, dimensionId?: string | null, order: string, subDimensionId?: string | null, type: string, updatedAt?: any | null, answers?: Array<{ __typename?: 'StdPageItemAnswerResponse', _id: string, color?: string | null, score?: number | null, value?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, infoText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questions?: Array<{ __typename?: 'StdPageItemQuestionResponse', _id: string, dimensionId?: string | null, isInverted?: boolean | null, order?: string | null, subDimensionId?: string | null, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> }> };

export type AddUnitsMutationVariables = Exact<{
  input: AddUnitsInput;
}>;


export type AddUnitsMutation = { __typename?: 'Mutation', addUnits: { __typename?: 'OrganizationResponse', _id: string, domain?: string | null, active: boolean, image?: string | null, units?: number | null, name: string } };

export type LinkProductsToOrganizationMutationVariables = Exact<{
  masterProductsIds: Array<Scalars['String']> | Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type LinkProductsToOrganizationMutation = { __typename?: 'Mutation', linkProductsToOrganization: Array<{ __typename?: 'ProductResponse', _id: string, createdAt: any, description: string, image?: string | null, isSent: boolean, masterProductId?: string | null, name: string, trashedAt?: any | null, type: string, units: number, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> };

export type SuperAdminGenerateUniqueDomainMutationVariables = Exact<{
  organizationName: Scalars['String'];
}>;


export type SuperAdminGenerateUniqueDomainMutation = { __typename?: 'Mutation', superAdminGenerateUniqueDomain: string };

export type SuperAdminUpdateOrganizationMutationVariables = Exact<{
  image?: InputMaybe<Scalars['Upload']>;
  input: UpdateOrganizationInput;
  organizationId: Scalars['String'];
}>;


export type SuperAdminUpdateOrganizationMutation = { __typename?: 'Mutation', superAdminUpdateOrganization: { __typename?: 'MyOrganizationWithJobTitleResponse', _id: string, active: boolean, adsApiKey?: string | null, domain?: string | null, image?: string | null, jobTitle?: string | null, name: string, units?: number | null, access?: { __typename?: 'MyOrganizationAccessResponse', assessmentModule?: boolean | null, surveyModule?: boolean | null } | null } };

export type ToggleOrganizationActivationMutationVariables = Exact<{
  active: Scalars['Boolean'];
  organizationId: Scalars['String'];
}>;


export type ToggleOrganizationActivationMutation = { __typename?: 'Mutation', toggleOrganizationActivation: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type TransferMasterSurveysMutationVariables = Exact<{
  masterSurveyIds: Array<Scalars['String']> | Scalars['String'];
  transfereeOrganizationId: Scalars['String'];
}>;


export type TransferMasterSurveysMutation = { __typename?: 'Mutation', transferMasterSurveys: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type OrganizationAssignableProductsQueryVariables = Exact<{
  args: PaginationArgs;
  organizationId: Scalars['String'];
}>;


export type OrganizationAssignableProductsQuery = { __typename?: 'Query', organizationAssignableProducts: { __typename?: 'MasterProductsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'MasterProductResponse', _id: string, createdAt: any, description: string, image?: string | null, name: string, trashedAt?: any | null, type: string, units: number, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> } };

export type SuperAdminAdsAssessmentsQueryVariables = Exact<{
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
}>;


export type SuperAdminAdsAssessmentsQuery = { __typename?: 'Query', superAdminAdsAssessments: { __typename?: 'AdsAssessmentsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'AdsAssessmentResponse', _id: string, name?: string | null, displayName?: string | null, image?: string | null }> } };

export type SuperAdminOrganizationsQueryVariables = Exact<{
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
}>;


export type SuperAdminOrganizationsQuery = { __typename?: 'Query', superAdminOrganizations: { __typename?: 'OrganizationsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'OrganizationResponse', _id: string, name: string, domain?: string | null, active: boolean, image?: string | null, units?: number | null }> } };

export type AnswerCompetencyItemMutationVariables = Exact<{
  input: AnswerCompetencyItemInput;
  sessionToken: Scalars['String'];
}>;


export type AnswerCompetencyItemMutation = { __typename?: 'Mutation', answerCompetencyItem: { __typename?: 'AnswerCompetencyItemResponse', competencyItemId: string, responseId: string, subItem?: { __typename?: 'SessionSubItemResponse', _id: string, questionTitle: string, questionDefinition?: string | null, selectedResponseId?: string | null, responses: Array<{ __typename?: 'SessionSubItemResponseResponse', _id: string, text: string }> } | null } };

export type AnswerStdSessionDemographicMutationVariables = Exact<{
  input: AnswerStdSessionDemographicInput;
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type AnswerStdSessionDemographicMutation = { __typename?: 'Mutation', answerStdSessionDemographic: { __typename?: 'AnswerStdSessionDemographicResponse', answerId?: string | null, answerIds?: Array<string> | null, answerText?: string | null, demographicId: string } };

export type AnswerStdSessionOpenEndedQuestionMutationVariables = Exact<{
  input: AnswerStdSessionOpenEndedQuestionInput;
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type AnswerStdSessionOpenEndedQuestionMutation = { __typename?: 'Mutation', answerStdSessionOpenEndedQuestion: { __typename?: 'AnswerStdSessionOpenEndedQuestionResponse', openEndedResponse?: string | null, stdPageItemId: string } };

export type AnswerStdSessionPageItemQuestionMutationVariables = Exact<{
  input: AnswerStdSessionPageItemQuestionInput;
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type AnswerStdSessionPageItemQuestionMutation = { __typename?: 'Mutation', answerStdSessionPageItemQuestion: { __typename?: 'AnswerStdSessionPageItemQuestionResponse', answerId?: string | null, questionId: string, stdPageItemId: string } };

export type AnswerSubItemMutationVariables = Exact<{
  input: AnswerSubItemInput;
  sessionToken: Scalars['String'];
}>;


export type AnswerSubItemMutation = { __typename?: 'Mutation', answerSubItem: { __typename?: 'AnswerSubItemResponse', subItemId: string, responseId: string } };

export type ApproveStdSessionPolicyMutationVariables = Exact<{
  approved: Scalars['Boolean'];
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type ApproveStdSessionPolicyMutation = { __typename?: 'Mutation', approveStdSessionPolicy: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type ApproveSurveyPolicyMutationVariables = Exact<{
  approved: Scalars['Boolean'];
  sessionToken: Scalars['String'];
}>;


export type ApproveSurveyPolicyMutation = { __typename?: 'Mutation', approveSurveyPolicy: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type CommentCompetencyMutationVariables = Exact<{
  input: CommentCompetencyInput;
  sessionToken: Scalars['String'];
}>;


export type CommentCompetencyMutation = { __typename?: 'Mutation', commentCompetency: { __typename?: 'CommentCompetencyResponse', comment: string, competencyId: string } };

export type DeleteStdProjectSessionsMutationVariables = Exact<{
  isAllSelected?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  sessionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteStdProjectSessionsMutation = { __typename?: 'Mutation', deleteStdProjectSessions: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type EndSessionMutationVariables = Exact<{
  additionalComments?: InputMaybe<Scalars['String']>;
  areasForDevelopment?: InputMaybe<Scalars['String']>;
  sessionToken: Scalars['String'];
  strengths?: InputMaybe<Scalars['String']>;
}>;


export type EndSessionMutation = { __typename?: 'Mutation', endSession: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type EndStdSessionMutationVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type EndStdSessionMutation = { __typename?: 'Mutation', endStdSession: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type PassInfoPageMutationVariables = Exact<{
  sessionToken: Scalars['String'];
}>;


export type PassInfoPageMutation = { __typename?: 'Mutation', passInfoPage: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type PassStdSessionDemographicsPageMutationVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type PassStdSessionDemographicsPageMutation = { __typename?: 'Mutation', passStdSessionDemographicsPage: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type PassStdSessionInfoPageMutationVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type PassStdSessionInfoPageMutation = { __typename?: 'Mutation', passStdSessionInfoPage: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type Resend360SessionsByProjectIdMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type Resend360SessionsByProjectIdMutation = { __typename?: 'Mutation', resend360SessionsByProjectId: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type Resend360SessionsBySelfRaterIdMutationVariables = Exact<{
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type Resend360SessionsBySelfRaterIdMutation = { __typename?: 'Mutation', resend360SessionsBySelfRaterId: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type ResendStdProjectSessionsMutationVariables = Exact<{
  isAllSelected?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  sessionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ResendStdProjectSessionsMutation = { __typename?: 'Mutation', resendStdProjectSessions: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type ResendSurveySessionMutationVariables = Exact<{
  organizationId: Scalars['String'];
  participantId: Scalars['String'];
  projectId: Scalars['String'];
  selfRaterId: Scalars['String'];
}>;


export type ResendSurveySessionMutation = { __typename?: 'Mutation', resendSurveySession: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type SelectLocaleMutationVariables = Exact<{
  sessionToken: Scalars['String'];
  input: SelectLocaleInput;
}>;


export type SelectLocaleMutation = { __typename?: 'Mutation', selectLocale: string };

export type SelectStdLocaleMutationVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
  input: StdSelectLocaleInput;
}>;


export type SelectStdLocaleMutation = { __typename?: 'Mutation', selectStdLocale: string };

export type CheckStdSessionQueryVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type CheckStdSessionQuery = { __typename?: 'Query', checkStdSession: { __typename?: 'CheckStdSessionResponse', allowBack?: boolean | null, mustAnswerAll?: boolean | null, organizationName: string, selectedLocaleCode?: string | null, responsesLayout: string, surveyHorizontalImage?: string | null, surveyName?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, demographics?: Array<{ __typename?: 'StdSessionDemographicResponse', _id: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answerId?: string | null, answerIds?: Array<string> | null, answerText?: string | null, customErrorMessage?: string | null, label?: string | null, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, answers?: Array<{ __typename?: 'StdSessionDemographicAnswerResponse', _id: string, label?: string | null }> | null }> | null, infoPageData?: { __typename?: 'StdSessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'StdSessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null, stdPageData?: { __typename?: 'StdSessionPageDataResponse', nextStdPageId?: string | null, prevStdPageId?: string | null, progressPercentage: number, stdPageId: string, stdPageItems: Array<{ __typename?: 'StdSessionPageItemResponse', _id: string, infoText?: string | null, openEndedAnswer?: string | null, openEndedQuestion?: string | null, openEndedDimensionName?: string | null, openEndedSubDimensionName?: string | null, order: string, type: string, answers: Array<{ __typename?: 'StdSessionPageItemAnswerResponse', _id: string, text?: string | null }>, linearQuestions: Array<{ __typename?: 'StdSessionPageItemLinearQuestionResponse', _id: string, order: string, questionTitle?: string | null, selectedAnswerId?: string | null, dimensionName?: string | null, subDimensionName?: string | null }> }> } | null } };

export type CheckSurveySessionQueryVariables = Exact<{
  sessionToken: Scalars['String'];
}>;


export type CheckSurveySessionQuery = { __typename?: 'Query', checkSurveySession: { __typename?: 'CheckSurveySessionResponse', organizationName: string, selectedLocaleCode?: string | null, selfRaterName: string, responsesLayout: string, surveyHorizontalImage?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, isSelfRater?: boolean | null, competencyData?: { __typename?: 'SurveySessionCompetencyDataResponse', comment?: string | null, competencyDefinition: string, competencyId: string, competencyName: string, nextCompetencyId?: string | null, prevCompetencyId?: string | null, progressPercentage: number, competenciesItems: Array<{ __typename?: 'SurveySessionCompetencyItemResponse', _id: string, questionTitle: string, selectedResponseId?: string | null, order: string, responses: Array<{ __typename?: 'SurveySessionCompetencyItemResponseResponse', _id: string, text: string }>, subItem?: { __typename?: 'SessionSubItemResponse', _id: string, questionTitle: string, questionDefinition?: string | null, selectedResponseId?: string | null, responses: Array<{ __typename?: 'SessionSubItemResponseResponse', _id: string, text: string }> } | null }> } | null, infoPageData?: { __typename?: 'SurveySessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'SurveySessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null } };

export type NextCompetencyQueryVariables = Exact<{
  sessionToken: Scalars['String'];
}>;


export type NextCompetencyQuery = { __typename?: 'Query', nextCompetency: { __typename?: 'CheckSurveySessionResponse', organizationName: string, selectedLocaleCode?: string | null, selfRaterName: string, responsesLayout: string, surveyHorizontalImage?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, isSelfRater?: boolean | null, competencyData?: { __typename?: 'SurveySessionCompetencyDataResponse', comment?: string | null, competencyDefinition: string, competencyId: string, competencyName: string, nextCompetencyId?: string | null, prevCompetencyId?: string | null, progressPercentage: number, competenciesItems: Array<{ __typename?: 'SurveySessionCompetencyItemResponse', _id: string, questionTitle: string, selectedResponseId?: string | null, order: string, responses: Array<{ __typename?: 'SurveySessionCompetencyItemResponseResponse', _id: string, text: string }>, subItem?: { __typename?: 'SessionSubItemResponse', _id: string, questionTitle: string, questionDefinition?: string | null, selectedResponseId?: string | null, responses: Array<{ __typename?: 'SessionSubItemResponseResponse', _id: string, text: string }> } | null }> } | null, infoPageData?: { __typename?: 'SurveySessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'SurveySessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null } };

export type NextStdSessionPageQueryVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type NextStdSessionPageQuery = { __typename?: 'Query', nextStdSessionPage: { __typename?: 'CheckStdSessionResponse', allowBack?: boolean | null, mustAnswerAll?: boolean | null, organizationName: string, selectedLocaleCode?: string | null, responsesLayout: string, surveyHorizontalImage?: string | null, surveyName?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, demographics?: Array<{ __typename?: 'StdSessionDemographicResponse', _id: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answerId?: string | null, answerIds?: Array<string> | null, answerText?: string | null, customErrorMessage?: string | null, label?: string | null, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, answers?: Array<{ __typename?: 'StdSessionDemographicAnswerResponse', _id: string, label?: string | null }> | null }> | null, infoPageData?: { __typename?: 'StdSessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'StdSessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null, stdPageData?: { __typename?: 'StdSessionPageDataResponse', nextStdPageId?: string | null, prevStdPageId?: string | null, progressPercentage: number, stdPageId: string, stdPageItems: Array<{ __typename?: 'StdSessionPageItemResponse', _id: string, infoText?: string | null, openEndedAnswer?: string | null, openEndedQuestion?: string | null, openEndedDimensionName?: string | null, openEndedSubDimensionName?: string | null, order: string, type: string, answers: Array<{ __typename?: 'StdSessionPageItemAnswerResponse', _id: string, text?: string | null }>, linearQuestions: Array<{ __typename?: 'StdSessionPageItemLinearQuestionResponse', _id: string, order: string, questionTitle?: string | null, selectedAnswerId?: string | null, dimensionName?: string | null, subDimensionName?: string | null }> }> } | null } };

export type PrevCompetencyQueryVariables = Exact<{
  sessionToken: Scalars['String'];
}>;


export type PrevCompetencyQuery = { __typename?: 'Query', prevCompetency: { __typename?: 'CheckSurveySessionResponse', organizationName: string, selectedLocaleCode?: string | null, selfRaterName: string, responsesLayout: string, surveyHorizontalImage?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, isSelfRater?: boolean | null, competencyData?: { __typename?: 'SurveySessionCompetencyDataResponse', comment?: string | null, competencyDefinition: string, competencyId: string, competencyName: string, nextCompetencyId?: string | null, prevCompetencyId?: string | null, progressPercentage: number, competenciesItems: Array<{ __typename?: 'SurveySessionCompetencyItemResponse', _id: string, questionTitle: string, selectedResponseId?: string | null, order: string, responses: Array<{ __typename?: 'SurveySessionCompetencyItemResponseResponse', _id: string, text: string }>, subItem?: { __typename?: 'SessionSubItemResponse', _id: string, questionTitle: string, questionDefinition?: string | null, selectedResponseId?: string | null, responses: Array<{ __typename?: 'SessionSubItemResponseResponse', _id: string, text: string }> } | null }> } | null, infoPageData?: { __typename?: 'SurveySessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'SurveySessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null } };

export type PrevStdSessionPageQueryVariables = Exact<{
  stdSessionInfo: StdSessionInfoArgs;
}>;


export type PrevStdSessionPageQuery = { __typename?: 'Query', prevStdSessionPage: { __typename?: 'CheckStdSessionResponse', allowBack?: boolean | null, mustAnswerAll?: boolean | null, organizationName: string, selectedLocaleCode?: string | null, responsesLayout: string, surveyHorizontalImage?: string | null, surveyName?: string | null, surveyPrimaryColor?: string | null, surveyVerticalImage?: string | null, toRender: string, demographics?: Array<{ __typename?: 'StdSessionDemographicResponse', _id: string, required?: boolean | null, shortAnswerValidation?: string | null, type: string, answerId?: string | null, answerIds?: Array<string> | null, answerText?: string | null, customErrorMessage?: string | null, label?: string | null, multipleChoicesValidationType?: string | null, multipleChoicesValidationValue?: number | null, order: string, answers?: Array<{ __typename?: 'StdSessionDemographicAnswerResponse', _id: string, label?: string | null }> | null }> | null, infoPageData?: { __typename?: 'StdSessionInfoPageDataResponse', infoPageContent: string, isPolicyApproved?: boolean | null, isSurveyConsentRequired?: boolean | null, policyText: string } | null, selectLocaleData?: { __typename?: 'StdSessionSelectLocaleDataResponse', surveyDefaultLocale: string, surveyLocaleCodes: Array<string> } | null, stdPageData?: { __typename?: 'StdSessionPageDataResponse', nextStdPageId?: string | null, prevStdPageId?: string | null, progressPercentage: number, stdPageId: string, stdPageItems: Array<{ __typename?: 'StdSessionPageItemResponse', _id: string, infoText?: string | null, openEndedAnswer?: string | null, openEndedQuestion?: string | null, openEndedDimensionName?: string | null, openEndedSubDimensionName?: string | null, order: string, type: string, answers: Array<{ __typename?: 'StdSessionPageItemAnswerResponse', _id: string, text?: string | null }>, linearQuestions: Array<{ __typename?: 'StdSessionPageItemLinearQuestionResponse', _id: string, order: string, questionTitle?: string | null, selectedAnswerId?: string | null, dimensionName?: string | null, subDimensionName?: string | null }> }> } | null } };

export type CloneCompetenciesToSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  clonedCompetencies: Array<CloneCompetencyInput> | CloneCompetencyInput;
  surveyId: Scalars['String'];
}>;


export type CloneCompetenciesToSurveyMutation = { __typename?: 'Mutation', cloneCompetenciesToSurvey: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type CreateSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'SurveyResponse', _id: string, consentRequired?: boolean | null, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, type: string, updatedAt: any, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null } };

export type DeleteSurveyCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  _id: Scalars['String'];
}>;


export type DeleteSurveyCompetencyMutation = { __typename?: 'Mutation', deleteSurveyCompetency: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type DuplicateSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type DuplicateSurveyMutation = { __typename?: 'Mutation', duplicateSurvey: { __typename?: 'SurveyResponse', _id: string, name: string, type: string, createdAt: any, updatedAt: any, consentRequired?: boolean | null, defaultLocaleCode: string, localeCodes: Array<string>, primaryColor?: string | null, horizontalImage?: string | null, verticalImage?: string | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null, trashedAt?: any | null } };

export type DuplicateSurveyCompetencyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  _id: Scalars['String'];
  newSurveyCompetencyOrder: Scalars['String'];
}>;


export type DuplicateSurveyCompetencyMutation = { __typename?: 'Mutation', duplicateSurveyCompetency: { __typename?: 'SurveyCompetencyWithItemsResponse', _id: string, createdAt: any, order: string, originalCompetencyId: string, updatedAt?: any | null, competenciesItems?: Array<{ __typename?: 'CompetencyItemResponse', _id: string, createdAt: any, measure?: string | null, order: string, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } | null }> | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'SurveyCompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type TrashSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type TrashSurveyMutation = { __typename?: 'Mutation', trashSurvey: { __typename?: 'SuccessResponse', message?: string | null, success: boolean } };

export type UpdateSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: UpdateSurveyInput;
  horizontalImage?: InputMaybe<Scalars['Upload']>;
  verticalImage?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'SurveyResponse', _id: string, name: string, type: string, createdAt: any, updatedAt: any, consentRequired?: boolean | null, defaultLocaleCode: string, localeCodes: Array<string>, primaryColor?: string | null, horizontalImage?: string | null, verticalImage?: string | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null } };

export type UpdateSurveyCompetencyLocaleMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  localeCodes: Array<Scalars['String']> | Scalars['String'];
  input: UpdateSurveyCompetencyLocaleInput;
}>;


export type UpdateSurveyCompetencyLocaleMutation = { __typename?: 'Mutation', updateSurveyCompetencyLocale: { __typename?: 'SurveyCompetencyResponse', _id: string, order: string, originalCompetencyId: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'SurveyCompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null } };

export type UpdateSurveyLocaleMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  input: UpdateSurveyLocaleInput;
}>;


export type UpdateSurveyLocaleMutation = { __typename?: 'Mutation', updateSurveyLocale: { __typename?: 'SurveyWithLocalesResponse', _id: string, name: string, type: string, createdAt: any, updatedAt: any, consentRequired?: boolean | null, defaultLocaleCode: string, localeCodes: Array<string>, horizontalImage?: string | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, primaryColor?: string | null, verticalImage?: string | null, responsesLayout?: string | null, infoPageContent?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, policyText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null } };

export type SearchSurveysQueryVariables = Exact<{
  organizationId: Scalars['String'];
  limit: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  page: Scalars['Float'];
}>;


export type SearchSurveysQuery = { __typename?: 'Query', searchSurveys: { __typename?: 'SurveysResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'SurveyResponse', _id: string, consentRequired?: boolean | null, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, type: string, updatedAt: any, horizontalImage?: string | null, primaryColor?: string | null, verticalImage?: string | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null }> } };

export type SurveyQueryVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
  withLocaleCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SurveyQuery = { __typename?: 'Query', survey: { __typename?: 'SurveyWithLocalesResponse', _id: string, consentRequired?: boolean | null, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, type: string, updatedAt: any, primaryColor?: string | null, horizontalImage?: string | null, verticalImage?: string | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null, infoPageContent?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, policyText?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null } };

export type SurveyCompetenciesQueryVariables = Exact<{
  localeCodes: Array<Scalars['String']> | Scalars['String'];
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type SurveyCompetenciesQuery = { __typename?: 'Query', surveyCompetencies: Array<{ __typename?: 'SurveyCompetencyWithItemsResponse', _id: string, createdAt: any, updatedAt?: any | null, originalCompetencyId: string, order: string, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'SurveyCompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, competenciesItems?: Array<{ __typename?: 'CompetencyItemResponse', _id: string, createdAt: any, updatedAt?: any | null, measure?: string | null, order: string, questionTitle?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, responses?: Array<{ __typename?: 'CompetencyItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null, responsesLogic?: Array<{ __typename?: 'CompetencyItemResponseLogicResponse', _id: string, responseId: string, type: string, data?: { __typename?: 'CompetencySubItemResponse', _id: string, createdAt?: any | null, updatedAt?: any | null, questionTitle?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, questionDefinition?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null, responses?: Array<{ __typename?: 'CompetencySubItemResponseResponse', _id: string, score: number, text?: Array<{ __typename?: 'LocaleResponse', text?: string | null, localeCode: string }> | null }> | null } | null }> | null, responseStatements?: Array<{ __typename?: 'CompetencyItemResponseStatement', _id: string, responseIds: Array<string>, type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null }> };

export type DeleteCompetencyGroupMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
}>;


export type DeleteCompetencyGroupMutation = { __typename?: 'Mutation', deleteCompetencyGroup: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type DeleteDemographicTemplateMutation = { __typename?: 'Mutation', deleteDemographicTemplate: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteMasterProductMutationVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type DeleteMasterProductMutation = { __typename?: 'Mutation', deleteMasterProduct: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteProductMutationVariables = Exact<{
  productId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreCompetencyGroupMutationVariables = Exact<{
  organizationId: Scalars['String'];
  competencyGroupId: Scalars['String'];
}>;


export type RestoreCompetencyGroupMutation = { __typename?: 'Mutation', restoreCompetencyGroup: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreDemographicTemplateMutationVariables = Exact<{
  organizationId: Scalars['String'];
  demographicTemplateId: Scalars['String'];
}>;


export type RestoreDemographicTemplateMutation = { __typename?: 'Mutation', restoreDemographicTemplate: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreMasterProductMutationVariables = Exact<{
  masterProductId: Scalars['String'];
}>;


export type RestoreMasterProductMutation = { __typename?: 'Mutation', restoreMasterProduct: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreProductMutationVariables = Exact<{
  productId: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type RestoreProductMutation = { __typename?: 'Mutation', restoreProduct: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type RestoreSurveyMutationVariables = Exact<{
  organizationId: Scalars['String'];
  surveyId: Scalars['String'];
}>;


export type RestoreSurveyMutation = { __typename?: 'Mutation', restoreSurvey: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type TrashedCompetencyGroupsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type TrashedCompetencyGroupsQuery = { __typename?: 'Query', trashedCompetencyGroups: { __typename?: 'CompetencyGroupsResponse', page: number, limit: number, hasNextPage: boolean, hasPrevPage: boolean, nextPage?: number | null, prevPage?: number | null, pagingCounter: number, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'CompetencyGroupWithChildrenResponse', _id: string, name: string, definition: string, defaultLocaleCode: string, localeCodes: Array<string>, trashedAt?: any | null, competenciesCount?: number | null, createdAt: any, updatedAt: any, competencies?: Array<{ __typename?: 'CompetencyResponse', _id: string, createdAt: any, updatedAt?: any | null, name?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, definition?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null, narratives?: Array<{ __typename?: 'CompetencyNarrativeResponse', type: string, text?: Array<{ __typename?: 'LocaleResponse', localeCode: string, text?: string | null }> | null }> | null }> | null }> } };

export type TrashedDemographicTemplatesQueryVariables = Exact<{
  organizationId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type TrashedDemographicTemplatesQuery = { __typename?: 'Query', trashedDemographicTemplates: { __typename?: 'DemographicTemplatesWithCountResponse', page: number, limit: number, hasNextPage: boolean, hasPrevPage: boolean, nextPage?: number | null, prevPage?: number | null, pagingCounter: number, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'DemographicTemplateWithCountResponse', _id: string, name: string, defaultLocaleCode: string, localeCodes: Array<string>, demographicsCount: number, createdAt: any, updatedAt: any, trashedAt?: any | null }> } };

export type TrashedMasterProductsQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
}>;


export type TrashedMasterProductsQuery = { __typename?: 'Query', trashedMasterProducts: { __typename?: 'MasterProductsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'MasterProductResponse', _id: string, createdAt: any, name: string, image?: string | null, type: string, description: string, units: number, trashedAt?: any | null, assessments?: Array<{ __typename?: 'MasterProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> } };

export type TrashedProductsQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  organizationId: Scalars['String'];
}>;


export type TrashedProductsQuery = { __typename?: 'Query', trashedProducts: { __typename?: 'ProductsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'ProductResponse', _id: string, createdAt: any, name: string, image?: string | null, type: string, description: string, units: number, trashedAt?: any | null, isSent: boolean, masterProductId?: string | null, assessments?: Array<{ __typename?: 'ProductAssessmentResponse', _id: string, assessmentId: string, assessmentName: string, adsAssessmentName?: string | null }> | null }> } };

export type TrashedSurveysQueryVariables = Exact<{
  organizationId: Scalars['String'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
}>;


export type TrashedSurveysQuery = { __typename?: 'Query', trashedSurveys: { __typename?: 'SurveysResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'SurveyResponse', _id: string, consentRequired?: boolean | null, createdAt: any, defaultLocaleCode: string, localeCodes: Array<string>, name: string, type: string, updatedAt: any, horizontalImage?: string | null, primaryColor?: string | null, verticalImage?: string | null, trashedAt?: any | null, allowBack?: boolean | null, allowDemographics?: boolean | null, demographicTemplateId?: string | null, demographicTemplateName?: string | null, mustAnswerAll?: boolean | null, isReadOnly?: boolean | null, masterSurveyUnits?: number | null, responsesLayout?: string | null }> } };

export type AcceptJoinRequestMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: AcceptJoinRequestInput;
}>;


export type AcceptJoinRequestMutation = { __typename?: 'Mutation', acceptJoinRequest: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DeleteMembersAndInvitationsMutationVariables = Exact<{
  organizationId: Scalars['String'];
  input: DeleteMembersOrInvitationsInput;
}>;


export type DeleteMembersAndInvitationsMutation = { __typename?: 'Mutation', deleteMembersAndInvitations: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type InviteUsersMutationVariables = Exact<{
  organizationId: Scalars['String'];
  invitedUsers?: InputMaybe<Array<InviteUserInput> | InviteUserInput>;
  invitedUsersCsv?: InputMaybe<Scalars['Upload']>;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type ResendInvitationMutationVariables = Exact<{
  organizationId: Scalars['String'];
  userEmail: Scalars['String'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type UpdateRolesMutationVariables = Exact<{
  organizationId: Scalars['String'];
  newRoleId: Scalars['String'];
  input: UpdateMembersOrInvitationsInput;
}>;


export type UpdateRolesMutation = { __typename?: 'Mutation', updateRoles: { __typename?: 'SuccessResponse', success: boolean, message?: string | null } };

export type DownloadInviteUsersCsvTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadInviteUsersCsvTemplateQuery = { __typename?: 'Query', downloadInviteUsersCsvTemplate: string };

export type JoinRequestsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  args: PaginationArgs;
}>;


export type JoinRequestsQuery = { __typename?: 'Query', joinRequests: { __typename?: 'JoinRequestsResponse', hasNextPage: boolean, hasPrevPage: boolean, limit: number, nextPage?: number | null, page: number, pagingCounter: number, prevPage?: number | null, totalDocs: number, totalPages: number, docs: Array<{ __typename?: 'JoinRequestResponse', _id: string, createdAt: any, organizationId: string, userEmail?: string | null, userId: string, userImage?: string | null, userName?: string | null }> } };

export type LastThreeJoinRequestsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type LastThreeJoinRequestsQuery = { __typename?: 'Query', lastThreeJoinRequests: Array<{ __typename?: 'JoinRequestResponse', _id: string, organizationId: string, userEmail?: string | null, userId: string, userName?: string | null, userImage?: string | null, createdAt: any }> };

export type MembersAndInvitationsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type MembersAndInvitationsQuery = { __typename?: 'Query', membersAndInvitations: { __typename?: 'MembersAndInvitationsResponse', invitations: Array<{ __typename?: 'InvitationResponse', _id: string, email: string, invitationCodeExpires: any, roleId: string, roleName: string }>, members: Array<{ __typename?: 'OrganizationMemberResponse', email: string, firstName?: string | null, lastName?: string | null, roleId: string, roleName: string, userId: string, image?: string | null }> } };

export type RolesQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'RoleResponse', _id: string, createdAt?: any | null, name: string, type: string }> };

export const CreateAcmCompetencyDocument = gql`
    mutation createAcmCompetency($input: CreateAcmCompetencyInput!, $organizationId: String!) {
  createAcmCompetency(organizationId: $organizationId, input: $input) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAcmCompetencyGQL extends Apollo.Mutation<CreateAcmCompetencyMutation, CreateAcmCompetencyMutationVariables> {
    document = CreateAcmCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAcmCompetencyDocument = gql`
    mutation deleteAcmCompetency($acmCompetencyId: String!, $organizationId: String!) {
  deleteAcmCompetency(
    organizationId: $organizationId
    acmCompetencyId: $acmCompetencyId
  ) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAcmCompetencyGQL extends Apollo.Mutation<DeleteAcmCompetencyMutation, DeleteAcmCompetencyMutationVariables> {
    document = DeleteAcmCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAcmCompetencyDocument = gql`
    mutation updateAcmCompetency($input: UpdateAcmCompetencyInput!, $acmCompetencyId: String!, $organizationId: String!) {
  updateAcmCompetency(
    organizationId: $organizationId
    input: $input
    acmCompetencyId: $acmCompetencyId
  ) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAcmCompetencyGQL extends Apollo.Mutation<UpdateAcmCompetencyMutation, UpdateAcmCompetencyMutationVariables> {
    document = UpdateAcmCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcmCompetenciesDocument = gql`
    query acmCompetencies($organizationId: String!, $ids: [String!]!) {
  acmCompetencies(organizationId: $organizationId, ids: $ids) {
    _id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcmCompetenciesGQL extends Apollo.Query<AcmCompetenciesQuery, AcmCompetenciesQueryVariables> {
    document = AcmCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAcmCompetenciesDocument = gql`
    query searchAcmCompetencies($organizationId: String!, $args: SearchAcmCompetenciesArgs!) {
  searchAcmCompetencies(organizationId: $organizationId, args: $args) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAcmCompetenciesGQL extends Apollo.Query<SearchAcmCompetenciesQuery, SearchAcmCompetenciesQueryVariables> {
    document = SearchAcmCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAcmProjectCompetencyDocument = gql`
    mutation createAcmProjectCompetency($acmProjectId: String!, $input: CreateAcmProjectCompetencyInput!, $organizationId: String!) {
  createAcmProjectCompetency(
    acmProjectId: $acmProjectId
    organizationId: $organizationId
    input: $input
  ) {
    _id
    name
    definition
    competencies {
      _id
      name
    }
    exercises {
      _id
      caseStudyId
      kpiIds
      weightPercentage
    }
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAcmProjectCompetencyGQL extends Apollo.Mutation<CreateAcmProjectCompetencyMutation, CreateAcmProjectCompetencyMutationVariables> {
    document = CreateAcmProjectCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAcmProjectCompetencyDocument = gql`
    mutation deleteAcmProjectCompetency($acmProjectCompetencyId: String!, $acmProjectId: String!, $organizationId: String!) {
  deleteAcmProjectCompetency(
    acmProjectId: $acmProjectId
    organizationId: $organizationId
    acmProjectCompetencyId: $acmProjectCompetencyId
  ) {
    _id
    name
    definition
    competencies {
      _id
      name
    }
    exercises {
      _id
      caseStudyId
      kpiIds
      weightPercentage
    }
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAcmProjectCompetencyGQL extends Apollo.Mutation<DeleteAcmProjectCompetencyMutation, DeleteAcmProjectCompetencyMutationVariables> {
    document = DeleteAcmProjectCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAcmProjectCompetencyDocument = gql`
    mutation updateAcmProjectCompetency($acmProjectCompetencyId: String!, $acmProjectId: String!, $organizationId: String!, $input: UpdateAcmProjectCompetencyInput!) {
  updateAcmProjectCompetency(
    acmProjectId: $acmProjectId
    organizationId: $organizationId
    acmProjectCompetencyId: $acmProjectCompetencyId
    input: $input
  ) {
    _id
    name
    definition
    competencies {
      _id
      name
    }
    exercises {
      _id
      caseStudyId
      kpiIds
      weightPercentage
    }
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAcmProjectCompetencyGQL extends Apollo.Mutation<UpdateAcmProjectCompetencyMutation, UpdateAcmProjectCompetencyMutationVariables> {
    document = UpdateAcmProjectCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcmProjectCompetencyKpisDocument = gql`
    query acmProjectCompetencyKpis($acmProjectId: String!, $organizationId: String!, $acmProjectCompetencyId: String!, $caseStudyId: String!) {
  acmProjectCompetencyKpis(
    organizationId: $organizationId
    acmProjectId: $acmProjectId
    caseStudyId: $caseStudyId
    acmProjectCompetencyId: $acmProjectCompetencyId
  ) {
    _id
    score1NarrativesStatus
    score2NarrativesStatus
    score3NarrativesStatus
    score4NarrativesStatus
    score5NarrativesStatus
    score1Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score2Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score3Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score4Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score5Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    type
    updatedAt
    competencyIds
    createdAt
    localeCodes
    negativeStatement {
      localeCode
      text
    }
    notes {
      _id
      createdAt
      text {
        localeCode
        text
      }
    }
    positiveStatement {
      localeCode
      text
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcmProjectCompetencyKpisGQL extends Apollo.Query<AcmProjectCompetencyKpisQuery, AcmProjectCompetencyKpisQueryVariables> {
    document = AcmProjectCompetencyKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAcmProjectCompetenciesDocument = gql`
    query searchAcmProjectCompetencies($acmProjectId: String!, $args: SearchAcmProjectCompetenciesArgs!, $organizationId: String!) {
  searchAcmProjectCompetencies(
    args: $args
    organizationId: $organizationId
    acmProjectId: $acmProjectId
  ) {
    docs {
      _id
      name
      definition
      competencies {
        _id
        name
      }
      exercises {
        _id
        caseStudyId
        kpiIds
        weightPercentage
      }
      createdAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAcmProjectCompetenciesGQL extends Apollo.Query<SearchAcmProjectCompetenciesQuery, SearchAcmProjectCompetenciesQueryVariables> {
    document = SearchAcmProjectCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAcmProjectDocument = gql`
    mutation createAcmProject($companyImageFile: Upload, $input: CreateAcmProjectInput!, $organizationId: String!) {
  createAcmProject(
    companyImageFile: $companyImageFile
    organizationId: $organizationId
    input: $input
  ) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAcmProjectGQL extends Apollo.Mutation<CreateAcmProjectMutation, CreateAcmProjectMutationVariables> {
    document = CreateAcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAcmProjectDocument = gql`
    mutation deleteAcmProject($acmProjectId: String!, $organizationId: String!) {
  deleteAcmProject(organizationId: $organizationId, acmProjectId: $acmProjectId) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAcmProjectGQL extends Apollo.Mutation<DeleteAcmProjectMutation, DeleteAcmProjectMutationVariables> {
    document = DeleteAcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreAcmProjectDocument = gql`
    mutation restoreAcmProject($acmProjectId: String!, $organizationId: String!) {
  restoreAcmProject(organizationId: $organizationId, acmProjectId: $acmProjectId) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreAcmProjectGQL extends Apollo.Mutation<RestoreAcmProjectMutation, RestoreAcmProjectMutationVariables> {
    document = RestoreAcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashAcmProjectDocument = gql`
    mutation trashAcmProject($acmProjectId: String!, $organizationId: String!) {
  trashAcmProject(organizationId: $organizationId, acmProjectId: $acmProjectId) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashAcmProjectGQL extends Apollo.Mutation<TrashAcmProjectMutation, TrashAcmProjectMutationVariables> {
    document = TrashAcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAcmProjectDocument = gql`
    mutation updateAcmProject($companyImageFile: Upload, $input: UpdateAcmProjectInput!, $organizationId: String!, $acmProjectId: String!) {
  updateAcmProject(
    companyImageFile: $companyImageFile
    organizationId: $organizationId
    input: $input
    acmProjectId: $acmProjectId
  ) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAcmProjectGQL extends Apollo.Mutation<UpdateAcmProjectMutation, UpdateAcmProjectMutationVariables> {
    document = UpdateAcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcmProjectDocument = gql`
    query acmProject($acmProjectId: String!, $organizationId: String!) {
  acmProject(acmProjectId: $acmProjectId, organizationId: $organizationId) {
    _id
    companyImage
    companyName
    createdAt
    name
    numOfDays
    purpose
    scoringScale {
      color
      from
      name
      to
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcmProjectGQL extends Apollo.Query<AcmProjectQuery, AcmProjectQueryVariables> {
    document = AcmProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAcmProjectsDocument = gql`
    query searchAcmProjects($args: SearchAcmProjectsArgs!, $organizationId: String!) {
  searchAcmProjects(args: $args, organizationId: $organizationId) {
    docs {
      _id
      companyImage
      companyName
      createdAt
      name
      numOfDays
      purpose
      scoringScale {
        color
        from
        name
        to
      }
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAcmProjectsGQL extends Apollo.Query<SearchAcmProjectsQuery, SearchAcmProjectsQueryVariables> {
    document = SearchAcmProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTrashedAcmProjectsDocument = gql`
    query searchTrashedAcmProjects($args: SearchAcmProjectsArgs!, $organizationId: String!) {
  searchTrashedAcmProjects(args: $args, organizationId: $organizationId) {
    docs {
      _id
      companyImage
      companyName
      createdAt
      name
      numOfDays
      purpose
      scoringScale {
        color
        from
        name
        to
      }
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTrashedAcmProjectsGQL extends Apollo.Query<SearchTrashedAcmProjectsQuery, SearchTrashedAcmProjectsQueryVariables> {
    document = SearchTrashedAcmProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAdsApiKeyDocument = gql`
    mutation deleteAdsApiKey($key: String!) {
  deleteAdsApiKey(key: $key) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAdsApiKeyGQL extends Apollo.Mutation<DeleteAdsApiKeyMutation, DeleteAdsApiKeyMutationVariables> {
    document = DeleteAdsApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetAdsApiKeyDocument = gql`
    mutation setAdsApiKey($key: String!) {
  setAdsApiKey(key: $key)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetAdsApiKeyGQL extends Apollo.Mutation<SetAdsApiKeyMutation, SetAdsApiKeyMutationVariables> {
    document = SetAdsApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdsApiKeyDocument = gql`
    query adsApiKey {
  adsApiKey
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdsApiKeyGQL extends Apollo.Query<AdsApiKeyQuery, AdsApiKeyQueryVariables> {
    document = AdsApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgetPasswordDocument = gql`
    mutation forgetPassword($email: String!) {
  forgetPassword(input: {email: $email}) {
    message
    success
    userId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgetPasswordGQL extends Apollo.Mutation<ForgetPasswordMutation, ForgetPasswordMutationVariables> {
    document = ForgetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogoutDocument = gql`
    mutation logout {
  logout {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    document = LogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken {
    accessToken
    refreshToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenGQL extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    document = RefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendVerificationDocument = gql`
    mutation resendVerification($userId: String!, $verificationToken: String!) {
  resendVerification(
    input: {userId: $userId, verificationToken: $verificationToken}
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendVerificationGQL extends Apollo.Mutation<ResendVerificationMutation, ResendVerificationMutationVariables> {
    document = ResendVerificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String!, $resetPasswordCode: Float!, $userId: String!) {
  resetPassword(
    input: {newPassword: $newPassword, resetPasswordCode: $resetPasswordCode, userId: $userId}
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordViaTokenDocument = gql`
    mutation resetPasswordViaToken($input: ChangePasswordInput!) {
  resetPasswordViaToken(input: $input) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordViaTokenGQL extends Apollo.Mutation<ResetPasswordViaTokenMutation, ResetPasswordViaTokenMutationVariables> {
    document = ResetPasswordViaTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendResetPasswordEmailDocument = gql`
    mutation sendResetPasswordEmail {
  sendResetPasswordEmail {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendResetPasswordEmailGQL extends Apollo.Mutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables> {
    document = SendResetPasswordEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SigninDocument = gql`
    mutation signin($email: String!, $password: String!) {
  signin(input: {email: $email, password: $password}) {
    userId
    accessToken
    refreshToken
    isVerified
    verificationToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SigninGQL extends Apollo.Mutation<SigninMutation, SigninMutationVariables> {
    document = SigninDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignupDocument = gql`
    mutation signup($input: SignupInput!) {
  signup(input: $input) {
    message
    success
    userId
    verificationToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignupGQL extends Apollo.Mutation<SignupMutation, SignupMutationVariables> {
    document = SignupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMyProfileDocument = gql`
    mutation updateMyProfile($image: Upload, $input: UpdateMyProfileInput!) {
  updateMyProfile(image: $image, input: $input) {
    _id
    email
    firstName
    lastName
    image
    timezone
    isSuperAdmin
    superAdminOrganizationId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMyProfileGQL extends Apollo.Mutation<UpdateMyProfileMutation, UpdateMyProfileMutationVariables> {
    document = UpdateMyProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyAccountDocument = gql`
    mutation verifyAccount($userId: String!, $verificationCode: Float!, $verificationToken: String!) {
  verifyAccount(
    input: {userId: $userId, verificationCode: $verificationCode, verificationToken: $verificationToken}
  ) {
    accessToken
    isVerified
    refreshToken
    userId
    verificationToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyAccountGQL extends Apollo.Mutation<VerifyAccountMutation, VerifyAccountMutationVariables> {
    document = VerifyAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query me {
  me {
    _id
    firstName
    lastName
    email
    image
    timezone
    isSuperAdmin
    superAdminOrganizationId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimezonesDocument = gql`
    query timezones {
  timezones
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TimezonesGQL extends Apollo.Query<TimezonesQuery, TimezonesQueryVariables> {
    document = TimezonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCaseStudyFileDocument = gql`
    mutation createCaseStudyFile($organizationId: String!, $caseStudyId: String!, $file: Upload!, $thumbnailFile: Upload, $input: CreateAcmCaseStudyFileInput!) {
  createCaseStudyFile(
    caseStudyId: $caseStudyId
    file: $file
    thumbnailFile: $thumbnailFile
    organizationId: $organizationId
    input: $input
  ) {
    _id
    name
    path
    type
    size
    localeCode
    accessibleTo
    createdAt
    thumbnailPath
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCaseStudyFileGQL extends Apollo.Mutation<CreateCaseStudyFileMutation, CreateCaseStudyFileMutationVariables> {
    document = CreateCaseStudyFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCaseStudyFileDocument = gql`
    mutation deleteCaseStudyFile($organizationId: String!, $caseStudyId: String!, $caseFileId: String!) {
  deleteCaseStudyFile(
    caseStudyId: $caseStudyId
    caseFileId: $caseFileId
    organizationId: $organizationId
  ) {
    _id
    name
    path
    type
    size
    localeCode
    accessibleTo
    thumbnailPath
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCaseStudyFileGQL extends Apollo.Mutation<DeleteCaseStudyFileMutation, DeleteCaseStudyFileMutationVariables> {
    document = DeleteCaseStudyFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCaseStudyFileDocument = gql`
    mutation updateCaseStudyFile($organizationId: String!, $caseStudyId: String!, $caseFileId: String!, $input: UpdateAcmCaseStudyFileInput!) {
  updateCaseStudyFile(
    caseStudyId: $caseStudyId
    caseFileId: $caseFileId
    organizationId: $organizationId
    input: $input
  ) {
    _id
    name
    path
    type
    size
    localeCode
    accessibleTo
    thumbnailPath
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCaseStudyFileGQL extends Apollo.Mutation<UpdateCaseStudyFileMutation, UpdateCaseStudyFileMutationVariables> {
    document = UpdateCaseStudyFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAcmCaseFilesDocument = gql`
    query searchAcmCaseFiles($organizationId: String!, $caseStudyId: String!, $args: SearchAcmCaseFileArgs!) {
  searchAcmCaseFiles(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    args: $args
  ) {
    docs {
      _id
      createdAt
      accessibleTo
      localeCode
      name
      path
      size
      thumbnailPath
      type
    }
    totalDocs
    totalPages
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAcmCaseFilesGQL extends Apollo.Query<SearchAcmCaseFilesQuery, SearchAcmCaseFilesQueryVariables> {
    document = SearchAcmCaseFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCaseStudyDocument = gql`
    mutation createCaseStudy($organizationId: String!, $input: CreateCaseStudyInput!) {
  createCaseStudy(organizationId: $organizationId, input: $input) {
    _id
    title
    description
    type
    maxCandidates
    minCandidates
    competencyIds
    performingDuration
    preparationDuration
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCaseStudyGQL extends Apollo.Mutation<CreateCaseStudyMutation, CreateCaseStudyMutationVariables> {
    document = CreateCaseStudyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashCaseStudyDocument = gql`
    mutation trashCaseStudy($organizationId: String!, $caseStudyId: String!) {
  trashCaseStudy(organizationId: $organizationId, caseStudyId: $caseStudyId) {
    _id
    title
    description
    type
    maxCandidates
    minCandidates
    competencyIds
    performingDuration
    preparationDuration
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashCaseStudyGQL extends Apollo.Mutation<TrashCaseStudyMutation, TrashCaseStudyMutationVariables> {
    document = TrashCaseStudyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCaseStudyDocument = gql`
    mutation updateCaseStudy($organizationId: String!, $caseStudyId: String!, $input: UpdateCaseStudyInput!) {
  updateCaseStudy(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    input: $input
  ) {
    _id
    title
    description
    type
    maxCandidates
    minCandidates
    competencyIds
    performingDuration
    preparationDuration
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCaseStudyGQL extends Apollo.Mutation<UpdateCaseStudyMutation, UpdateCaseStudyMutationVariables> {
    document = UpdateCaseStudyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaseStudyDocument = gql`
    query caseStudy($organizationId: String!, $caseStudyId: String!) {
  caseStudy(organizationId: $organizationId, caseStudyId: $caseStudyId) {
    _id
    title
    description
    type
    maxCandidates
    minCandidates
    competencyIds
    performingDuration
    preparationDuration
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaseStudyGQL extends Apollo.Query<CaseStudyQuery, CaseStudyQueryVariables> {
    document = CaseStudyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCaseStudiesDocument = gql`
    query searchCaseStudies($organizationId: String!, $args: SearchCaseStudiesArgs!) {
  searchCaseStudies(organizationId: $organizationId, args: $args) {
    docs {
      _id
      title
      description
      type
      maxCandidates
      minCandidates
      competencyIds
      performingDuration
      preparationDuration
      createdAt
    }
    totalDocs
    totalPages
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCaseStudiesGQL extends Apollo.Query<SearchCaseStudiesQuery, SearchCaseStudiesQueryVariables> {
    document = SearchCaseStudiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTrashedCaseStudiesDocument = gql`
    query searchTrashedCaseStudies($organizationId: String!, $args: SearchCaseStudiesArgs!) {
  searchTrashedCaseStudies(organizationId: $organizationId, args: $args) {
    docs {
      _id
      title
      description
      type
      maxCandidates
      minCandidates
      competencyIds
      performingDuration
      preparationDuration
      createdAt
    }
    totalDocs
    totalPages
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTrashedCaseStudiesGQL extends Apollo.Query<SearchTrashedCaseStudiesQuery, SearchTrashedCaseStudiesQueryVariables> {
    document = SearchTrashedCaseStudiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCaseStudyKpiDocument = gql`
    mutation deleteCaseStudyKpi($organizationId: String!, $caseStudyId: String!, $competencyId: String!, $caseStudyKpiId: String!) {
  deleteCaseStudyKpi(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    competencyId: $competencyId
    caseStudyKpiId: $caseStudyKpiId
  ) {
    _id
    kpi {
      _id
      score1Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score1NarrativesStatus
      score2NarrativesStatus
      score2Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3NarrativesStatus
      score4Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score4NarrativesStatus
      score5Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score5NarrativesStatus
      type
      updatedAt
      createdAt
      competencyIds
      localeCodes
      negativeStatement {
        localeCode
        text
      }
      notes {
        _id
        createdAt
        text {
          localeCode
          text
        }
      }
      positiveStatement {
        localeCode
        text
      }
    }
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCaseStudyKpiGQL extends Apollo.Mutation<DeleteCaseStudyKpiMutation, DeleteCaseStudyKpiMutationVariables> {
    document = DeleteCaseStudyKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkKpisWithCaseStudyAndCompetencyDocument = gql`
    mutation linkKpisWithCaseStudyAndCompetency($organizationId: String!, $caseStudyId: String!, $input: LinkKpisWithCaseStudyAndCompetencyInput!) {
  linkKpisWithCaseStudyAndCompetency(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    input: $input
  ) {
    _id
    kpi {
      _id
      score1Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score1NarrativesStatus
      score2NarrativesStatus
      score2Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3NarrativesStatus
      score4Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score4NarrativesStatus
      score5Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score5NarrativesStatus
      type
      updatedAt
      createdAt
      competencyIds
      localeCodes
      negativeStatement {
        localeCode
        text
      }
      notes {
        _id
        createdAt
        text {
          localeCode
          text
        }
      }
      positiveStatement {
        localeCode
        text
      }
    }
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkKpisWithCaseStudyAndCompetencyGQL extends Apollo.Mutation<LinkKpisWithCaseStudyAndCompetencyMutation, LinkKpisWithCaseStudyAndCompetencyMutationVariables> {
    document = LinkKpisWithCaseStudyAndCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCaseStudyKpiOrderDocument = gql`
    mutation updateCaseStudyKpiOrder($organizationId: String!, $order: String!, $competencyId: String!, $caseStudyId: String!, $caseStudyKpiId: String!) {
  updateCaseStudyKpiOrder(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    order: $order
    competencyId: $competencyId
    caseStudyKpiId: $caseStudyKpiId
  ) {
    _id
    kpi {
      _id
      score1Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score1NarrativesStatus
      score2NarrativesStatus
      score2Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3NarrativesStatus
      score4Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score4NarrativesStatus
      score5Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score5NarrativesStatus
      type
      updatedAt
      createdAt
      competencyIds
      localeCodes
      negativeStatement {
        localeCode
        text
      }
      notes {
        _id
        createdAt
        text {
          localeCode
          text
        }
      }
      positiveStatement {
        localeCode
        text
      }
    }
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCaseStudyKpiOrderGQL extends Apollo.Mutation<UpdateCaseStudyKpiOrderMutation, UpdateCaseStudyKpiOrderMutationVariables> {
    document = UpdateCaseStudyKpiOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaseStudyKpisDocument = gql`
    query caseStudyKpis($organizationId: String!, $caseStudyId: String!, $competencyId: String) {
  caseStudyKpis(
    organizationId: $organizationId
    caseStudyId: $caseStudyId
    competencyId: $competencyId
  ) {
    _id
    order
    kpi {
      _id
      score1Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score2Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score4Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score5Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      type
      competencyIds
      localeCodes
      score1NarrativesStatus
      score2NarrativesStatus
      score3NarrativesStatus
      score4NarrativesStatus
      score5NarrativesStatus
      negativeStatement {
        localeCode
        text
      }
      notes {
        _id
        text {
          localeCode
          text
        }
        createdAt
      }
      positiveStatement {
        localeCode
        text
      }
      updatedAt
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaseStudyKpisGQL extends Apollo.Query<CaseStudyKpisQuery, CaseStudyKpisQueryVariables> {
    document = CaseStudyKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompetencyGroupDocument = gql`
    mutation createCompetencyGroup($organizationId: String!, $name: String!, $definition: String!, $localeCodes: [String!]!, $defaultLocaleCode: String!) {
  createCompetencyGroup(
    input: {organizationId: $organizationId, name: $name, definition: $definition, localeCodes: $localeCodes, defaultLocaleCode: $defaultLocaleCode}
  ) {
    _id
    name
    definition
    defaultLocaleCode
    localeCodes
    competencies {
      _id
      name {
        localeCode
        text
      }
      definition {
        localeCode
        text
      }
      narratives {
        text {
          localeCode
          text
        }
        type
      }
      createdAt
      updatedAt
    }
    competenciesCount
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompetencyGroupGQL extends Apollo.Mutation<CreateCompetencyGroupMutation, CreateCompetencyGroupMutationVariables> {
    document = CreateCompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompetencyGroupDocument = gql`
    mutation updateCompetencyGroup($organizationId: String!, $_id: String!, $name: String!, $definition: String!, $localeCodes: [String!]!, $defaultLocaleCode: String!) {
  updateCompetencyGroup(
    input: {organizationId: $organizationId, _id: $_id, name: $name, definition: $definition, localeCodes: $localeCodes, defaultLocaleCode: $defaultLocaleCode}
  ) {
    _id
    name
    definition
    defaultLocaleCode
    localeCodes
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompetencyGroupGQL extends Apollo.Mutation<UpdateCompetencyGroupMutation, UpdateCompetencyGroupMutationVariables> {
    document = UpdateCompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompetencyGroupDocument = gql`
    query competencyGroup($_id: String!, $organizationId: String!) {
  competencyGroup(_id: $_id, organizationId: $organizationId) {
    _id
    name
    definition
    localeCodes
    defaultLocaleCode
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompetencyGroupGQL extends Apollo.Query<CompetencyGroupQuery, CompetencyGroupQueryVariables> {
    document = CompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCompetencyGroupsDocument = gql`
    query searchCompetencyGroups($organizationId: String!, $page: Float!, $limit: Float!, $searchTerm: String) {
  searchCompetencyGroups(
    args: {organizationId: $organizationId, page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    docs {
      _id
      name
      definition
      defaultLocaleCode
      localeCodes
      competencies {
        _id
        name {
          localeCode
          text
        }
        definition {
          localeCode
          text
        }
        narratives {
          text {
            localeCode
            text
          }
          type
        }
        createdAt
        updatedAt
      }
      competenciesCount
      createdAt
      updatedAt
    }
    page
    limit
    hasNextPage
    hasPrevPage
    nextPage
    prevPage
    pagingCounter
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCompetencyGroupsGQL extends Apollo.Query<SearchCompetencyGroupsQuery, SearchCompetencyGroupsQueryVariables> {
    document = SearchCompetencyGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCompetencyGroupsWithAllCompetenciesDocument = gql`
    query searchCompetencyGroupsWithAllCompetencies($organizationId: String!, $page: Float!, $limit: Float!, $searchTerm: String, $localeCode: String) {
  searchCompetencyGroupsWithAllCompetencies(
    localeCode: $localeCode
    args: {organizationId: $organizationId, page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    docs {
      _id
      name
      definition
      defaultLocaleCode
      localeCodes
      competencies {
        _id
        name {
          localeCode
          text
        }
        definition {
          localeCode
          text
        }
        narratives {
          text {
            localeCode
            text
          }
          type
        }
        createdAt
        updatedAt
      }
      competenciesCount
      createdAt
      updatedAt
    }
    page
    limit
    hasNextPage
    hasPrevPage
    nextPage
    prevPage
    pagingCounter
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCompetencyGroupsWithAllCompetenciesGQL extends Apollo.Query<SearchCompetencyGroupsWithAllCompetenciesQuery, SearchCompetencyGroupsWithAllCompetenciesQueryVariables> {
    document = SearchCompetencyGroupsWithAllCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompetencyDocument = gql`
    mutation createCompetency($organizationId: String!, $competencyGroupId: String!) {
  createCompetency(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
  ) {
    _id
    name {
      localeCode
      text
    }
    definition {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompetencyGQL extends Apollo.Mutation<CreateCompetencyMutation, CreateCompetencyMutationVariables> {
    document = CreateCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompetencyDocument = gql`
    mutation deleteCompetency($organizationId: String!, $_id: String!) {
  deleteCompetency(organizationId: $organizationId, _id: $_id) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompetencyGQL extends Apollo.Mutation<DeleteCompetencyMutation, DeleteCompetencyMutationVariables> {
    document = DeleteCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateCompetencyDocument = gql`
    mutation duplicateCompetency($organizationId: String!, $_id: String!, $competencyGroupId: String!) {
  duplicateCompetency(
    organizationId: $organizationId
    _id: $_id
    competencyGroupId: $competencyGroupId
  ) {
    _id
    createdAt
    definition {
      localeCode
      text
    }
    name {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    competenciesItems {
      _id
      createdAt
      measure
      order
      questionTitle {
        localeCode
        text
      }
      responseStatements {
        _id
        responseIds
        text {
          localeCode
          text
        }
        type
      }
      responses {
        _id
        score
        text {
          localeCode
          text
        }
      }
      responsesLogic {
        _id
        data {
          _id
          createdAt
          questionDefinition {
            localeCode
            text
          }
          questionTitle {
            localeCode
            text
          }
          responses {
            _id
            score
            text {
              localeCode
              text
            }
          }
          updatedAt
        }
        responseId
        type
      }
      updatedAt
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateCompetencyGQL extends Apollo.Mutation<DuplicateCompetencyMutation, DuplicateCompetencyMutationVariables> {
    document = DuplicateCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashCompetencyGroupDocument = gql`
    mutation trashCompetencyGroup($organizationId: String!, $competencyGroupId: String!) {
  trashCompetencyGroup(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashCompetencyGroupGQL extends Apollo.Mutation<TrashCompetencyGroupMutation, TrashCompetencyGroupMutationVariables> {
    document = TrashCompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompetencyLocaleDocument = gql`
    mutation updateCompetencyLocale($competencyGroupId: String!, $input: UpdateCompetencyLocaleInput!, $localeCodes: [String!]!, $organizationId: String!) {
  updateCompetencyLocale(
    organizationId: $organizationId
    localeCodes: $localeCodes
    competencyGroupId: $competencyGroupId
    input: $input
  ) {
    _id
    name {
      localeCode
      text
    }
    definition {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompetencyLocaleGQL extends Apollo.Mutation<UpdateCompetencyLocaleMutation, UpdateCompetencyLocaleMutationVariables> {
    document = UpdateCompetencyLocaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompetenciesDocument = gql`
    query competencies($organizationId: String!, $competencyGroupId: String!, $localeCodes: [String!]!) {
  competencies(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    query: {localeCodes: $localeCodes}
  ) {
    _id
    name {
      localeCode
      text
    }
    definition {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    competenciesItems {
      _id
      measure
      questionTitle {
        localeCode
        text
      }
      order
      responses {
        _id
        text {
          localeCode
          text
        }
        score
      }
      responsesLogic {
        _id
        responseId
        type
        data {
          _id
          questionTitle {
            text
            localeCode
          }
          questionDefinition {
            text
            localeCode
          }
          responses {
            _id
            text {
              text
              localeCode
            }
            score
          }
          createdAt
          updatedAt
        }
      }
      responseStatements {
        _id
        text {
          localeCode
          text
        }
        responseIds
        type
      }
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompetenciesGQL extends Apollo.Query<CompetenciesQuery, CompetenciesQueryVariables> {
    document = CompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompetencyItemDocument = gql`
    mutation createCompetencyItem($organizationId: String!, $competencyGroupId: String!, $input: CreateCompetencyItemInput!) {
  createCompetencyItem(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    input: $input
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompetencyItemGQL extends Apollo.Mutation<CreateCompetencyItemMutation, CreateCompetencyItemMutationVariables> {
    document = CreateCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSurveyCompetencyItemDocument = gql`
    mutation createSurveyCompetencyItem($organizationId: String!, $input: CreateSurveyCompetencyItemInput!, $surveyId: String!) {
  createSurveyCompetencyItem(
    organizationId: $organizationId
    input: $input
    surveyId: $surveyId
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSurveyCompetencyItemGQL extends Apollo.Mutation<CreateSurveyCompetencyItemMutation, CreateSurveyCompetencyItemMutationVariables> {
    document = CreateSurveyCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompetencyItemDocument = gql`
    mutation deleteCompetencyItem($organizationId: String!, $competencyGroupId: String!, $input: DeleteCompetencyItemInput!) {
  deleteCompetencyItem(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    input: $input
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompetencyItemGQL extends Apollo.Mutation<DeleteCompetencyItemMutation, DeleteCompetencyItemMutationVariables> {
    document = DeleteCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSurveyCompetencyItemDocument = gql`
    mutation deleteSurveyCompetencyItem($organizationId: String!, $surveyId: String!, $input: DeleteSurveyCompetencyItemInput!) {
  deleteSurveyCompetencyItem(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSurveyCompetencyItemGQL extends Apollo.Mutation<DeleteSurveyCompetencyItemMutation, DeleteSurveyCompetencyItemMutationVariables> {
    document = DeleteSurveyCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateCompetencyItemDocument = gql`
    mutation duplicateCompetencyItem($organizationId: String!, $competencyGroupId: String!, $_id: String!, $competencyId: String!, $newCompetencyItemOrder: String!) {
  duplicateCompetencyItem(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    _id: $_id
    competencyId: $competencyId
    newCompetencyItemOrder: $newCompetencyItemOrder
  ) {
    _id
    createdAt
    measure
    order
    questionTitle {
      localeCode
      text
    }
    responseStatements {
      _id
      responseIds
      text {
        localeCode
        text
      }
      type
    }
    responses {
      _id
      score
      text {
        localeCode
        text
      }
    }
    responsesLogic {
      _id
      data {
        _id
        createdAt
        questionDefinition {
          localeCode
          text
        }
        questionTitle {
          localeCode
          text
        }
        responses {
          _id
          score
          text {
            localeCode
            text
          }
        }
        updatedAt
      }
      responseId
      type
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateCompetencyItemGQL extends Apollo.Mutation<DuplicateCompetencyItemMutation, DuplicateCompetencyItemMutationVariables> {
    document = DuplicateCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateSurveyCompetencyItemDocument = gql`
    mutation duplicateSurveyCompetencyItem($organizationId: String!, $surveyId: String!, $_id: String!, $surveyCompetencyId: String!, $newSurveyCompetencyItemOrder: String!) {
  duplicateSurveyCompetencyItem(
    organizationId: $organizationId
    surveyId: $surveyId
    _id: $_id
    surveyCompetencyId: $surveyCompetencyId
    newSurveyCompetencyItemOrder: $newSurveyCompetencyItemOrder
  ) {
    _id
    createdAt
    measure
    order
    questionTitle {
      localeCode
      text
    }
    responseStatements {
      _id
      responseIds
      text {
        localeCode
        text
      }
      type
    }
    responses {
      _id
      score
      text {
        localeCode
        text
      }
    }
    responsesLogic {
      _id
      data {
        _id
        createdAt
        questionDefinition {
          localeCode
          text
        }
        questionTitle {
          localeCode
          text
        }
        responses {
          _id
          score
          text {
            localeCode
            text
          }
        }
        updatedAt
      }
      responseId
      type
    }
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateSurveyCompetencyItemGQL extends Apollo.Mutation<DuplicateSurveyCompetencyItemMutation, DuplicateSurveyCompetencyItemMutationVariables> {
    document = DuplicateSurveyCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompetencyItemDocument = gql`
    mutation updateCompetencyItem($organizationId: String!, $competencyGroupId: String!, $input: UpdateCompetencyItemInput!, $withLocaleCodes: [String!]!) {
  updateCompetencyItem(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    input: $input
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompetencyItemGQL extends Apollo.Mutation<UpdateCompetencyItemMutation, UpdateCompetencyItemMutationVariables> {
    document = UpdateCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompetencyItemOrderDocument = gql`
    mutation updateCompetencyItemOrder($organizationId: String!, $competencyGroupId: String!, $input: UpdateCompetencyItemOrderInput!) {
  updateCompetencyItemOrder(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    input: $input
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompetencyItemOrderGQL extends Apollo.Mutation<UpdateCompetencyItemOrderMutation, UpdateCompetencyItemOrderMutationVariables> {
    document = UpdateCompetencyItemOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyCompetencyItemDocument = gql`
    mutation updateSurveyCompetencyItem($organizationId: String!, $input: UpdateSurveyCompetencyItemInput!, $surveyId: String!, $withLocaleCodes: [String!]!) {
  updateSurveyCompetencyItem(
    organizationId: $organizationId
    input: $input
    surveyId: $surveyId
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyCompetencyItemGQL extends Apollo.Mutation<UpdateSurveyCompetencyItemMutation, UpdateSurveyCompetencyItemMutationVariables> {
    document = UpdateSurveyCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyCompetencyItemOrderDocument = gql`
    mutation updateSurveyCompetencyItemOrder($input: UpdateSurveyCompetencyItemOrderInput!, $organizationId: String!, $surveyId: String!) {
  updateSurveyCompetencyItemOrder(
    organizationId: $organizationId
    input: $input
    surveyId: $surveyId
  ) {
    _id
    measure
    questionTitle {
      localeCode
      text
    }
    order
    responses {
      _id
      text {
        localeCode
        text
      }
      score
    }
    responsesLogic {
      _id
      responseId
      type
      data {
        _id
        questionTitle {
          text
          localeCode
        }
        questionDefinition {
          text
          localeCode
        }
        responses {
          _id
          text {
            text
            localeCode
          }
          score
        }
        createdAt
        updatedAt
      }
    }
    responseStatements {
      _id
      text {
        localeCode
        text
      }
      responseIds
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyCompetencyItemOrderGQL extends Apollo.Mutation<UpdateSurveyCompetencyItemOrderMutation, UpdateSurveyCompetencyItemOrderMutationVariables> {
    document = UpdateSurveyCompetencyItemOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompetencyItemResponseLogicDocument = gql`
    mutation updateCompetencyItemResponseLogic($organizationId: String!, $competencyGroupId: String!, $input: UpdateCompetencyItemResponseLogicSubItemInput!, $withLocaleCodes: [String!]!) {
  updateCompetencyItemResponseLogic(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
    input: $input
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    questionTitle {
      localeCode
      text
    }
    questionDefinition {
      text
      localeCode
    }
    responses {
      _id
      score
      text {
        localeCode
        text
      }
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompetencyItemResponseLogicGQL extends Apollo.Mutation<UpdateCompetencyItemResponseLogicMutation, UpdateCompetencyItemResponseLogicMutationVariables> {
    document = UpdateCompetencyItemResponseLogicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyCompetencyItemResponseLogicDocument = gql`
    mutation updateSurveyCompetencyItemResponseLogic($organizationId: String!, $surveyId: String!, $input: UpdateSurveyCompetencyItemResponseLogicSubItemInput!, $withLocaleCodes: [String!]!) {
  updateSurveyCompetencyItemResponseLogic(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    questionTitle {
      localeCode
      text
    }
    questionDefinition {
      text
      localeCode
    }
    responses {
      _id
      score
      text {
        localeCode
        text
      }
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyCompetencyItemResponseLogicGQL extends Apollo.Mutation<UpdateSurveyCompetencyItemResponseLogicMutation, UpdateSurveyCompetencyItemResponseLogicMutationVariables> {
    document = UpdateSurveyCompetencyItemResponseLogicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDemographicDocument = gql`
    mutation createDemographic($organizationId: String!, $demographicTemplateId: String!, $input: CreateDemographicInput!) {
  createDemographic(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
    input: $input
  ) {
    _id
    answers {
      _id
      text {
        localeCode
        text
      }
    }
    createdAt
    label {
      localeCode
      text
    }
    customErrorMessage {
      localeCode
      text
    }
    multipleChoicesValidationType
    multipleChoicesValidationValue
    order
    required
    shortAnswerValidation
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDemographicGQL extends Apollo.Mutation<CreateDemographicMutation, CreateDemographicMutationVariables> {
    document = CreateDemographicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDemographicTemplateDocument = gql`
    mutation createDemographicTemplate($organizationId: String!, $input: CreateDemographicTemplateInput!) {
  createDemographicTemplate(organizationId: $organizationId, input: $input) {
    _id
    createdAt
    defaultLocaleCode
    localeCodes
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDemographicTemplateGQL extends Apollo.Mutation<CreateDemographicTemplateMutation, CreateDemographicTemplateMutationVariables> {
    document = CreateDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDemographicDocument = gql`
    mutation deleteDemographic($organizationId: String!, $demographicId: String!, $demographicTemplateId: String!) {
  deleteDemographic(
    organizationId: $organizationId
    demographicId: $demographicId
    demographicTemplateId: $demographicTemplateId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDemographicGQL extends Apollo.Mutation<DeleteDemographicMutation, DeleteDemographicMutationVariables> {
    document = DeleteDemographicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateDemographicTemplateDocument = gql`
    mutation duplicateDemographicTemplate($organizationId: String!, $demographicTemplateId: String!) {
  duplicateDemographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
  ) {
    _id
    createdAt
    defaultLocaleCode
    localeCodes
    name
    trashedAt
    updatedAt
    demographicsCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateDemographicTemplateGQL extends Apollo.Mutation<DuplicateDemographicTemplateMutation, DuplicateDemographicTemplateMutationVariables> {
    document = DuplicateDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashDemographicTemplateDocument = gql`
    mutation trashDemographicTemplate($organizationId: String!, $demographicTemplateId: String!) {
  trashDemographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashDemographicTemplateGQL extends Apollo.Mutation<TrashDemographicTemplateMutation, TrashDemographicTemplateMutationVariables> {
    document = TrashDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDemographicDocument = gql`
    mutation updateDemographic($organizationId: String!, $demographicId: String!, $demographicTemplateId: String!, $input: UpdateDemographicInput!, $withLocaleCodes: [String!]!) {
  updateDemographic(
    organizationId: $organizationId
    demographicId: $demographicId
    demographicTemplateId: $demographicTemplateId
    input: $input
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    answers {
      _id
      text {
        localeCode
        text
      }
    }
    createdAt
    label {
      localeCode
      text
    }
    customErrorMessage {
      localeCode
      text
    }
    multipleChoicesValidationType
    multipleChoicesValidationValue
    order
    required
    shortAnswerValidation
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDemographicGQL extends Apollo.Mutation<UpdateDemographicMutation, UpdateDemographicMutationVariables> {
    document = UpdateDemographicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDemographicOrderDocument = gql`
    mutation updateDemographicOrder($organizationId: String!, $demographicId: String!, $demographicTemplateId: String!, $order: String!) {
  updateDemographicOrder(
    organizationId: $organizationId
    demographicId: $demographicId
    demographicTemplateId: $demographicTemplateId
    order: $order
  ) {
    _id
    answers {
      _id
      text {
        localeCode
        text
      }
    }
    createdAt
    label {
      localeCode
      text
    }
    customErrorMessage {
      localeCode
      text
    }
    multipleChoicesValidationType
    multipleChoicesValidationValue
    order
    required
    shortAnswerValidation
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDemographicOrderGQL extends Apollo.Mutation<UpdateDemographicOrderMutation, UpdateDemographicOrderMutationVariables> {
    document = UpdateDemographicOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDemographicTemplateDocument = gql`
    mutation updateDemographicTemplate($organizationId: String!, $demographicTemplateId: String!, $input: UpdateDemographicTemplateInput!) {
  updateDemographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
    input: $input
  ) {
    _id
    createdAt
    defaultLocaleCode
    localeCodes
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDemographicTemplateGQL extends Apollo.Mutation<UpdateDemographicTemplateMutation, UpdateDemographicTemplateMutationVariables> {
    document = UpdateDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DemographicTemplateDocument = gql`
    query demographicTemplate($organizationId: String!, $demographicTemplateId: String!) {
  demographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
  ) {
    _id
    createdAt
    defaultLocaleCode
    localeCodes
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DemographicTemplateGQL extends Apollo.Query<DemographicTemplateQuery, DemographicTemplateQueryVariables> {
    document = DemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DemographicsDocument = gql`
    query demographics($organizationId: String!, $demographicTemplateId: String!, $localeCodes: [String!]!) {
  demographics(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
    localeCodes: $localeCodes
  ) {
    _id
    answers {
      _id
      text {
        localeCode
        text
      }
    }
    createdAt
    customErrorMessage {
      localeCode
      text
    }
    label {
      localeCode
      text
    }
    multipleChoicesValidationType
    multipleChoicesValidationValue
    order
    required
    shortAnswerValidation
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DemographicsGQL extends Apollo.Query<DemographicsQuery, DemographicsQueryVariables> {
    document = DemographicsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDemographicTemplatesDocument = gql`
    query searchDemographicTemplates($organizationId: String!, $args: SearchDemographicTemplatesArgs!) {
  searchDemographicTemplates(organizationId: $organizationId, args: $args) {
    docs {
      _id
      createdAt
      defaultLocaleCode
      localeCodes
      name
      updatedAt
      demographicsCount
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDemographicTemplatesGQL extends Apollo.Query<SearchDemographicTemplatesQuery, SearchDemographicTemplatesQueryVariables> {
    document = SearchDemographicTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateKpiDocument = gql`
    mutation createKpi($input: CreateKpiInput!, $organizationId: String!) {
  createKpi(organizationId: $organizationId, input: $input) {
    _id
    score1Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score2Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score3Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score4Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score5Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score1NarrativesStatus
    score2NarrativesStatus
    score3NarrativesStatus
    score4NarrativesStatus
    score5NarrativesStatus
    type
    competencyIds
    localeCodes
    negativeStatement {
      localeCode
      text
    }
    notes {
      _id
      text {
        localeCode
        text
      }
      createdAt
    }
    positiveStatement {
      localeCode
      text
    }
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateKpiGQL extends Apollo.Mutation<CreateKpiMutation, CreateKpiMutationVariables> {
    document = CreateKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKpiDocument = gql`
    mutation deleteKpi($kpiId: String!, $organizationId: String!) {
  deleteKpi(organizationId: $organizationId, kpiId: $kpiId) {
    _id
    score1Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score2Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score3Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score4Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score5Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    type
    competencyIds
    localeCodes
    score1NarrativesStatus
    score2NarrativesStatus
    score3NarrativesStatus
    score4NarrativesStatus
    score5NarrativesStatus
    negativeStatement {
      localeCode
      text
    }
    notes {
      _id
      text {
        localeCode
        text
      }
      createdAt
    }
    positiveStatement {
      localeCode
      text
    }
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKpiGQL extends Apollo.Mutation<DeleteKpiMutation, DeleteKpiMutationVariables> {
    document = DeleteKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateKpiDocument = gql`
    mutation updateKpi($input: UpdateKpiInput!, $kpiId: String!, $organizationId: String!) {
  updateKpi(organizationId: $organizationId, input: $input, kpiId: $kpiId) {
    _id
    score1Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score2Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score3Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score4Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score5Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    type
    competencyIds
    localeCodes
    score1NarrativesStatus
    score2NarrativesStatus
    score3NarrativesStatus
    score4NarrativesStatus
    score5NarrativesStatus
    negativeStatement {
      localeCode
      text
    }
    notes {
      _id
      text {
        localeCode
        text
      }
      createdAt
    }
    positiveStatement {
      localeCode
      text
    }
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateKpiGQL extends Apollo.Mutation<UpdateKpiMutation, UpdateKpiMutationVariables> {
    document = UpdateKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const KpiDocument = gql`
    query kpi($organizationId: String!, $kpiId: String!) {
  kpi(organizationId: $organizationId, kpiId: $kpiId) {
    _id
    score1Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score2Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score3Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score4Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    score5Narratives {
      _id
      text {
        localeCode
        text
      }
    }
    type
    competencyIds
    localeCodes
    score1NarrativesStatus
    score2NarrativesStatus
    score3NarrativesStatus
    score4NarrativesStatus
    score5NarrativesStatus
    negativeStatement {
      localeCode
      text
    }
    notes {
      _id
      text {
        localeCode
        text
      }
      createdAt
    }
    positiveStatement {
      localeCode
      text
    }
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class KpiGQL extends Apollo.Query<KpiQuery, KpiQueryVariables> {
    document = KpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchKpisDocument = gql`
    query searchKpis($organizationId: String!, $args: SearchKpisArgs!) {
  searchKpis(organizationId: $organizationId, args: $args) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      score1Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score2Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score3Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score4Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      score5Narratives {
        _id
        text {
          localeCode
          text
        }
      }
      type
      competencyIds
      localeCodes
      score1NarrativesStatus
      score2NarrativesStatus
      score3NarrativesStatus
      score4NarrativesStatus
      score5NarrativesStatus
      negativeStatement {
        localeCode
        text
      }
      notes {
        _id
        text {
          localeCode
          text
        }
        createdAt
      }
      positiveStatement {
        localeCode
        text
      }
      updatedAt
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchKpisGQL extends Apollo.Query<SearchKpisQuery, SearchKpisQueryVariables> {
    document = SearchKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSelfRaterParticipantsDocument = gql`
    mutation createSelfRaterParticipants($input: CreateSelfRaterParticipantsInput!, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  createSelfRaterParticipants(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
    selfRaterId: $selfRaterId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSelfRaterParticipantsGQL extends Apollo.Mutation<CreateSelfRaterParticipantsMutation, CreateSelfRaterParticipantsMutationVariables> {
    document = CreateSelfRaterParticipantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSelfRaterParticipantDocument = gql`
    mutation deleteSelfRaterParticipant($participantId: String!, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  deleteSelfRaterParticipant(
    organizationId: $organizationId
    projectId: $projectId
    participantId: $participantId
    selfRaterId: $selfRaterId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSelfRaterParticipantGQL extends Apollo.Mutation<DeleteSelfRaterParticipantMutation, DeleteSelfRaterParticipantMutationVariables> {
    document = DeleteSelfRaterParticipantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportParticipantsCsvDocument = gql`
    mutation importParticipantsCsv($organizationId: String!, $projectId: String!, $participantsCsv: Upload) {
  importParticipantsCsv(
    organizationId: $organizationId
    projectId: $projectId
    participantsCsv: $participantsCsv
  ) {
    email
    participantTypeId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportParticipantsCsvGQL extends Apollo.Mutation<ImportParticipantsCsvMutation, ImportParticipantsCsvMutationVariables> {
    document = ImportParticipantsCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSelfRaterParticipantDocument = gql`
    mutation updateSelfRaterParticipant($input: UpdateSelfRaterParticipantInput!, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  updateSelfRaterParticipant(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
    selfRaterId: $selfRaterId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSelfRaterParticipantGQL extends Apollo.Mutation<UpdateSelfRaterParticipantMutation, UpdateSelfRaterParticipantMutationVariables> {
    document = UpdateSelfRaterParticipantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadParticipantsCsvTemplateDocument = gql`
    query downloadParticipantsCsvTemplate {
  downloadParticipantsCsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadParticipantsCsvTemplateGQL extends Apollo.Query<DownloadParticipantsCsvTemplateQuery, DownloadParticipantsCsvTemplateQueryVariables> {
    document = DownloadParticipantsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadStdParticipantsCsvTemplateDocument = gql`
    query downloadStdParticipantsCsvTemplate {
  downloadStdParticipantsCsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadStdParticipantsCsvTemplateGQL extends Apollo.Query<DownloadStdParticipantsCsvTemplateQuery, DownloadStdParticipantsCsvTemplateQueryVariables> {
    document = DownloadStdParticipantsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMasterProductIndicatorDocument = gql`
    mutation deleteMasterProductIndicator($masterProductId: String!, $_id: String!) {
  deleteMasterProductIndicator(masterProductId: $masterProductId, _id: $_id) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMasterProductIndicatorGQL extends Apollo.Mutation<DeleteMasterProductIndicatorMutation, DeleteMasterProductIndicatorMutationVariables> {
    document = DeleteMasterProductIndicatorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductIndicatorDocument = gql`
    mutation deleteProductIndicator($organizationId: String!, $productId: String!, $_id: String!) {
  deleteProductIndicator(
    organizationId: $organizationId
    productId: $productId
    _id: $_id
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductIndicatorGQL extends Apollo.Mutation<DeleteProductIndicatorMutation, DeleteProductIndicatorMutationVariables> {
    document = DeleteProductIndicatorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportMasterProductIndicatorsCsvTemplateDocument = gql`
    mutation exportMasterProductIndicatorsCsvTemplate($masterProductId: String!) {
  exportMasterProductIndicatorsCsvTemplate(masterProductId: $masterProductId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportMasterProductIndicatorsCsvTemplateGQL extends Apollo.Mutation<ExportMasterProductIndicatorsCsvTemplateMutation, ExportMasterProductIndicatorsCsvTemplateMutationVariables> {
    document = ExportMasterProductIndicatorsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportProductIndicatorsCsvTemplateDocument = gql`
    mutation exportProductIndicatorsCsvTemplate($organizationId: String!, $productId: String!) {
  exportProductIndicatorsCsvTemplate(
    organizationId: $organizationId
    productId: $productId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportProductIndicatorsCsvTemplateGQL extends Apollo.Mutation<ExportProductIndicatorsCsvTemplateMutation, ExportProductIndicatorsCsvTemplateMutationVariables> {
    document = ExportProductIndicatorsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportMasterProductIndicatorsCsvTemplateDocument = gql`
    mutation importMasterProductIndicatorsCsvTemplate($masterProductId: String!, $ProductIndicatorsCsv: Upload!) {
  importMasterProductIndicatorsCsvTemplate(
    masterProductId: $masterProductId
    ProductIndicatorsCsv: $ProductIndicatorsCsv
  ) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportMasterProductIndicatorsCsvTemplateGQL extends Apollo.Mutation<ImportMasterProductIndicatorsCsvTemplateMutation, ImportMasterProductIndicatorsCsvTemplateMutationVariables> {
    document = ImportMasterProductIndicatorsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportProductIndicatorsCsvTemplateDocument = gql`
    mutation importProductIndicatorsCsvTemplate($organizationId: String!, $productId: String!, $ProductIndicatorsCsv: Upload!) {
  importProductIndicatorsCsvTemplate(
    organizationId: $organizationId
    productId: $productId
    ProductIndicatorsCsv: $ProductIndicatorsCsv
  ) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportProductIndicatorsCsvTemplateGQL extends Apollo.Mutation<ImportProductIndicatorsCsvTemplateMutation, ImportProductIndicatorsCsvTemplateMutationVariables> {
    document = ImportProductIndicatorsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetMasterProductIndicatorsDocument = gql`
    mutation setMasterProductIndicators($masterProductId: String!, $input: [SetProductIndicatorInput!]!) {
  setMasterProductIndicators(masterProductId: $masterProductId, input: $input) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetMasterProductIndicatorsGQL extends Apollo.Mutation<SetMasterProductIndicatorsMutation, SetMasterProductIndicatorsMutationVariables> {
    document = SetMasterProductIndicatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetProductIndicatorsDocument = gql`
    mutation setProductIndicators($organizationId: String!, $productId: String!, $input: [SetProductIndicatorInput!]!) {
  setProductIndicators(
    organizationId: $organizationId
    productId: $productId
    input: $input
  ) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetProductIndicatorsGQL extends Apollo.Mutation<SetProductIndicatorsMutation, SetProductIndicatorsMutationVariables> {
    document = SetProductIndicatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadProductIndicatorsCsvTemplateDocument = gql`
    query downloadProductIndicatorsCsvTemplate {
  downloadProductIndicatorsCsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadProductIndicatorsCsvTemplateGQL extends Apollo.Query<DownloadProductIndicatorsCsvTemplateQuery, DownloadProductIndicatorsCsvTemplateQueryVariables> {
    document = DownloadProductIndicatorsCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterProductIndicatorsDocument = gql`
    query masterProductIndicators($masterProductId: String!) {
  masterProductIndicators(masterProductId: $masterProductId) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterProductIndicatorsGQL extends Apollo.Query<MasterProductIndicatorsQuery, MasterProductIndicatorsQueryVariables> {
    document = MasterProductIndicatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductIndicatorsDocument = gql`
    query productIndicators($organizationId: String!, $productId: String!) {
  productIndicators(organizationId: $organizationId, productId: $productId) {
    _id
    fromScore
    name
    toScore
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductIndicatorsGQL extends Apollo.Query<ProductIndicatorsQuery, ProductIndicatorsQueryVariables> {
    document = ProductIndicatorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMasterProductNarrativeDocument = gql`
    mutation createMasterProductNarrative($masterProductId: String!, $input: CreateProductNarrativeInput!) {
  createMasterProductNarrative(masterProductId: $masterProductId, input: $input) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMasterProductNarrativeGQL extends Apollo.Mutation<CreateMasterProductNarrativeMutation, CreateMasterProductNarrativeMutationVariables> {
    document = CreateMasterProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductNarrativeDocument = gql`
    mutation createProductNarrative($organizationId: String!, $productId: String!, $input: CreateProductNarrativeInput!) {
  createProductNarrative(
    organizationId: $organizationId
    productId: $productId
    input: $input
  ) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductNarrativeGQL extends Apollo.Mutation<CreateProductNarrativeMutation, CreateProductNarrativeMutationVariables> {
    document = CreateProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMasterProductNarrativeDocument = gql`
    mutation deleteMasterProductNarrative($masterProductId: String!, $_id: String!) {
  deleteMasterProductNarrative(masterProductId: $masterProductId, _id: $_id) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMasterProductNarrativeGQL extends Apollo.Mutation<DeleteMasterProductNarrativeMutation, DeleteMasterProductNarrativeMutationVariables> {
    document = DeleteMasterProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductNarrativeDocument = gql`
    mutation deleteProductNarrative($organizationId: String!, $productId: String!, $_id: String!) {
  deleteProductNarrative(
    organizationId: $organizationId
    productId: $productId
    _id: $_id
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductNarrativeGQL extends Apollo.Mutation<DeleteProductNarrativeMutation, DeleteProductNarrativeMutationVariables> {
    document = DeleteProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportMasterProductNarrativesCsvTemplateDocument = gql`
    mutation exportMasterProductNarrativesCsvTemplate($masterProductId: String!) {
  exportMasterProductNarrativesCsvTemplate(masterProductId: $masterProductId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportMasterProductNarrativesCsvTemplateGQL extends Apollo.Mutation<ExportMasterProductNarrativesCsvTemplateMutation, ExportMasterProductNarrativesCsvTemplateMutationVariables> {
    document = ExportMasterProductNarrativesCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportProductNarrativesCsvTemplateDocument = gql`
    mutation exportProductNarrativesCsvTemplate($organizationId: String!, $productId: String!) {
  exportProductNarrativesCsvTemplate(
    organizationId: $organizationId
    productId: $productId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportProductNarrativesCsvTemplateGQL extends Apollo.Mutation<ExportProductNarrativesCsvTemplateMutation, ExportProductNarrativesCsvTemplateMutationVariables> {
    document = ExportProductNarrativesCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportMasterProductNarrativeCsvTemplateDocument = gql`
    mutation importMasterProductNarrativeCsvTemplate($masterProductId: String!, $productNarrativesCsv: Upload!) {
  importMasterProductNarrativeCsvTemplate(
    masterProductId: $masterProductId
    productNarrativesCsv: $productNarrativesCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportMasterProductNarrativeCsvTemplateGQL extends Apollo.Mutation<ImportMasterProductNarrativeCsvTemplateMutation, ImportMasterProductNarrativeCsvTemplateMutationVariables> {
    document = ImportMasterProductNarrativeCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportProductNarrativeCsvTemplateDocument = gql`
    mutation importProductNarrativeCsvTemplate($organizationId: String!, $productId: String!, $productNarrativesCsv: Upload!) {
  importProductNarrativeCsvTemplate(
    organizationId: $organizationId
    productId: $productId
    productNarrativesCsv: $productNarrativesCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportProductNarrativeCsvTemplateGQL extends Apollo.Mutation<ImportProductNarrativeCsvTemplateMutation, ImportProductNarrativeCsvTemplateMutationVariables> {
    document = ImportProductNarrativeCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMasterProductNarrativeDocument = gql`
    mutation updateMasterProductNarrative($masterProductId: String!, $_id: String!, $input: UpdateProductNarrativeInput!) {
  updateMasterProductNarrative(
    masterProductId: $masterProductId
    _id: $_id
    input: $input
  ) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMasterProductNarrativeGQL extends Apollo.Mutation<UpdateMasterProductNarrativeMutation, UpdateMasterProductNarrativeMutationVariables> {
    document = UpdateMasterProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductNarrativeDocument = gql`
    mutation updateProductNarrative($organizationId: String!, $productId: String!, $_id: String!, $input: UpdateProductNarrativeInput!) {
  updateProductNarrative(
    organizationId: $organizationId
    productId: $productId
    _id: $_id
    input: $input
  ) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductNarrativeGQL extends Apollo.Mutation<UpdateProductNarrativeMutation, UpdateProductNarrativeMutationVariables> {
    document = UpdateProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadProductNarrativesCsvTemplateDocument = gql`
    query downloadProductNarrativesCsvTemplate {
  downloadProductNarrativesCsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadProductNarrativesCsvTemplateGQL extends Apollo.Query<DownloadProductNarrativesCsvTemplateQuery, DownloadProductNarrativesCsvTemplateQueryVariables> {
    document = DownloadProductNarrativesCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterProductNarrativeDocument = gql`
    query masterProductNarrative($_id: String!, $masterProductId: String!) {
  masterProductNarrative(_id: $_id, masterProductId: $masterProductId) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterProductNarrativeGQL extends Apollo.Query<MasterProductNarrativeQuery, MasterProductNarrativeQueryVariables> {
    document = MasterProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductNarrativeDocument = gql`
    query productNarrative($organizationId: String!, $_id: String!, $productId: String!) {
  productNarrative(
    organizationId: $organizationId
    _id: $_id
    productId: $productId
  ) {
    _id
    content
    dimension
    indicatorId
    langCode
    order
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductNarrativeGQL extends Apollo.Query<ProductNarrativeQuery, ProductNarrativeQueryVariables> {
    document = ProductNarrativeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMasterProductNarrativesDocument = gql`
    query searchMasterProductNarratives($args: SearchProductNarrativeArgs!, $masterProductId: String!) {
  searchMasterProductNarratives(args: $args, masterProductId: $masterProductId) {
    docs {
      _id
      content
      dimension
      indicatorId
      langCode
      order
      type
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMasterProductNarrativesGQL extends Apollo.Query<SearchMasterProductNarrativesQuery, SearchMasterProductNarrativesQueryVariables> {
    document = SearchMasterProductNarrativesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProductNarrativesDocument = gql`
    query searchProductNarratives($organizationId: String!, $args: SearchProductNarrativeArgs!, $productId: String!) {
  searchProductNarratives(
    organizationId: $organizationId
    args: $args
    productId: $productId
  ) {
    docs {
      _id
      content
      dimension
      indicatorId
      langCode
      order
      type
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProductNarrativesGQL extends Apollo.Query<SearchProductNarrativesQuery, SearchProductNarrativesQueryVariables> {
    document = SearchProductNarrativesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMasterProductDocument = gql`
    mutation createMasterProduct($image: Upload, $input: CreateMasterProductInput!) {
  createMasterProduct(input: $input, image: $image) {
    _id
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    createdAt
    description
    image
    name
    type
    units
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMasterProductGQL extends Apollo.Mutation<CreateMasterProductMutation, CreateMasterProductMutationVariables> {
    document = CreateMasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductDocument = gql`
    mutation createProduct($image: Upload, $input: CreateProductInput!, $organizationId: String!) {
  createProduct(input: $input, image: $image, organizationId: $organizationId) {
    _id
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    createdAt
    description
    image
    name
    type
    masterProductId
    isSent
    units
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductGQL extends Apollo.Mutation<CreateProductMutation, CreateProductMutationVariables> {
    document = CreateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductLinkGeneratorDocument = gql`
    mutation productLinkGenerator($organizationId: String!, $input: LinkGeneratorInput!, $candidatesCsv: Upload) {
  productLinkGenerator(
    organizationId: $organizationId
    input: $input
    candidatesCsv: $candidatesCsv
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductLinkGeneratorGQL extends Apollo.Mutation<ProductLinkGeneratorMutation, ProductLinkGeneratorMutationVariables> {
    document = ProductLinkGeneratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendProductSessionDocument = gql`
    mutation resendProductSession($assessmentId: String!, $email: String!, $organizationId: String!, $productId: String!, $productSendId: String!, $withNewToken: Boolean, $resendEmail: Boolean) {
  resendProductSession(
    assessmentId: $assessmentId
    email: $email
    organizationId: $organizationId
    productId: $productId
    productSendId: $productSendId
    withNewToken: $withNewToken
    resendEmail: $resendEmail
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendProductSessionGQL extends Apollo.Mutation<ResendProductSessionMutation, ResendProductSessionMutationVariables> {
    document = ResendProductSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendBulkProductsDocument = gql`
    mutation sendBulkProducts($input: SendProductsInput!, $organizationId: String!, $candidatesCsv: Upload) {
  sendBulkProducts(
    input: $input
    organizationId: $organizationId
    candidatesCsv: $candidatesCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendBulkProductsGQL extends Apollo.Mutation<SendBulkProductsMutation, SendBulkProductsMutationVariables> {
    document = SendBulkProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendProductsToIndividualDocument = gql`
    mutation sendProductsToIndividual($input: SendProductsToIndividualInput!, $organizationId: String!) {
  sendProductsToIndividual(input: $input, organizationId: $organizationId) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendProductsToIndividualGQL extends Apollo.Mutation<SendProductsToIndividualMutation, SendProductsToIndividualMutationVariables> {
    document = SendProductsToIndividualDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashMasterProductDocument = gql`
    mutation trashMasterProduct($masterProductId: String!) {
  trashMasterProduct(masterProductId: $masterProductId) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashMasterProductGQL extends Apollo.Mutation<TrashMasterProductMutation, TrashMasterProductMutationVariables> {
    document = TrashMasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashProductDocument = gql`
    mutation trashProduct($productId: String!, $organizationId: String!) {
  trashProduct(productId: $productId, organizationId: $organizationId) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashProductGQL extends Apollo.Mutation<TrashProductMutation, TrashProductMutationVariables> {
    document = TrashProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMasterProductDocument = gql`
    mutation updateMasterProduct($image: Upload, $input: UpdateMasterProductInput!, $masterProductId: String!) {
  updateMasterProduct(
    input: $input
    image: $image
    masterProductId: $masterProductId
  ) {
    _id
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    createdAt
    description
    image
    name
    type
    units
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMasterProductGQL extends Apollo.Mutation<UpdateMasterProductMutation, UpdateMasterProductMutationVariables> {
    document = UpdateMasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDocument = gql`
    mutation updateProduct($image: Upload, $input: UpdateProductInput!, $productId: String!, $organizationId: String!) {
  updateProduct(
    input: $input
    image: $image
    productId: $productId
    organizationId: $organizationId
  ) {
    _id
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    createdAt
    description
    image
    name
    type
    masterProductId
    isSent
    units
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductGQL extends Apollo.Mutation<UpdateProductMutation, UpdateProductMutationVariables> {
    document = UpdateProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignedAssessmentsDocument = gql`
    query assignedAssessments {
  assignedAssessments {
    _id
    productId
    productName
    productImage
    assessmentLink
    expiryDate
    isExpired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignedAssessmentsGQL extends Apollo.Query<AssignedAssessmentsQuery, AssignedAssessmentsQueryVariables> {
    document = AssignedAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadBulkSenderTemplateDocument = gql`
    query downloadBulkSenderTemplate {
  downloadBulkSenderTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadBulkSenderTemplateGQL extends Apollo.Query<DownloadBulkSenderTemplateQuery, DownloadBulkSenderTemplateQueryVariables> {
    document = DownloadBulkSenderTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadLinksGeneratorTemplateDocument = gql`
    query downloadLinksGeneratorTemplate {
  downloadLinksGeneratorTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadLinksGeneratorTemplateGQL extends Apollo.Query<DownloadLinksGeneratorTemplateQuery, DownloadLinksGeneratorTemplateQueryVariables> {
    document = DownloadLinksGeneratorTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MasterProductDocument = gql`
    query masterProduct($masterProductId: String!) {
  masterProduct(masterProductId: $masterProductId) {
    _id
    createdAt
    name
    type
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    units
    image
    description
    narrativesCount
    createdAt
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MasterProductGQL extends Apollo.Query<MasterProductQuery, MasterProductQueryVariables> {
    document = MasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationAdsAssessmentsDocument = gql`
    query organizationAdsAssessments($limit: Float!, $searchTerm: String, $page: Float!, $organizationId: String!) {
  organizationAdsAssessments(
    args: {page: $page, limit: $limit, searchTerm: $searchTerm}
    organizationId: $organizationId
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      name
      displayName
      image
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationAdsAssessmentsGQL extends Apollo.Query<OrganizationAdsAssessmentsQuery, OrganizationAdsAssessmentsQueryVariables> {
    document = OrganizationAdsAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductDocument = gql`
    query product($productId: String!, $organizationId: String!) {
  product(organizationId: $organizationId, productId: $productId) {
    _id
    createdAt
    name
    type
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    units
    image
    description
    masterProductId
    isSent
    narrativesCount
    createdAt
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductGQL extends Apollo.Query<ProductQuery, ProductQueryVariables> {
    document = ProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMasterProductsDocument = gql`
    query searchMasterProducts($limit: Float!, $searchTerm: String, $page: Float!) {
  searchMasterProducts(
    args: {page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      createdAt
      name
      type
      assessments {
        _id
        assessmentId
        assessmentName
        adsAssessmentName
      }
      units
      image
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMasterProductsGQL extends Apollo.Query<SearchMasterProductsQuery, SearchMasterProductsQueryVariables> {
    document = SearchMasterProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProductsDocument = gql`
    query searchProducts($args: SearchProductArgs!, $organizationId: String!) {
  searchProducts(args: $args, organizationId: $organizationId) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      createdAt
      name
      type
      assessments {
        _id
        assessmentId
        assessmentName
        adsAssessmentName
      }
      units
      image
      description
      masterProductId
      isSent
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProductsGQL extends Apollo.Query<SearchProductsQuery, SearchProductsQueryVariables> {
    document = SearchProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProjectDocument = gql`
    mutation createProject($organizationId: String!, $surveyId: String!, $input: CreateProjectInput!) {
  createProject(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProjectGQL extends Apollo.Mutation<CreateProjectMutation, CreateProjectMutationVariables> {
    document = CreateProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStdProjectDocument = gql`
    mutation createStdProject($organizationId: String!, $surveyId: String!, $input: CreateProjectInput!) {
  createStdProject(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStdProjectGQL extends Apollo.Mutation<CreateStdProjectMutation, CreateStdProjectMutationVariables> {
    document = CreateStdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStdProjectDocument = gql`
    mutation deleteStdProject($organizationId: String!, $projectId: String!) {
  deleteStdProject(organizationId: $organizationId, projectId: $projectId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStdProjectGQL extends Apollo.Mutation<DeleteStdProjectMutation, DeleteStdProjectMutationVariables> {
    document = DeleteStdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStdReportsDocument = gql`
    mutation deleteStdReports($organizationId: String!, $stdReportsIds: [String!]!) {
  deleteStdReports(organizationId: $organizationId, stdReportsIds: $stdReportsIds) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStdReportsGQL extends Apollo.Mutation<DeleteStdReportsMutation, DeleteStdReportsMutationVariables> {
    document = DeleteStdReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExtendStdProjectEndDateDocument = gql`
    mutation extendStdProjectEndDate($organizationId: String!, $projectId: String!, $endDate: DateTime!) {
  extendStdProjectEndDate(
    organizationId: $organizationId
    projectId: $projectId
    endDate: $endDate
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExtendStdProjectEndDateGQL extends Apollo.Mutation<ExtendStdProjectEndDateMutation, ExtendStdProjectEndDateMutationVariables> {
    document = ExtendStdProjectEndDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreStdProjectDocument = gql`
    mutation restoreStdProject($organizationId: String!, $projectId: String!) {
  restoreStdProject(organizationId: $organizationId, projectId: $projectId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreStdProjectGQL extends Apollo.Mutation<RestoreStdProjectMutation, RestoreStdProjectMutationVariables> {
    document = RestoreStdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Send360ProjectViaCsvDocument = gql`
    mutation Send360ProjectViaCsv($organizationId: String!, $projectId: String!, $input: SendProjectViaCsvInput!, $selfRatersCsv: Upload) {
  send360ProjectViaCsv(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
    selfRatersCsv: $selfRatersCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Send360ProjectViaCsvGQL extends Apollo.Mutation<Send360ProjectViaCsvMutation, Send360ProjectViaCsvMutationVariables> {
    document = Send360ProjectViaCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendProjectDocument = gql`
    mutation sendProject($organizationId: String!, $projectId: String!, $input: SendProjectInput!) {
  sendProject(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendProjectGQL extends Apollo.Mutation<SendProjectMutation, SendProjectMutationVariables> {
    document = SendProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendStdProject2Document = gql`
    mutation sendStdProject2($organizationId: String!, $projectId: String!, $sendStdProjectInput: SendStdProjectInput!, $participantsCsv: Upload) {
  sendStdProject2(
    organizationId: $organizationId
    projectId: $projectId
    sendStdProjectInput: $sendStdProjectInput
    participantsCsv: $participantsCsv
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendStdProject2GQL extends Apollo.Mutation<SendStdProject2Mutation, SendStdProject2MutationVariables> {
    document = SendStdProject2Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetProjectSettingsDocument = gql`
    mutation setProjectSettings($organizationId: String!, $projectId: String!, $input: SetProjectSettingsInput!) {
  setProjectSettings(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
  ) {
    _id
    globalSubject
    globalBody
    unifyEmailForAll
    restrictLogin
    participantTypes {
      _id
      name
    }
    participantEmailTemplates {
      _id
      subject
      body
      participantTypeId
    }
    selfRaterSubject
    selfRaterBody
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetProjectSettingsGQL extends Apollo.Mutation<SetProjectSettingsMutation, SetProjectSettingsMutationVariables> {
    document = SetProjectSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetStdProjectSettingsDocument = gql`
    mutation setStdProjectSettings($organizationId: String!, $projectId: String!, $input: SetStdProjectSettingsInput!) {
  setStdProjectSettings(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
  ) {
    _id
    globalSubject
    globalBody
    restrictLogin
    allowPublicLink
    showDimensions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetStdProjectSettingsGQL extends Apollo.Mutation<SetStdProjectSettingsMutation, SetStdProjectSettingsMutationVariables> {
    document = SetStdProjectSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncStdProjectTypoDocument = gql`
    mutation syncStdProjectTypo($organizationId: String!, $projectId: String!) {
  syncStdProjectTypo(organizationId: $organizationId, projectId: $projectId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncStdProjectTypoGQL extends Apollo.Mutation<SyncStdProjectTypoMutation, SyncStdProjectTypoMutationVariables> {
    document = SyncStdProjectTypoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashStdProjectDocument = gql`
    mutation trashStdProject($organizationId: String!, $projectId: String!) {
  trashStdProject(organizationId: $organizationId, projectId: $projectId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashStdProjectGQL extends Apollo.Mutation<TrashStdProjectMutation, TrashStdProjectMutationVariables> {
    document = TrashStdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjectDocument = gql`
    mutation updateProject($organizationId: String!, $projectId: String!, $input: UpdateProjectInput!) {
  updateProject(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
  ) {
    _id
    color
    createdAt
    name
    surveyId
    surveyName
    surveyType
    localeCodes
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjectGQL extends Apollo.Mutation<UpdateProjectMutation, UpdateProjectMutationVariables> {
    document = UpdateProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStdProjectDocument = gql`
    mutation updateStdProject($organizationId: String!, $projectId: String!, $input: UpdateStdProjectInput!) {
  updateStdProject(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
  ) {
    _id
    color
    createdAt
    name
    stdSurveyId
    stdSurveyName
    stdSurveyType
    trashedAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStdProjectGQL extends Apollo.Mutation<UpdateStdProjectMutation, UpdateStdProjectMutationVariables> {
    document = UpdateStdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStdProjectSessionDocument = gql`
    mutation updateStdProjectSession($organizationId: String!, $projectId: String!, $stdProjectSessionId: String!, $input: UpdateStdProjectSessionInput!) {
  updateStdProjectSession(
    organizationId: $organizationId
    projectId: $projectId
    stdProjectSessionId: $stdProjectSessionId
    input: $input
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStdProjectSessionGQL extends Apollo.Mutation<UpdateStdProjectSessionMutation, UpdateStdProjectSessionMutationVariables> {
    document = UpdateStdProjectSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountStdSessionsWithTrashedOptionDocument = gql`
    query countStdSessionsWithTrashedOption($organizationId: String!, $projectId: String!) {
  countStdSessionsWithTrashedOption(
    organizationId: $organizationId
    projectId: $projectId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountStdSessionsWithTrashedOptionGQL extends Apollo.Query<CountStdSessionsWithTrashedOptionQuery, CountStdSessionsWithTrashedOptionQueryVariables> {
    document = CountStdSessionsWithTrashedOptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadProject360CsvTemplateDocument = gql`
    query downloadProject360CsvTemplate {
  downloadProject360CsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadProject360CsvTemplateGQL extends Apollo.Query<DownloadProject360CsvTemplateQuery, DownloadProject360CsvTemplateQueryVariables> {
    document = DownloadProject360CsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsProjectNameExistDocument = gql`
    query isProjectNameExist($organizationId: String!, $name: String!) {
  isProjectNameExist(organizationId: $organizationId, name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsProjectNameExistGQL extends Apollo.Query<IsProjectNameExistQuery, IsProjectNameExistQueryVariables> {
    document = IsProjectNameExistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsStdProjectNameExistDocument = gql`
    query isStdProjectNameExist($organizationId: String!, $name: String!) {
  isStdProjectNameExist(organizationId: $organizationId, name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsStdProjectNameExistGQL extends Apollo.Query<IsStdProjectNameExistQuery, IsStdProjectNameExistQueryVariables> {
    document = IsStdProjectNameExistDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectDocument = gql`
    query project($organizationId: String!, $projectId: String!) {
  project(organizationId: $organizationId, projectId: $projectId) {
    _id
    color
    createdAt
    name
    surveyId
    surveyName
    surveyType
    localeCodes
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectGQL extends Apollo.Query<ProjectQuery, ProjectQueryVariables> {
    document = ProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectSettingsDocument = gql`
    query projectSettings($organizationId: String!, $projectId: String!) {
  projectSettings(organizationId: $organizationId, projectId: $projectId) {
    _id
    globalSubject
    globalBody
    unifyEmailForAll
    restrictLogin
    participantTypes {
      _id
      name
    }
    participantEmailTemplates {
      _id
      subject
      body
      participantTypeId
    }
    selfRaterSubject
    selfRaterBody
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectSettingsGQL extends Apollo.Query<ProjectSettingsQuery, ProjectSettingsQueryVariables> {
    document = ProjectSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchProjectsDocument = gql`
    query searchProjects($organizationId: String!, $args: SearchProjectsArgs!) {
  searchProjects(organizationId: $organizationId, args: $args) {
    docs {
      _id
      color
      createdAt
      name
      surveyId
      surveyName
      surveyType
      localeCodes
      updatedAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchProjectsGQL extends Apollo.Query<SearchProjectsQuery, SearchProjectsQueryVariables> {
    document = SearchProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchStdProjectReportsDocument = gql`
    query searchStdProjectReports($organizationId: String!, $args: SearchStdReportsArgs!) {
  searchStdProjectReports(organizationId: $organizationId, args: $args) {
    docs {
      _id
      stdSurveyId
      updatedAt
      createdAt
      createdById
      firstName
      image
      lastName
      link
      size
      stdProjectId
      stdProjectName
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchStdProjectReportsGQL extends Apollo.Query<SearchStdProjectReportsQuery, SearchStdProjectReportsQueryVariables> {
    document = SearchStdProjectReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchStdProjectSessionsDocument = gql`
    query searchStdProjectSessions($organizationId: String!, $projectId: String!, $args: SearchProjectSessionsArgs!) {
  searchStdProjectSessions(
    organizationId: $organizationId
    projectId: $projectId
    args: $args
  ) {
    docs {
      _id
      email
      expiryDate
      image
      isCompleted
      name
      businessUnit
      ageGroup
      city
      custom1
      custom2
      custom3
      department
      experience
      location
      seniority
      tenure
      gender
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchStdProjectSessionsGQL extends Apollo.Query<SearchStdProjectSessionsQuery, SearchStdProjectSessionsQueryVariables> {
    document = SearchStdProjectSessionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchStdProjectsDocument = gql`
    query searchStdProjects($organizationId: String!, $args: SearchStdProjectsArgs!) {
  searchStdProjects(organizationId: $organizationId, args: $args) {
    docs {
      _id
      color
      createdAt
      name
      stdSurveyId
      stdSurveyName
      trashedAt
      stdSurveyType
      updatedAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchStdProjectsGQL extends Apollo.Query<SearchStdProjectsQuery, SearchStdProjectsQueryVariables> {
    document = SearchStdProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchStdSurveyProjectsDocument = gql`
    query searchStdSurveyProjects($organizationId: String!, $args: SearchStdProjectsArgs!, $surveyId: String!) {
  searchStdSurveyProjects(
    organizationId: $organizationId
    args: $args
    surveyId: $surveyId
  ) {
    docs {
      _id
      color
      createdAt
      name
      stdSurveyId
      stdSurveyName
      stdSurveyType
      trashedAt
      updatedAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchStdSurveyProjectsGQL extends Apollo.Query<SearchStdSurveyProjectsQuery, SearchStdSurveyProjectsQueryVariables> {
    document = SearchStdSurveyProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSurveyProjectsDocument = gql`
    query searchSurveyProjects($organizationId: String!, $args: SearchProjectsArgs!, $surveyId: String!) {
  searchSurveyProjects(
    organizationId: $organizationId
    args: $args
    surveyId: $surveyId
  ) {
    docs {
      _id
      color
      createdAt
      name
      surveyId
      surveyName
      surveyType
      localeCodes
      updatedAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSurveyProjectsGQL extends Apollo.Query<SearchSurveyProjectsQuery, SearchSurveyProjectsQueryVariables> {
    document = SearchSurveyProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTrashedStdProjectsDocument = gql`
    query searchTrashedStdProjects($organizationId: String!, $args: SearchStdProjectsArgs!) {
  searchTrashedStdProjects(organizationId: $organizationId, args: $args) {
    docs {
      _id
      color
      createdAt
      name
      stdSurveyId
      stdSurveyName
      stdSurveyType
      trashedAt
      updatedAt
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTrashedStdProjectsGQL extends Apollo.Query<SearchTrashedStdProjectsQuery, SearchTrashedStdProjectsQueryVariables> {
    document = SearchTrashedStdProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectDocument = gql`
    query stdProject($organizationId: String!, $projectId: String!) {
  stdProject(organizationId: $organizationId, projectId: $projectId) {
    _id
    color
    createdAt
    name
    stdSurveyId
    stdSurveyName
    stdSurveyType
    trashedAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectGQL extends Apollo.Query<StdProjectQuery, StdProjectQueryVariables> {
    document = StdProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectHeatmapReportDocument = gql`
    query stdProjectHeatmapReport($organizationId: String!, $projectId: String!, $drillDownBy: StdProjectReportDrillDownArgs, $filterBy: StdProjectReportFilterArgs, $dynamicDemographicsFilter: [StdProjectReportDynamicDemographicsArgs!], $dimensionsFilter: [String!], $percentage: Float, $allowPercentageHeatMap: Boolean, $percentageHeatMapCutOff: Float) {
  stdProjectHeatmapReport(
    organizationId: $organizationId
    projectId: $projectId
    drillDownBy: $drillDownBy
    filterBy: $filterBy
    dynamicDemographicsFilter: $dynamicDemographicsFilter
    dimensionsFilter: $dimensionsFilter
    percentage: $percentage
    allowPercentageHeatMap: $allowPercentageHeatMap
    percentageHeatMapCutOff: $percentageHeatMapCutOff
  ) {
    dimensionId
    dimensionName
    drillDowns {
      key
      markedAs
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectHeatmapReportGQL extends Apollo.Query<StdProjectHeatmapReportQuery, StdProjectHeatmapReportQueryVariables> {
    document = StdProjectHeatmapReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectParticipantsReportDocument = gql`
    query stdProjectParticipantsReport($organizationId: String!, $projectId: String!, $drillDownBy: StdProjectReportDrillDownArgs, $filterBy: StdProjectReportFilterArgs, $dynamicDemographicsFilter: [StdProjectReportDynamicDemographicsArgs!]) {
  stdProjectParticipantsReport(
    organizationId: $organizationId
    projectId: $projectId
    drillDownBy: $drillDownBy
    filterBy: $filterBy
    dynamicDemographicsFilter: $dynamicDemographicsFilter
  ) {
    completedCount
    drillDownValue
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectParticipantsReportGQL extends Apollo.Query<StdProjectParticipantsReportQuery, StdProjectParticipantsReportQueryVariables> {
    document = StdProjectParticipantsReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectReportDocument = gql`
    query stdProjectReport($organizationId: String!, $projectId: String!, $drillDownBy: StdProjectReportDrillDownArgs, $dynamicDemographicsFilter: [StdProjectReportDynamicDemographicsArgs!], $filterBy: StdProjectReportFilterArgs, $dimensionsFilter: [String!]) {
  stdProjectReport(
    organizationId: $organizationId
    projectId: $projectId
    drillDownBy: $drillDownBy
    filterBy: $filterBy
    dimensionsFilter: $dimensionsFilter
    dynamicDemographicsFilter: $dynamicDemographicsFilter
  ) {
    sessionsCount
    filterFields {
      ageGroup
      seniority
      tenure
      businessUnit
      city
      custom1
      custom2
      custom3
      department
      experience
      gender
      location
    }
    dimensions {
      _id
      name
    }
    dynamicDemographics {
      _id
      label
      options {
        _id
        label
      }
    }
    dimensionGroups {
      dimensionId
      dimensionName
      questions {
        _id
        label
        answers {
          _id
          color
          drilledDowns {
            key
            value
          }
          score
          text
          totalFrequency
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectReportGQL extends Apollo.Query<StdProjectReportQuery, StdProjectReportQueryVariables> {
    document = StdProjectReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectReportDetailsDocument = gql`
    query stdProjectReportDetails($organizationId: String!, $projectId: String!) {
  stdProjectReportDetails(organizationId: $organizationId, projectId: $projectId) {
    dimensions {
      _id
      name
    }
    completedParticipants
    expirationDate
    qualitativeItems
    quantitativeItems
    totalParticipants
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectReportDetailsGQL extends Apollo.Query<StdProjectReportDetailsQuery, StdProjectReportDetailsQueryVariables> {
    document = StdProjectReportDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdProjectSettingsDocument = gql`
    query stdProjectSettings($organizationId: String!, $projectId: String!) {
  stdProjectSettings(organizationId: $organizationId, projectId: $projectId) {
    _id
    globalSubject
    globalBody
    restrictLogin
    allowPublicLink
    showDimensions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdProjectSettingsGQL extends Apollo.Query<StdProjectSettingsQuery, StdProjectSettingsQueryVariables> {
    document = StdProjectSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSystemLanguagesDocument = gql`
    query getSystemLanguages {
  getSystemLanguages {
    code
    name
    nativeName
    dir
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSystemLanguagesGQL extends Apollo.Query<GetSystemLanguagesQuery, GetSystemLanguagesQueryVariables> {
    document = GetSystemLanguagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateProductPdfReportDocument = gql`
    mutation generateProductPdfReport($email: String!, $organizationId: String!, $productId: String!, $productSendId: String!) {
  generateProductPdfReport(
    organizationId: $organizationId
    productId: $productId
    email: $email
    productSendId: $productSendId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateProductPdfReportGQL extends Apollo.Mutation<GenerateProductPdfReportMutation, GenerateProductPdfReportMutationVariables> {
    document = GenerateProductPdfReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateProductReportDocument = gql`
    mutation generateProductReport($organizationId: String!, $productId: String!, $startAt: DateTime, $endAt: DateTime) {
  generateProductReport(
    organizationId: $organizationId
    productId: $productId
    startAt: $startAt
    endAt: $endAt
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateProductReportGQL extends Apollo.Mutation<GenerateProductReportMutation, GenerateProductReportMutationVariables> {
    document = GenerateProductReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSingleProductAssessmentReportDocument = gql`
    mutation generateSingleProductAssessmentReport($organizationId: String!, $productId: String!, $adsAssessmentId: String!) {
  generateSingleProductAssessmentReport(
    organizationId: $organizationId
    productId: $productId
    adsAssessmentId: $adsAssessmentId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSingleProductAssessmentReportGQL extends Apollo.Mutation<GenerateSingleProductAssessmentReportMutation, GenerateSingleProductAssessmentReportMutationVariables> {
    document = GenerateSingleProductAssessmentReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateStdProjectCsvReportDocument = gql`
    mutation generateStdProjectCsvReport($organizationId: String!, $projectId: String!) {
  generateStdProjectCsvReport(
    organizationId: $organizationId
    projectId: $projectId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateStdProjectCsvReportGQL extends Apollo.Mutation<GenerateStdProjectCsvReportMutation, GenerateStdProjectCsvReportMutationVariables> {
    document = GenerateStdProjectCsvReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateStdProjectTokensDocument = gql`
    mutation generateStdProjectTokens($organizationId: String!, $projectId: String!, $input: GenerateStdProjectTokensInput!, $participantsCsv: Upload) {
  generateStdProjectTokens(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
    participantsCsv: $participantsCsv
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateStdProjectTokensGQL extends Apollo.Mutation<GenerateStdProjectTokensMutation, GenerateStdProjectTokensMutationVariables> {
    document = GenerateStdProjectTokensDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductSessionDocument = gql`
    mutation updateProductSession($email: String!, $firstName: String, $lastName: String, $organizationId: String!, $productId: String!, $productSendId: String!) {
  updateProductSession(
    organizationId: $organizationId
    productId: $productId
    email: $email
    productSendId: $productSendId
    firstName: $firstName
    lastName: $lastName
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductSessionGQL extends Apollo.Mutation<UpdateProductSessionMutation, UpdateProductSessionMutationVariables> {
    document = UpdateProductSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateMyProductReportDocument = gql`
    query generateMyProductReport($organizationId: String!, $productId: String!, $productSendId: String!) {
  generateMyProductReport(
    organizationId: $organizationId
    productId: $productId
    productSendId: $productSendId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateMyProductReportGQL extends Apollo.Query<GenerateMyProductReportQuery, GenerateMyProductReportQueryVariables> {
    document = GenerateMyProductReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyProductReportsDocument = gql`
    query myProductReports {
  myProductReports {
    groupId
    organizationId
    productId
    productSendId
    organizationName
    organizationImage
    productName
    productImage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyProductReportsGQL extends Apollo.Query<MyProductReportsQuery, MyProductReportsQueryVariables> {
    document = MyProductReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductEmailReportsDocument = gql`
    query productEmailReports($organizationId: String!, $args: ProductEmailReportsArgs!) {
  productEmailReports(organizationId: $organizationId, args: $args) {
    docs {
      _id
      createdAt
      email
      productId
      productImage
      productName
      updatedAt
      isProductDeleted
      productSendId
      firstName
      lastName
      userSessions {
        _id
        adsAssessmentName
        assessmentId
        assessmentName
        isCompleted
        assessmentLink
      }
    }
    hasNextPage
    hasPrevPage
    page
    limit
    pagingCounter
    prevPage
    nextPage
    totalPages
    totalDocs
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductEmailReportsGQL extends Apollo.Query<ProductEmailReportsQuery, ProductEmailReportsQueryVariables> {
    document = ProductEmailReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectRawScores360Document = gql`
    query projectRawScores360($organizationId: String!, $projectId: String!) {
  projectRawScores360(organizationId: $organizationId, projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectRawScores360GQL extends Apollo.Query<ProjectRawScores360Query, ProjectRawScores360QueryVariables> {
    document = ProjectRawScores360Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Report360DataForManySelfRatersDocument = gql`
    query report360DataForManySelfRaters($organizationId: String!, $projectId: String!, $lang: String) {
  report360DataForManySelfRaters(
    organizationId: $organizationId
    projectId: $projectId
    lang: $lang
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Report360DataForManySelfRatersGQL extends Apollo.Query<Report360DataForManySelfRatersQuery, Report360DataForManySelfRatersQueryVariables> {
    document = Report360DataForManySelfRatersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Report360DataDocument = gql`
    query report360Data($lang: String, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  report360Data(
    lang: $lang
    organizationId: $organizationId
    projectId: $projectId
    selfRaterId: $selfRaterId
  ) {
    actualRatersDescription
    selfRaterName
    skillSignificantGraph
    startDate
    summary
    surveyDuration
    competencies {
      col
      totalSelfRaterSkillMean
      definition
      name
      narratives {
        text
        type
      }
      participantsSkillAndSignificant {
        agreement
        keyInsights
        potentialUse
        significantMean
        skillMean
        typeName
      }
      row
      selfRaterSignificantMean
      selfRaterSkillMean
      totalSelfRaterAgreement
      totalSelfRaterSignificantMean
    }
    competenciesComments {
      name
      participants {
        comments
        name
      }
    }
    additionalComments {
      comments
      participantTypeId
      participantTypeName
    }
    areasForDevelopment {
      comments
      participantTypeId
      participantTypeName
    }
    strengths {
      comments
      participantTypeId
      participantTypeName
    }
    completed
    completedPercentage
    endDate
    isSelfRaterCompleted
    noCompleted
    participantsStatusAsGroup {
      participantsStatus {
        completed
        email
      }
      type
    }
    projectName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Report360DataGQL extends Apollo.Query<Report360DataQuery, Report360DataQueryVariables> {
    document = Report360DataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Report360PdfDocument = gql`
    query report360Pdf($lang: String, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  report360Pdf(
    lang: $lang
    organizationId: $organizationId
    projectId: $projectId
    selfRaterId: $selfRaterId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Report360PdfGQL extends Apollo.Query<Report360PdfQuery, Report360PdfQueryVariables> {
    document = Report360PdfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelfRaterRawScores360Document = gql`
    query selfRaterRawScores360($organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  selfRaterRawScores360(
    organizationId: $organizationId
    projectId: $projectId
    selfRaterId: $selfRaterId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelfRaterRawScores360GQL extends Apollo.Query<SelfRaterRawScores360Query, SelfRaterRawScores360QueryVariables> {
    document = SelfRaterRawScores360Document;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSelfRaterEndDateDocument = gql`
    mutation updateSelfRaterEndDate($input: UpdateProjectSelfRaterDateInput!, $organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  updateSelfRaterEndDate(
    organizationId: $organizationId
    projectId: $projectId
    input: $input
    selfRaterId: $selfRaterId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSelfRaterEndDateGQL extends Apollo.Mutation<UpdateSelfRaterEndDateMutation, UpdateSelfRaterEndDateMutationVariables> {
    document = UpdateSelfRaterEndDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSelfRatersDocument = gql`
    query searchSelfRaters($organizationId: String!, $projectId: String!, $args: SearchSelfRatersArgs!) {
  searchSelfRaters(
    organizationId: $organizationId
    projectId: $projectId
    args: $args
  ) {
    docs {
      _id
      email
      endDate
      image
      name
      userId
      completedParticipants
      totalParticipants
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSelfRatersGQL extends Apollo.Query<SearchSelfRatersQuery, SearchSelfRatersQueryVariables> {
    document = SearchSelfRatersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelfRaterDocument = gql`
    query selfRater($organizationId: String!, $_id: String!, $projectId: String!) {
  selfRater(organizationId: $organizationId, projectId: $projectId, _id: $_id) {
    _id
    email
    endDate
    image
    name
    isCompleted
    participants {
      _id
      email
      image
      name
      participantType
      participantTypeId
      userId
      isCompleted
    }
    sendDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelfRaterGQL extends Apollo.Query<SelfRaterQuery, SelfRaterQueryVariables> {
    document = SelfRaterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelJoiningRequestDocument = gql`
    mutation cancelJoiningRequest($joinRequestId: String!, $organizationId: String!) {
  cancelJoiningRequest(
    joinRequestId: $joinRequestId
    organizationId: $organizationId
  ) {
    _id
    organizationId
    userId
    createdAt
    userEmail
    userImage
    userName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelJoiningRequestGQL extends Apollo.Mutation<CancelJoiningRequestMutation, CancelJoiningRequestMutationVariables> {
    document = CancelJoiningRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!, $image: Upload) {
  createOrganization(input: $input, image: $image) {
    _id
    name
    image
    domain
    units
    adsApiKey
    access {
      assessmentModule
      surveyModule
    }
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationGQL extends Apollo.Mutation<CreateOrganizationMutation, CreateOrganizationMutationVariables> {
    document = CreateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateUniqueDomainDocument = gql`
    mutation generateUniqueDomain($organizationName: String!) {
  generateUniqueDomain(organizationName: $organizationName)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateUniqueDomainGQL extends Apollo.Mutation<GenerateUniqueDomainMutation, GenerateUniqueDomainMutationVariables> {
    document = GenerateUniqueDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JoinOrganizationDocument = gql`
    mutation joinOrganization($orgId: String!) {
  joinOrganization(organizationId: $orgId) {
    _id
    organizationId
    userId
    createdAt
    userEmail
    userImage
    userName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JoinOrganizationGQL extends Apollo.Mutation<JoinOrganizationMutation, JoinOrganizationMutationVariables> {
    document = JoinOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JoinOrganizationViaInvitationDocument = gql`
    mutation joinOrganizationViaInvitation($invitationToken: String!) {
  joinOrganizationViaInvitation(invitationToken: $invitationToken) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JoinOrganizationViaInvitationGQL extends Apollo.Mutation<JoinOrganizationViaInvitationMutation, JoinOrganizationViaInvitationMutationVariables> {
    document = JoinOrganizationViaInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectJoinRequestDocument = gql`
    mutation rejectJoinRequest($joinRequestId: String!, $organizationId: String!, $userId: String!) {
  rejectJoinRequest(
    joinRequestId: $joinRequestId
    organizationId: $organizationId
    userId: $userId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectJoinRequestGQL extends Apollo.Mutation<RejectJoinRequestMutation, RejectJoinRequestMutationVariables> {
    document = RejectJoinRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($organizationId: String!, $input: UpdateOrganizationInput!, $image: Upload) {
  updateOrganization(
    input: $input
    image: $image
    organizationId: $organizationId
  ) {
    _id
    name
    image
    jobTitle
    domain
    units
    adsApiKey
    access {
      assessmentModule
      surveyModule
    }
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGQL extends Apollo.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> {
    document = UpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationAccessDocument = gql`
    mutation updateOrganizationAccess($input: UpdateOrganizationAccessInput!) {
  updateOrganizationAccess(input: $input) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationAccessGQL extends Apollo.Mutation<UpdateOrganizationAccessMutation, UpdateOrganizationAccessMutationVariables> {
    document = UpdateOrganizationAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyJoiningRequestsDocument = gql`
    query myJoiningRequests {
  myJoiningRequests {
    _id
    organizationId
    userId
    createdAt
    userEmail
    userImage
    userName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyJoiningRequestsGQL extends Apollo.Query<MyJoiningRequestsQuery, MyJoiningRequestsQueryVariables> {
    document = MyJoiningRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyOrganizationDocument = gql`
    query myOrganization($organizationId: String!) {
  myOrganization(organizationId: $organizationId) {
    _id
    name
    image
    jobTitle
    domain
    units
    adsApiKey
    access {
      assessmentModule
      surveyModule
    }
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyOrganizationGQL extends Apollo.Query<MyOrganizationQuery, MyOrganizationQueryVariables> {
    document = MyOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyOrganizationsDocument = gql`
    query myOrganizations {
  myOrganizations {
    _id
    name
    image
    domain
    units
    adsApiKey
    access {
      assessmentModule
      surveyModule
    }
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyOrganizationsGQL extends Apollo.Query<MyOrganizationsQuery, MyOrganizationsQueryVariables> {
    document = MyOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationDocument = gql`
    query organization($organizationId: String!) {
  organization(organizationId: $organizationId) {
    _id
    name
    image
    domain
    active
    units
    consumedUnits
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationGQL extends Apollo.Query<OrganizationQuery, OrganizationQueryVariables> {
    document = OrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchOrganizationsDocument = gql`
    query searchOrganizations($name: String!, $page: Float!, $limit: Float!) {
  searchOrganizations(
    searchOrganizationsData: {name: $name, page: $page, limit: $limit}
  ) {
    docs {
      _id
      name
      image
    }
    page
    limit
    pagingCounter
    totalDocs
    totalPages
    hasNextPage
    hasPrevPage
    nextPage
    prevPage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchOrganizationsGQL extends Apollo.Query<SearchOrganizationsQuery, SearchOrganizationsQueryVariables> {
    document = SearchOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStandardSurveyPageDocument = gql`
    mutation createStandardSurveyPage($input: CreateStandardSurveyPageInput!, $organizationId: String!, $surveyId: String!) {
  createStandardSurveyPage(
    input: $input
    organizationId: $organizationId
    surveyId: $surveyId
  ) {
    _id
    name
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStandardSurveyPageGQL extends Apollo.Mutation<CreateStandardSurveyPageMutation, CreateStandardSurveyPageMutationVariables> {
    document = CreateStandardSurveyPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStdPageItemDocument = gql`
    mutation createStdPageItem($input: CreateStdPageItemInput!, $organizationId: String!, $surveyId: String!, $stdPageId: String!) {
  createStdPageItem(
    input: $input
    organizationId: $organizationId
    surveyId: $surveyId
    stdPageId: $stdPageId
  ) {
    _id
    answers {
      _id
      color
      score
      text {
        localeCode
        text
      }
      value
    }
    createdAt
    dimensionId
    infoText {
      localeCode
      text
    }
    order
    questionTitle {
      localeCode
      text
    }
    questions {
      _id
      dimensionId
      isInverted
      order
      subDimensionId
      text {
        localeCode
        text
      }
    }
    subDimensionId
    type
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStdPageItemGQL extends Apollo.Mutation<CreateStdPageItemMutation, CreateStdPageItemMutationVariables> {
    document = CreateStdPageItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStandardSurveyPageDocument = gql`
    mutation deleteStandardSurveyPage($_id: String!, $organizationId: String!, $surveyId: String!) {
  deleteStandardSurveyPage(
    _id: $_id
    organizationId: $organizationId
    surveyId: $surveyId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStandardSurveyPageGQL extends Apollo.Mutation<DeleteStandardSurveyPageMutation, DeleteStandardSurveyPageMutationVariables> {
    document = DeleteStandardSurveyPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStdPageItemDocument = gql`
    mutation deleteStdPageItem($_id: String!, $organizationId: String!, $surveyId: String!, $stdPageId: String!) {
  deleteStdPageItem(
    _id: $_id
    organizationId: $organizationId
    surveyId: $surveyId
    stdPageId: $stdPageId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStdPageItemGQL extends Apollo.Mutation<DeleteStdPageItemMutation, DeleteStdPageItemMutationVariables> {
    document = DeleteStdPageItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportStdAnswersFromCsvDocument = gql`
    mutation importStdAnswersFromCsv($organizationId: String!, $surveyId: String!, $stdAnswersCsv: Upload) {
  importStdAnswersFromCsv(
    organizationId: $organizationId
    surveyId: $surveyId
    stdAnswersCsv: $stdAnswersCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportStdAnswersFromCsvGQL extends Apollo.Mutation<ImportStdAnswersFromCsvMutation, ImportStdAnswersFromCsvMutationVariables> {
    document = ImportStdAnswersFromCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportStdQuestionsFromCsvDocument = gql`
    mutation importStdQuestionsFromCsv($organizationId: String!, $surveyId: String!, $stdQuestionsCsv: Upload) {
  importStdQuestionsFromCsv(
    organizationId: $organizationId
    surveyId: $surveyId
    stdQuestionsCsv: $stdQuestionsCsv
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportStdQuestionsFromCsvGQL extends Apollo.Mutation<ImportStdQuestionsFromCsvMutation, ImportStdQuestionsFromCsvMutationVariables> {
    document = ImportStdQuestionsFromCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetStandardSurveyDimensionsDocument = gql`
    mutation setStandardSurveyDimensions($input: SetStandardDimensionsInput!, $organizationId: String!, $surveyId: String!) {
  setStandardSurveyDimensions(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
  ) {
    _id
    name
    subDimensions {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetStandardSurveyDimensionsGQL extends Apollo.Mutation<SetStandardSurveyDimensionsMutation, SetStandardSurveyDimensionsMutationVariables> {
    document = SetStandardSurveyDimensionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStandardSurveyPageDocument = gql`
    mutation updateStandardSurveyPage($_id: String!, $input: UpdateStandardSurveyPageInput!, $organizationId: String!, $surveyId: String!) {
  updateStandardSurveyPage(
    _id: $_id
    input: $input
    organizationId: $organizationId
    surveyId: $surveyId
  ) {
    _id
    name
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStandardSurveyPageGQL extends Apollo.Mutation<UpdateStandardSurveyPageMutation, UpdateStandardSurveyPageMutationVariables> {
    document = UpdateStandardSurveyPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStdPageItemDocument = gql`
    mutation updateStdPageItem($input: UpdateStdPageItemInput!, $organizationId: String!, $stdPageId: String!, $surveyId: String!, $withLocaleCodes: [String!]!) {
  updateStdPageItem(
    input: $input
    organizationId: $organizationId
    surveyId: $surveyId
    stdPageId: $stdPageId
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    answers {
      _id
      color
      score
      text {
        localeCode
        text
      }
      value
    }
    createdAt
    dimensionId
    infoText {
      localeCode
      text
    }
    order
    questionTitle {
      localeCode
      text
    }
    questions {
      _id
      dimensionId
      isInverted
      order
      subDimensionId
      text {
        localeCode
        text
      }
    }
    subDimensionId
    type
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStdPageItemGQL extends Apollo.Mutation<UpdateStdPageItemMutation, UpdateStdPageItemMutationVariables> {
    document = UpdateStdPageItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStdPageItemOrderDocument = gql`
    mutation updateStdPageItemOrder($input: UpdateStdPageItemOrderInput!, $organizationId: String!, $stdPageId: String!, $surveyId: String!) {
  updateStdPageItemOrder(
    input: $input
    organizationId: $organizationId
    surveyId: $surveyId
    stdPageId: $stdPageId
  ) {
    _id
    answers {
      _id
      color
      score
      text {
        localeCode
        text
      }
      value
    }
    createdAt
    dimensionId
    infoText {
      localeCode
      text
    }
    order
    questionTitle {
      localeCode
      text
    }
    questions {
      _id
      dimensionId
      isInverted
      order
      subDimensionId
      text {
        localeCode
        text
      }
    }
    subDimensionId
    type
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStdPageItemOrderGQL extends Apollo.Mutation<UpdateStdPageItemOrderMutation, UpdateStdPageItemOrderMutationVariables> {
    document = UpdateStdPageItemOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportStdQuestionsAndAnswersToCsvDocument = gql`
    query exportStdQuestionsAndAnswersToCsv($organizationId: String!, $surveyId: String!) {
  exportStdQuestionsAndAnswersToCsv(
    organizationId: $organizationId
    surveyId: $surveyId
  ) {
    stdAnswersCsv
    stdQuestionsCsv
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportStdQuestionsAndAnswersToCsvGQL extends Apollo.Query<ExportStdQuestionsAndAnswersToCsvQuery, ExportStdQuestionsAndAnswersToCsvQueryVariables> {
    document = ExportStdQuestionsAndAnswersToCsvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StandardSurveyDimensionsDocument = gql`
    query standardSurveyDimensions($organizationId: String!, $surveyId: String!) {
  standardSurveyDimensions(organizationId: $organizationId, surveyId: $surveyId) {
    _id
    name
    subDimensions {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StandardSurveyDimensionsGQL extends Apollo.Query<StandardSurveyDimensionsQuery, StandardSurveyDimensionsQueryVariables> {
    document = StandardSurveyDimensionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StandardSurveyPageDocument = gql`
    query standardSurveyPage($_id: String!, $organizationId: String!, $surveyId: String!) {
  standardSurveyPage(
    _id: $_id
    organizationId: $organizationId
    surveyId: $surveyId
  ) {
    _id
    name
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StandardSurveyPageGQL extends Apollo.Query<StandardSurveyPageQuery, StandardSurveyPageQueryVariables> {
    document = StandardSurveyPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StandardSurveyPagesDocument = gql`
    query standardSurveyPages($organizationId: String!, $surveyId: String!) {
  standardSurveyPages(organizationId: $organizationId, surveyId: $surveyId) {
    _id
    name
    order
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StandardSurveyPagesGQL extends Apollo.Query<StandardSurveyPagesQuery, StandardSurveyPagesQueryVariables> {
    document = StandardSurveyPagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdPageItemsDocument = gql`
    query stdPageItems($organizationId: String!, $query: StdPageItemArgs!, $stdPageId: String!, $surveyId: String!) {
  stdPageItems(
    organizationId: $organizationId
    query: $query
    stdPageId: $stdPageId
    surveyId: $surveyId
  ) {
    _id
    answers {
      _id
      color
      score
      text {
        localeCode
        text
      }
      value
    }
    createdAt
    dimensionId
    infoText {
      localeCode
      text
    }
    order
    questionTitle {
      localeCode
      text
    }
    questions {
      _id
      dimensionId
      isInverted
      order
      subDimensionId
      text {
        localeCode
        text
      }
    }
    subDimensionId
    type
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdPageItemsGQL extends Apollo.Query<StdPageItemsQuery, StdPageItemsQueryVariables> {
    document = StdPageItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StdPagesWithPageItemsDocument = gql`
    query stdPagesWithPageItems($organizationId: String!, $surveyId: String!, $localeCodes: [String!]!) {
  stdPagesWithPageItems(
    organizationId: $organizationId
    localeCodes: $localeCodes
    surveyId: $surveyId
  ) {
    _id
    name
    order
    stdPageItems {
      _id
      answers {
        _id
        color
        score
        text {
          localeCode
          text
        }
        value
      }
      createdAt
      dimensionId
      infoText {
        localeCode
        text
      }
      order
      questionTitle {
        localeCode
        text
      }
      questions {
        _id
        dimensionId
        isInverted
        order
        subDimensionId
        text {
          localeCode
          text
        }
      }
      subDimensionId
      type
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StdPagesWithPageItemsGQL extends Apollo.Query<StdPagesWithPageItemsQuery, StdPagesWithPageItemsQueryVariables> {
    document = StdPagesWithPageItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUnitsDocument = gql`
    mutation addUnits($input: AddUnitsInput!) {
  addUnits(input: $input) {
    _id
    domain
    active
    image
    units
    image
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUnitsGQL extends Apollo.Mutation<AddUnitsMutation, AddUnitsMutationVariables> {
    document = AddUnitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LinkProductsToOrganizationDocument = gql`
    mutation linkProductsToOrganization($masterProductsIds: [String!]!, $organizationId: String!) {
  linkProductsToOrganization(
    masterProductsIds: $masterProductsIds
    organizationId: $organizationId
  ) {
    _id
    assessments {
      _id
      assessmentId
      assessmentName
      adsAssessmentName
    }
    createdAt
    description
    image
    isSent
    masterProductId
    name
    trashedAt
    type
    units
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkProductsToOrganizationGQL extends Apollo.Mutation<LinkProductsToOrganizationMutation, LinkProductsToOrganizationMutationVariables> {
    document = LinkProductsToOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuperAdminGenerateUniqueDomainDocument = gql`
    mutation superAdminGenerateUniqueDomain($organizationName: String!) {
  superAdminGenerateUniqueDomain(organizationName: $organizationName)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuperAdminGenerateUniqueDomainGQL extends Apollo.Mutation<SuperAdminGenerateUniqueDomainMutation, SuperAdminGenerateUniqueDomainMutationVariables> {
    document = SuperAdminGenerateUniqueDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuperAdminUpdateOrganizationDocument = gql`
    mutation superAdminUpdateOrganization($image: Upload, $input: UpdateOrganizationInput!, $organizationId: String!) {
  superAdminUpdateOrganization(
    image: $image
    organizationId: $organizationId
    input: $input
  ) {
    _id
    access {
      assessmentModule
      surveyModule
    }
    active
    adsApiKey
    domain
    image
    jobTitle
    name
    units
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuperAdminUpdateOrganizationGQL extends Apollo.Mutation<SuperAdminUpdateOrganizationMutation, SuperAdminUpdateOrganizationMutationVariables> {
    document = SuperAdminUpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleOrganizationActivationDocument = gql`
    mutation toggleOrganizationActivation($active: Boolean!, $organizationId: String!) {
  toggleOrganizationActivation(active: $active, organizationId: $organizationId) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleOrganizationActivationGQL extends Apollo.Mutation<ToggleOrganizationActivationMutation, ToggleOrganizationActivationMutationVariables> {
    document = ToggleOrganizationActivationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransferMasterSurveysDocument = gql`
    mutation transferMasterSurveys($masterSurveyIds: [String!]!, $transfereeOrganizationId: String!) {
  transferMasterSurveys(
    masterSurveyIds: $masterSurveyIds
    transfereeOrganizationId: $transfereeOrganizationId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransferMasterSurveysGQL extends Apollo.Mutation<TransferMasterSurveysMutation, TransferMasterSurveysMutationVariables> {
    document = TransferMasterSurveysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationAssignableProductsDocument = gql`
    query organizationAssignableProducts($args: PaginationArgs!, $organizationId: String!) {
  organizationAssignableProducts(args: $args, organizationId: $organizationId) {
    docs {
      _id
      assessments {
        _id
        assessmentId
        assessmentName
        adsAssessmentName
      }
      createdAt
      description
      image
      name
      trashedAt
      type
      units
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationAssignableProductsGQL extends Apollo.Query<OrganizationAssignableProductsQuery, OrganizationAssignableProductsQueryVariables> {
    document = OrganizationAssignableProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuperAdminAdsAssessmentsDocument = gql`
    query superAdminAdsAssessments($limit: Float!, $searchTerm: String, $page: Float!) {
  superAdminAdsAssessments(
    args: {page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      name
      displayName
      image
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuperAdminAdsAssessmentsGQL extends Apollo.Query<SuperAdminAdsAssessmentsQuery, SuperAdminAdsAssessmentsQueryVariables> {
    document = SuperAdminAdsAssessmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuperAdminOrganizationsDocument = gql`
    query superAdminOrganizations($limit: Float!, $searchTerm: String, $page: Float!) {
  superAdminOrganizations(
    args: {page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      name
      domain
      active
      image
      units
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuperAdminOrganizationsGQL extends Apollo.Query<SuperAdminOrganizationsQuery, SuperAdminOrganizationsQueryVariables> {
    document = SuperAdminOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerCompetencyItemDocument = gql`
    mutation answerCompetencyItem($input: AnswerCompetencyItemInput!, $sessionToken: String!) {
  answerCompetencyItem(sessionToken: $sessionToken, input: $input) {
    competencyItemId
    responseId
    subItem {
      _id
      questionTitle
      questionDefinition
      responses {
        _id
        text
      }
      selectedResponseId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerCompetencyItemGQL extends Apollo.Mutation<AnswerCompetencyItemMutation, AnswerCompetencyItemMutationVariables> {
    document = AnswerCompetencyItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerStdSessionDemographicDocument = gql`
    mutation answerStdSessionDemographic($input: AnswerStdSessionDemographicInput!, $stdSessionInfo: StdSessionInfoArgs!) {
  answerStdSessionDemographic(stdSessionInfo: $stdSessionInfo, input: $input) {
    answerId
    answerIds
    answerText
    demographicId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerStdSessionDemographicGQL extends Apollo.Mutation<AnswerStdSessionDemographicMutation, AnswerStdSessionDemographicMutationVariables> {
    document = AnswerStdSessionDemographicDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerStdSessionOpenEndedQuestionDocument = gql`
    mutation answerStdSessionOpenEndedQuestion($input: AnswerStdSessionOpenEndedQuestionInput!, $stdSessionInfo: StdSessionInfoArgs!) {
  answerStdSessionOpenEndedQuestion(
    stdSessionInfo: $stdSessionInfo
    input: $input
  ) {
    openEndedResponse
    stdPageItemId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerStdSessionOpenEndedQuestionGQL extends Apollo.Mutation<AnswerStdSessionOpenEndedQuestionMutation, AnswerStdSessionOpenEndedQuestionMutationVariables> {
    document = AnswerStdSessionOpenEndedQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerStdSessionPageItemQuestionDocument = gql`
    mutation answerStdSessionPageItemQuestion($input: AnswerStdSessionPageItemQuestionInput!, $stdSessionInfo: StdSessionInfoArgs!) {
  answerStdSessionPageItemQuestion(stdSessionInfo: $stdSessionInfo, input: $input) {
    answerId
    questionId
    stdPageItemId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerStdSessionPageItemQuestionGQL extends Apollo.Mutation<AnswerStdSessionPageItemQuestionMutation, AnswerStdSessionPageItemQuestionMutationVariables> {
    document = AnswerStdSessionPageItemQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnswerSubItemDocument = gql`
    mutation answerSubItem($input: AnswerSubItemInput!, $sessionToken: String!) {
  answerSubItem(sessionToken: $sessionToken, input: $input) {
    subItemId
    responseId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AnswerSubItemGQL extends Apollo.Mutation<AnswerSubItemMutation, AnswerSubItemMutationVariables> {
    document = AnswerSubItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApproveStdSessionPolicyDocument = gql`
    mutation approveStdSessionPolicy($approved: Boolean!, $stdSessionInfo: StdSessionInfoArgs!) {
  approveStdSessionPolicy(stdSessionInfo: $stdSessionInfo, approved: $approved) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApproveStdSessionPolicyGQL extends Apollo.Mutation<ApproveStdSessionPolicyMutation, ApproveStdSessionPolicyMutationVariables> {
    document = ApproveStdSessionPolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApproveSurveyPolicyDocument = gql`
    mutation approveSurveyPolicy($approved: Boolean!, $sessionToken: String!) {
  approveSurveyPolicy(sessionToken: $sessionToken, approved: $approved) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApproveSurveyPolicyGQL extends Apollo.Mutation<ApproveSurveyPolicyMutation, ApproveSurveyPolicyMutationVariables> {
    document = ApproveSurveyPolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommentCompetencyDocument = gql`
    mutation commentCompetency($input: CommentCompetencyInput!, $sessionToken: String!) {
  commentCompetency(sessionToken: $sessionToken, input: $input) {
    comment
    competencyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CommentCompetencyGQL extends Apollo.Mutation<CommentCompetencyMutation, CommentCompetencyMutationVariables> {
    document = CommentCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteStdProjectSessionsDocument = gql`
    mutation deleteStdProjectSessions($isAllSelected: Boolean, $organizationId: String!, $projectId: String!, $sessionIds: [String!]) {
  deleteStdProjectSessions(
    isAllSelected: $isAllSelected
    organizationId: $organizationId
    projectId: $projectId
    sessionIds: $sessionIds
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteStdProjectSessionsGQL extends Apollo.Mutation<DeleteStdProjectSessionsMutation, DeleteStdProjectSessionsMutationVariables> {
    document = DeleteStdProjectSessionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EndSessionDocument = gql`
    mutation endSession($additionalComments: String, $areasForDevelopment: String, $sessionToken: String!, $strengths: String) {
  endSession(
    additionalComments: $additionalComments
    areasForDevelopment: $areasForDevelopment
    sessionToken: $sessionToken
    strengths: $strengths
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EndSessionGQL extends Apollo.Mutation<EndSessionMutation, EndSessionMutationVariables> {
    document = EndSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EndStdSessionDocument = gql`
    mutation endStdSession($stdSessionInfo: StdSessionInfoArgs!) {
  endStdSession(stdSessionInfo: $stdSessionInfo) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EndStdSessionGQL extends Apollo.Mutation<EndStdSessionMutation, EndStdSessionMutationVariables> {
    document = EndStdSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PassInfoPageDocument = gql`
    mutation passInfoPage($sessionToken: String!) {
  passInfoPage(sessionToken: $sessionToken) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PassInfoPageGQL extends Apollo.Mutation<PassInfoPageMutation, PassInfoPageMutationVariables> {
    document = PassInfoPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PassStdSessionDemographicsPageDocument = gql`
    mutation passStdSessionDemographicsPage($stdSessionInfo: StdSessionInfoArgs!) {
  passStdSessionDemographicsPage(stdSessionInfo: $stdSessionInfo) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PassStdSessionDemographicsPageGQL extends Apollo.Mutation<PassStdSessionDemographicsPageMutation, PassStdSessionDemographicsPageMutationVariables> {
    document = PassStdSessionDemographicsPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PassStdSessionInfoPageDocument = gql`
    mutation passStdSessionInfoPage($stdSessionInfo: StdSessionInfoArgs!) {
  passStdSessionInfoPage(stdSessionInfo: $stdSessionInfo) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PassStdSessionInfoPageGQL extends Apollo.Mutation<PassStdSessionInfoPageMutation, PassStdSessionInfoPageMutationVariables> {
    document = PassStdSessionInfoPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Resend360SessionsByProjectIdDocument = gql`
    mutation resend360SessionsByProjectId($organizationId: String!, $projectId: String!) {
  resend360SessionsByProjectId(
    organizationId: $organizationId
    projectId: $projectId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Resend360SessionsByProjectIdGQL extends Apollo.Mutation<Resend360SessionsByProjectIdMutation, Resend360SessionsByProjectIdMutationVariables> {
    document = Resend360SessionsByProjectIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Resend360SessionsBySelfRaterIdDocument = gql`
    mutation resend360SessionsBySelfRaterId($organizationId: String!, $projectId: String!, $selfRaterId: String!) {
  resend360SessionsBySelfRaterId(
    organizationId: $organizationId
    projectId: $projectId
    selfRaterId: $selfRaterId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Resend360SessionsBySelfRaterIdGQL extends Apollo.Mutation<Resend360SessionsBySelfRaterIdMutation, Resend360SessionsBySelfRaterIdMutationVariables> {
    document = Resend360SessionsBySelfRaterIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendStdProjectSessionsDocument = gql`
    mutation resendStdProjectSessions($isAllSelected: Boolean, $organizationId: String!, $projectId: String!, $sessionIds: [String!]) {
  resendStdProjectSessions(
    isAllSelected: $isAllSelected
    organizationId: $organizationId
    projectId: $projectId
    sessionIds: $sessionIds
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendStdProjectSessionsGQL extends Apollo.Mutation<ResendStdProjectSessionsMutation, ResendStdProjectSessionsMutationVariables> {
    document = ResendStdProjectSessionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendSurveySessionDocument = gql`
    mutation resendSurveySession($organizationId: String!, $participantId: String!, $projectId: String!, $selfRaterId: String!) {
  resendSurveySession(
    organizationId: $organizationId
    participantId: $participantId
    projectId: $projectId
    selfRaterId: $selfRaterId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendSurveySessionGQL extends Apollo.Mutation<ResendSurveySessionMutation, ResendSurveySessionMutationVariables> {
    document = ResendSurveySessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelectLocaleDocument = gql`
    mutation selectLocale($sessionToken: String!, $input: SelectLocaleInput!) {
  selectLocale(sessionToken: $sessionToken, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelectLocaleGQL extends Apollo.Mutation<SelectLocaleMutation, SelectLocaleMutationVariables> {
    document = SelectLocaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SelectStdLocaleDocument = gql`
    mutation selectStdLocale($stdSessionInfo: StdSessionInfoArgs!, $input: StdSelectLocaleInput!) {
  selectStdLocale(stdSessionInfo: $stdSessionInfo, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SelectStdLocaleGQL extends Apollo.Mutation<SelectStdLocaleMutation, SelectStdLocaleMutationVariables> {
    document = SelectStdLocaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckStdSessionDocument = gql`
    query checkStdSession($stdSessionInfo: StdSessionInfoArgs!) {
  checkStdSession(stdSessionInfo: $stdSessionInfo) {
    allowBack
    mustAnswerAll
    demographics {
      _id
      required
      shortAnswerValidation
      type
      answerId
      answerIds
      answerText
      answers {
        _id
        label
      }
      customErrorMessage
      label
      multipleChoicesValidationType
      multipleChoicesValidationValue
      order
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selectedLocaleCode
    stdPageData {
      nextStdPageId
      prevStdPageId
      progressPercentage
      stdPageId
      stdPageItems {
        _id
        answers {
          _id
          text
        }
        infoText
        linearQuestions {
          _id
          order
          questionTitle
          selectedAnswerId
          dimensionName
          subDimensionName
        }
        openEndedAnswer
        openEndedQuestion
        openEndedDimensionName
        openEndedSubDimensionName
        order
        type
      }
    }
    responsesLayout
    surveyHorizontalImage
    surveyName
    surveyPrimaryColor
    surveyVerticalImage
    toRender
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckStdSessionGQL extends Apollo.Query<CheckStdSessionQuery, CheckStdSessionQueryVariables> {
    document = CheckStdSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckSurveySessionDocument = gql`
    query checkSurveySession($sessionToken: String!) {
  checkSurveySession(sessionToken: $sessionToken) {
    competencyData {
      comment
      competenciesItems {
        _id
        questionTitle
        responses {
          _id
          text
        }
        selectedResponseId
        order
        subItem {
          _id
          questionTitle
          questionDefinition
          responses {
            _id
            text
          }
          selectedResponseId
        }
      }
      competencyDefinition
      competencyId
      competencyName
      nextCompetencyId
      prevCompetencyId
      progressPercentage
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectedLocaleCode
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selfRaterName
    responsesLayout
    surveyHorizontalImage
    surveyPrimaryColor
    surveyVerticalImage
    toRender
    isSelfRater
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckSurveySessionGQL extends Apollo.Query<CheckSurveySessionQuery, CheckSurveySessionQueryVariables> {
    document = CheckSurveySessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NextCompetencyDocument = gql`
    query nextCompetency($sessionToken: String!) {
  nextCompetency(sessionToken: $sessionToken) {
    competencyData {
      comment
      competenciesItems {
        _id
        questionTitle
        responses {
          _id
          text
        }
        selectedResponseId
        order
        subItem {
          _id
          questionTitle
          questionDefinition
          responses {
            _id
            text
          }
          selectedResponseId
        }
      }
      competencyDefinition
      competencyId
      competencyName
      nextCompetencyId
      prevCompetencyId
      progressPercentage
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectedLocaleCode
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selfRaterName
    responsesLayout
    surveyHorizontalImage
    surveyPrimaryColor
    surveyVerticalImage
    toRender
    isSelfRater
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NextCompetencyGQL extends Apollo.Query<NextCompetencyQuery, NextCompetencyQueryVariables> {
    document = NextCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NextStdSessionPageDocument = gql`
    query nextStdSessionPage($stdSessionInfo: StdSessionInfoArgs!) {
  nextStdSessionPage(stdSessionInfo: $stdSessionInfo) {
    allowBack
    mustAnswerAll
    demographics {
      _id
      required
      shortAnswerValidation
      type
      answerId
      answerIds
      answerText
      answers {
        _id
        label
      }
      customErrorMessage
      label
      multipleChoicesValidationType
      multipleChoicesValidationValue
      order
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selectedLocaleCode
    stdPageData {
      nextStdPageId
      prevStdPageId
      progressPercentage
      stdPageId
      stdPageItems {
        _id
        answers {
          _id
          text
        }
        infoText
        linearQuestions {
          _id
          order
          questionTitle
          selectedAnswerId
          dimensionName
          subDimensionName
        }
        openEndedAnswer
        openEndedQuestion
        openEndedDimensionName
        openEndedSubDimensionName
        order
        type
      }
    }
    responsesLayout
    surveyHorizontalImage
    surveyName
    surveyPrimaryColor
    surveyVerticalImage
    toRender
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NextStdSessionPageGQL extends Apollo.Query<NextStdSessionPageQuery, NextStdSessionPageQueryVariables> {
    document = NextStdSessionPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PrevCompetencyDocument = gql`
    query prevCompetency($sessionToken: String!) {
  prevCompetency(sessionToken: $sessionToken) {
    competencyData {
      comment
      competenciesItems {
        _id
        questionTitle
        responses {
          _id
          text
        }
        selectedResponseId
        order
        subItem {
          _id
          questionTitle
          questionDefinition
          responses {
            _id
            text
          }
          selectedResponseId
        }
      }
      competencyDefinition
      competencyId
      competencyName
      nextCompetencyId
      prevCompetencyId
      progressPercentage
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectedLocaleCode
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selfRaterName
    responsesLayout
    surveyHorizontalImage
    surveyPrimaryColor
    surveyVerticalImage
    toRender
    isSelfRater
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PrevCompetencyGQL extends Apollo.Query<PrevCompetencyQuery, PrevCompetencyQueryVariables> {
    document = PrevCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PrevStdSessionPageDocument = gql`
    query prevStdSessionPage($stdSessionInfo: StdSessionInfoArgs!) {
  prevStdSessionPage(stdSessionInfo: $stdSessionInfo) {
    allowBack
    mustAnswerAll
    demographics {
      _id
      required
      shortAnswerValidation
      type
      answerId
      answerIds
      answerText
      answers {
        _id
        label
      }
      customErrorMessage
      label
      multipleChoicesValidationType
      multipleChoicesValidationValue
      order
    }
    infoPageData {
      infoPageContent
      isPolicyApproved
      isSurveyConsentRequired
      policyText
    }
    organizationName
    selectLocaleData {
      surveyDefaultLocale
      surveyLocaleCodes
    }
    selectedLocaleCode
    stdPageData {
      nextStdPageId
      prevStdPageId
      progressPercentage
      stdPageId
      stdPageItems {
        _id
        answers {
          _id
          text
        }
        infoText
        linearQuestions {
          _id
          order
          questionTitle
          selectedAnswerId
          dimensionName
          subDimensionName
        }
        openEndedAnswer
        openEndedQuestion
        openEndedDimensionName
        openEndedSubDimensionName
        order
        type
      }
    }
    responsesLayout
    surveyHorizontalImage
    surveyName
    surveyPrimaryColor
    surveyVerticalImage
    toRender
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PrevStdSessionPageGQL extends Apollo.Query<PrevStdSessionPageQuery, PrevStdSessionPageQueryVariables> {
    document = PrevStdSessionPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CloneCompetenciesToSurveyDocument = gql`
    mutation cloneCompetenciesToSurvey($organizationId: String!, $clonedCompetencies: [CloneCompetencyInput!]!, $surveyId: String!) {
  cloneCompetenciesToSurvey(
    organizationId: $organizationId
    clonedCompetencies: $clonedCompetencies
    surveyId: $surveyId
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CloneCompetenciesToSurveyGQL extends Apollo.Mutation<CloneCompetenciesToSurveyMutation, CloneCompetenciesToSurveyMutationVariables> {
    document = CloneCompetenciesToSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSurveyDocument = gql`
    mutation createSurvey($organizationId: String!, $input: CreateSurveyInput!) {
  createSurvey(organizationId: $organizationId, input: $input) {
    _id
    consentRequired
    createdAt
    defaultLocaleCode
    localeCodes
    name
    type
    updatedAt
    allowBack
    allowDemographics
    demographicTemplateId
    demographicTemplateName
    mustAnswerAll
    isReadOnly
    masterSurveyUnits
    responsesLayout
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSurveyGQL extends Apollo.Mutation<CreateSurveyMutation, CreateSurveyMutationVariables> {
    document = CreateSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSurveyCompetencyDocument = gql`
    mutation deleteSurveyCompetency($organizationId: String!, $surveyId: String!, $_id: String!) {
  deleteSurveyCompetency(
    organizationId: $organizationId
    surveyId: $surveyId
    _id: $_id
  ) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSurveyCompetencyGQL extends Apollo.Mutation<DeleteSurveyCompetencyMutation, DeleteSurveyCompetencyMutationVariables> {
    document = DeleteSurveyCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateSurveyDocument = gql`
    mutation duplicateSurvey($organizationId: String!, $surveyId: String!) {
  duplicateSurvey(organizationId: $organizationId, surveyId: $surveyId) {
    _id
    name
    type
    createdAt
    updatedAt
    consentRequired
    defaultLocaleCode
    localeCodes
    primaryColor
    horizontalImage
    verticalImage
    allowBack
    allowDemographics
    demographicTemplateId
    demographicTemplateName
    mustAnswerAll
    isReadOnly
    masterSurveyUnits
    responsesLayout
    trashedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateSurveyGQL extends Apollo.Mutation<DuplicateSurveyMutation, DuplicateSurveyMutationVariables> {
    document = DuplicateSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DuplicateSurveyCompetencyDocument = gql`
    mutation duplicateSurveyCompetency($organizationId: String!, $surveyId: String!, $_id: String!, $newSurveyCompetencyOrder: String!) {
  duplicateSurveyCompetency(
    organizationId: $organizationId
    surveyId: $surveyId
    _id: $_id
    newSurveyCompetencyOrder: $newSurveyCompetencyOrder
  ) {
    _id
    competenciesItems {
      _id
      createdAt
      measure
      order
      questionTitle {
        localeCode
        text
      }
      responseStatements {
        _id
        responseIds
        text {
          localeCode
          text
        }
        type
      }
      responses {
        _id
        score
        text {
          localeCode
          text
        }
      }
      responsesLogic {
        _id
        data {
          _id
          createdAt
          questionDefinition {
            localeCode
            text
          }
          questionTitle {
            localeCode
            text
          }
          responses {
            _id
            score
            text {
              localeCode
              text
            }
          }
          updatedAt
        }
        responseId
        type
      }
      updatedAt
    }
    createdAt
    definition {
      localeCode
      text
    }
    name {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    order
    originalCompetencyId
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateSurveyCompetencyGQL extends Apollo.Mutation<DuplicateSurveyCompetencyMutation, DuplicateSurveyCompetencyMutationVariables> {
    document = DuplicateSurveyCompetencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashSurveyDocument = gql`
    mutation trashSurvey($organizationId: String!, $surveyId: String!) {
  trashSurvey(organizationId: $organizationId, surveyId: $surveyId) {
    message
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashSurveyGQL extends Apollo.Mutation<TrashSurveyMutation, TrashSurveyMutationVariables> {
    document = TrashSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyDocument = gql`
    mutation updateSurvey($organizationId: String!, $surveyId: String!, $input: UpdateSurveyInput!, $horizontalImage: Upload, $verticalImage: Upload) {
  updateSurvey(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
    horizontalImage: $horizontalImage
    verticalImage: $verticalImage
  ) {
    _id
    name
    type
    createdAt
    updatedAt
    consentRequired
    defaultLocaleCode
    localeCodes
    primaryColor
    horizontalImage
    verticalImage
    allowBack
    allowDemographics
    demographicTemplateId
    demographicTemplateName
    mustAnswerAll
    isReadOnly
    masterSurveyUnits
    responsesLayout
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyGQL extends Apollo.Mutation<UpdateSurveyMutation, UpdateSurveyMutationVariables> {
    document = UpdateSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyCompetencyLocaleDocument = gql`
    mutation updateSurveyCompetencyLocale($organizationId: String!, $surveyId: String!, $localeCodes: [String!]!, $input: UpdateSurveyCompetencyLocaleInput!) {
  updateSurveyCompetencyLocale(
    organizationId: $organizationId
    surveyId: $surveyId
    localeCodes: $localeCodes
    input: $input
  ) {
    _id
    order
    originalCompetencyId
    name {
      localeCode
      text
    }
    definition {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyCompetencyLocaleGQL extends Apollo.Mutation<UpdateSurveyCompetencyLocaleMutation, UpdateSurveyCompetencyLocaleMutationVariables> {
    document = UpdateSurveyCompetencyLocaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSurveyLocaleDocument = gql`
    mutation updateSurveyLocale($organizationId: String!, $surveyId: String!, $input: UpdateSurveyLocaleInput!) {
  updateSurveyLocale(
    organizationId: $organizationId
    surveyId: $surveyId
    input: $input
  ) {
    _id
    name
    type
    createdAt
    updatedAt
    consentRequired
    defaultLocaleCode
    localeCodes
    horizontalImage
    allowBack
    allowDemographics
    demographicTemplateId
    demographicTemplateName
    mustAnswerAll
    isReadOnly
    masterSurveyUnits
    infoPageContent {
      localeCode
      text
    }
    policyText {
      localeCode
      text
    }
    primaryColor
    verticalImage
    responsesLayout
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSurveyLocaleGQL extends Apollo.Mutation<UpdateSurveyLocaleMutation, UpdateSurveyLocaleMutationVariables> {
    document = UpdateSurveyLocaleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSurveysDocument = gql`
    query searchSurveys($organizationId: String!, $limit: Float!, $searchTerm: String, $page: Float!) {
  searchSurveys(
    organizationId: $organizationId
    args: {page: $page, limit: $limit, searchTerm: $searchTerm}
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      consentRequired
      createdAt
      defaultLocaleCode
      localeCodes
      name
      type
      updatedAt
      horizontalImage
      primaryColor
      verticalImage
      allowBack
      allowDemographics
      demographicTemplateId
      demographicTemplateName
      mustAnswerAll
      isReadOnly
      masterSurveyUnits
      responsesLayout
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSurveysGQL extends Apollo.Query<SearchSurveysQuery, SearchSurveysQueryVariables> {
    document = SearchSurveysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SurveyDocument = gql`
    query survey($organizationId: String!, $surveyId: String!, $withLocaleCodes: [String!]) {
  survey(
    organizationId: $organizationId
    surveyId: $surveyId
    withLocaleCodes: $withLocaleCodes
  ) {
    _id
    consentRequired
    createdAt
    defaultLocaleCode
    infoPageContent {
      localeCode
      text
    }
    localeCodes
    name
    type
    updatedAt
    primaryColor
    horizontalImage
    verticalImage
    policyText {
      localeCode
      text
    }
    allowBack
    allowDemographics
    demographicTemplateId
    demographicTemplateName
    mustAnswerAll
    isReadOnly
    masterSurveyUnits
    responsesLayout
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SurveyGQL extends Apollo.Query<SurveyQuery, SurveyQueryVariables> {
    document = SurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SurveyCompetenciesDocument = gql`
    query surveyCompetencies($localeCodes: [String!]!, $organizationId: String!, $surveyId: String!) {
  surveyCompetencies(
    organizationId: $organizationId
    surveyId: $surveyId
    localeCodes: $localeCodes
  ) {
    _id
    createdAt
    updatedAt
    originalCompetencyId
    order
    name {
      localeCode
      text
    }
    definition {
      localeCode
      text
    }
    narratives {
      text {
        localeCode
        text
      }
      type
    }
    competenciesItems {
      _id
      createdAt
      updatedAt
      measure
      questionTitle {
        localeCode
        text
      }
      order
      responses {
        _id
        score
        text {
          localeCode
          text
        }
      }
      responsesLogic {
        _id
        responseId
        type
        data {
          _id
          questionTitle {
            text
            localeCode
          }
          questionDefinition {
            text
            localeCode
          }
          responses {
            _id
            text {
              text
              localeCode
            }
            score
          }
          createdAt
          updatedAt
        }
      }
      responseStatements {
        _id
        text {
          localeCode
          text
        }
        responseIds
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SurveyCompetenciesGQL extends Apollo.Query<SurveyCompetenciesQuery, SurveyCompetenciesQueryVariables> {
    document = SurveyCompetenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompetencyGroupDocument = gql`
    mutation deleteCompetencyGroup($organizationId: String!, $competencyGroupId: String!) {
  deleteCompetencyGroup(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompetencyGroupGQL extends Apollo.Mutation<DeleteCompetencyGroupMutation, DeleteCompetencyGroupMutationVariables> {
    document = DeleteCompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDemographicTemplateDocument = gql`
    mutation deleteDemographicTemplate($organizationId: String!, $demographicTemplateId: String!) {
  deleteDemographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDemographicTemplateGQL extends Apollo.Mutation<DeleteDemographicTemplateMutation, DeleteDemographicTemplateMutationVariables> {
    document = DeleteDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMasterProductDocument = gql`
    mutation deleteMasterProduct($masterProductId: String!) {
  deleteMasterProduct(masterProductId: $masterProductId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMasterProductGQL extends Apollo.Mutation<DeleteMasterProductMutation, DeleteMasterProductMutationVariables> {
    document = DeleteMasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductDocument = gql`
    mutation deleteProduct($productId: String!, $organizationId: String!) {
  deleteProduct(productId: $productId, organizationId: $organizationId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductGQL extends Apollo.Mutation<DeleteProductMutation, DeleteProductMutationVariables> {
    document = DeleteProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSurveyDocument = gql`
    mutation deleteSurvey($organizationId: String!, $surveyId: String!) {
  deleteSurvey(organizationId: $organizationId, surveyId: $surveyId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSurveyGQL extends Apollo.Mutation<DeleteSurveyMutation, DeleteSurveyMutationVariables> {
    document = DeleteSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreCompetencyGroupDocument = gql`
    mutation restoreCompetencyGroup($organizationId: String!, $competencyGroupId: String!) {
  restoreCompetencyGroup(
    organizationId: $organizationId
    competencyGroupId: $competencyGroupId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreCompetencyGroupGQL extends Apollo.Mutation<RestoreCompetencyGroupMutation, RestoreCompetencyGroupMutationVariables> {
    document = RestoreCompetencyGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreDemographicTemplateDocument = gql`
    mutation restoreDemographicTemplate($organizationId: String!, $demographicTemplateId: String!) {
  restoreDemographicTemplate(
    organizationId: $organizationId
    demographicTemplateId: $demographicTemplateId
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreDemographicTemplateGQL extends Apollo.Mutation<RestoreDemographicTemplateMutation, RestoreDemographicTemplateMutationVariables> {
    document = RestoreDemographicTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreMasterProductDocument = gql`
    mutation restoreMasterProduct($masterProductId: String!) {
  restoreMasterProduct(masterProductId: $masterProductId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreMasterProductGQL extends Apollo.Mutation<RestoreMasterProductMutation, RestoreMasterProductMutationVariables> {
    document = RestoreMasterProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreProductDocument = gql`
    mutation restoreProduct($productId: String!, $organizationId: String!) {
  restoreProduct(productId: $productId, organizationId: $organizationId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreProductGQL extends Apollo.Mutation<RestoreProductMutation, RestoreProductMutationVariables> {
    document = RestoreProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreSurveyDocument = gql`
    mutation restoreSurvey($organizationId: String!, $surveyId: String!) {
  restoreSurvey(organizationId: $organizationId, surveyId: $surveyId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreSurveyGQL extends Apollo.Mutation<RestoreSurveyMutation, RestoreSurveyMutationVariables> {
    document = RestoreSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashedCompetencyGroupsDocument = gql`
    query trashedCompetencyGroups($organizationId: String!, $page: Float!, $limit: Float!) {
  trashedCompetencyGroups(
    organizationId: $organizationId
    args: {page: $page, limit: $limit}
  ) {
    docs {
      _id
      name
      definition
      defaultLocaleCode
      localeCodes
      trashedAt
      competencies {
        _id
        name {
          localeCode
          text
        }
        definition {
          localeCode
          text
        }
        narratives {
          text {
            localeCode
            text
          }
          type
        }
        createdAt
        updatedAt
      }
      competenciesCount
      definition
      createdAt
      updatedAt
    }
    page
    limit
    hasNextPage
    hasPrevPage
    nextPage
    prevPage
    pagingCounter
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashedCompetencyGroupsGQL extends Apollo.Query<TrashedCompetencyGroupsQuery, TrashedCompetencyGroupsQueryVariables> {
    document = TrashedCompetencyGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashedDemographicTemplatesDocument = gql`
    query trashedDemographicTemplates($organizationId: String!, $page: Float!, $limit: Float!) {
  trashedDemographicTemplates(
    organizationId: $organizationId
    args: {page: $page, limit: $limit}
  ) {
    docs {
      _id
      name
      defaultLocaleCode
      localeCodes
      demographicsCount
      createdAt
      updatedAt
      trashedAt
    }
    page
    limit
    hasNextPage
    hasPrevPage
    nextPage
    prevPage
    pagingCounter
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashedDemographicTemplatesGQL extends Apollo.Query<TrashedDemographicTemplatesQuery, TrashedDemographicTemplatesQueryVariables> {
    document = TrashedDemographicTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashedMasterProductsDocument = gql`
    query trashedMasterProducts($limit: Float!, $page: Float!) {
  trashedMasterProducts(args: {page: $page, limit: $limit}) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      createdAt
      name
      image
      type
      description
      units
      assessments {
        _id
        assessmentId
        assessmentName
        adsAssessmentName
      }
      trashedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashedMasterProductsGQL extends Apollo.Query<TrashedMasterProductsQuery, TrashedMasterProductsQueryVariables> {
    document = TrashedMasterProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashedProductsDocument = gql`
    query trashedProducts($limit: Float!, $page: Float!, $organizationId: String!) {
  trashedProducts(
    args: {page: $page, limit: $limit}
    organizationId: $organizationId
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      createdAt
      name
      image
      type
      description
      units
      assessments {
        _id
        assessmentId
        assessmentName
        adsAssessmentName
      }
      trashedAt
      isSent
      masterProductId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashedProductsGQL extends Apollo.Query<TrashedProductsQuery, TrashedProductsQueryVariables> {
    document = TrashedProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrashedSurveysDocument = gql`
    query trashedSurveys($organizationId: String!, $limit: Float!, $page: Float!) {
  trashedSurveys(
    organizationId: $organizationId
    args: {page: $page, limit: $limit}
  ) {
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
    docs {
      _id
      consentRequired
      createdAt
      defaultLocaleCode
      localeCodes
      name
      type
      updatedAt
      horizontalImage
      primaryColor
      verticalImage
      trashedAt
      allowBack
      allowDemographics
      demographicTemplateId
      demographicTemplateName
      mustAnswerAll
      isReadOnly
      masterSurveyUnits
      responsesLayout
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrashedSurveysGQL extends Apollo.Query<TrashedSurveysQuery, TrashedSurveysQueryVariables> {
    document = TrashedSurveysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptJoinRequestDocument = gql`
    mutation acceptJoinRequest($organizationId: String!, $input: AcceptJoinRequestInput!) {
  acceptJoinRequest(organizationId: $organizationId, input: $input) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptJoinRequestGQL extends Apollo.Mutation<AcceptJoinRequestMutation, AcceptJoinRequestMutationVariables> {
    document = AcceptJoinRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMembersAndInvitationsDocument = gql`
    mutation deleteMembersAndInvitations($organizationId: String!, $input: DeleteMembersOrInvitationsInput!) {
  deleteMembersAndInvitations(organizationId: $organizationId, input: $input) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMembersAndInvitationsGQL extends Apollo.Mutation<DeleteMembersAndInvitationsMutation, DeleteMembersAndInvitationsMutationVariables> {
    document = DeleteMembersAndInvitationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUsersDocument = gql`
    mutation inviteUsers($organizationId: String!, $invitedUsers: [InviteUserInput!], $invitedUsersCsv: Upload) {
  inviteUsers(
    organizationId: $organizationId
    invitedUsers: $invitedUsers
    invitedUsersCsv: $invitedUsersCsv
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUsersGQL extends Apollo.Mutation<InviteUsersMutation, InviteUsersMutationVariables> {
    document = InviteUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInvitationDocument = gql`
    mutation resendInvitation($organizationId: String!, $userEmail: String!) {
  resendInvitation(organizationId: $organizationId, userEmail: $userEmail) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInvitationGQL extends Apollo.Mutation<ResendInvitationMutation, ResendInvitationMutationVariables> {
    document = ResendInvitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRolesDocument = gql`
    mutation updateRoles($organizationId: String!, $newRoleId: String!, $input: UpdateMembersOrInvitationsInput!) {
  updateRoles(
    organizationId: $organizationId
    newRoleId: $newRoleId
    input: $input
  ) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRolesGQL extends Apollo.Mutation<UpdateRolesMutation, UpdateRolesMutationVariables> {
    document = UpdateRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadInviteUsersCsvTemplateDocument = gql`
    query downloadInviteUsersCsvTemplate {
  downloadInviteUsersCsvTemplate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadInviteUsersCsvTemplateGQL extends Apollo.Query<DownloadInviteUsersCsvTemplateQuery, DownloadInviteUsersCsvTemplateQueryVariables> {
    document = DownloadInviteUsersCsvTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JoinRequestsDocument = gql`
    query joinRequests($organizationId: String!, $args: PaginationArgs!) {
  joinRequests(organizationId: $organizationId, args: $args) {
    docs {
      _id
      createdAt
      organizationId
      userEmail
      userId
      userImage
      userName
    }
    hasNextPage
    hasPrevPage
    limit
    nextPage
    page
    pagingCounter
    prevPage
    totalDocs
    totalPages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JoinRequestsGQL extends Apollo.Query<JoinRequestsQuery, JoinRequestsQueryVariables> {
    document = JoinRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LastThreeJoinRequestsDocument = gql`
    query lastThreeJoinRequests($organizationId: String!) {
  lastThreeJoinRequests(organizationId: $organizationId) {
    _id
    organizationId
    userEmail
    userId
    userName
    userImage
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LastThreeJoinRequestsGQL extends Apollo.Query<LastThreeJoinRequestsQuery, LastThreeJoinRequestsQueryVariables> {
    document = LastThreeJoinRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MembersAndInvitationsDocument = gql`
    query membersAndInvitations($organizationId: String!) {
  membersAndInvitations(organizationId: $organizationId) {
    invitations {
      _id
      email
      invitationCodeExpires
      roleId
      roleName
    }
    members {
      email
      firstName
      lastName
      roleId
      roleName
      userId
      image
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MembersAndInvitationsGQL extends Apollo.Query<MembersAndInvitationsQuery, MembersAndInvitationsQueryVariables> {
    document = MembersAndInvitationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesDocument = gql`
    query roles($organizationId: String!) {
  roles(organizationId: $organizationId) {
    _id
    createdAt
    name
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesGQL extends Apollo.Query<RolesQuery, RolesQueryVariables> {
    document = RolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }